export default {
  failed: 'Action failed',
  success: 'Action was successful',
  common: {
    menu: 'Menu',
    save: 'Save',
    cancel: 'Cancel',
    smsOptedOut: 'This number has opted out of SMS. They can reply START to resubscribe.',
    back: 'Back',
    backToSettings: 'Back to Settings',
    backToReports: 'Back to Reports',
    backToProducts: 'Back to Products',
    edit: 'Edit',
    delete: 'Delete',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    apply: 'Apply',
    yes: 'Yes',
    no: 'No',
    close: 'Close'
  },
  cardCapture: {
    loadingOptions: 'Checking available capture methods…',
    chooseMethod: 'How will the card be added?',
    methodTerminal: 'Terminal',
    methodKeyed: 'Keyed entry',
    methodKeyedSecure: 'All card details are entered securely.',
    terminalPanelHint: 'Use the physical terminal or integrated reader on this register.',
    terminalPanelWalletHint: 'A $1.00 authorization validates the card and is voided after save.',
    statusTokenizing: 'Securing card details…',
    statusSaving: 'Saving card on file…',
    statusTerminal: 'Complete the card read at the terminal…',
    statusIntegrated: 'Follow the prompts on the integrated reader…'
  },
  numpad: {
    open: 'Open numpad',
    digit: 'Digit {digit}',
    decimal: 'Decimal point',
    backspace: 'Delete',
    backspaceHint: 'Tap to delete. Hold to clear.',
    cursorLeft: 'Move cursor left',
    cursorRight: 'Move cursor right',
    done: 'Done',
    cancel: 'Cancel',
    overlayTitle: 'Enter amount'
  },
  tableColumns: {
    settingsTooltip: 'Table columns',
    settingsAria: 'Column visibility settings',
    visibleColumns: 'Visible columns'
  },
  auth: {
    login: 'Log in',
    logout: 'Log out',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot your password?',
    resetPassword: 'Reset password',
    setPassword: 'Set password',
    appIconAlt: 'Blu app icon'
  },
  profile: {
    title: 'Profile',
    subtitle: 'Update your details and account preferences',
    personalInfo: 'Personal Information',
    fullName: 'Full Name',
    emailAddress: 'Email Address',
    language: 'Language',
    useBusinessDefault: 'Use business default',
    emailRequired: 'Email is required',
    emailInvalid: 'Invalid email format',
    emailChangesAffectLogin: 'Email changes affect login',
    emailChangesMessage: 'Changing your email address will also update your login credentials. Use the new email next time you sign in.',
    phoneNumber: 'Phone Number',
    phonePlaceholder: '+1 555 555 1212',
    security: 'Security',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    currentPasswordRequired: 'Current password is required',
    newPasswordRequired: 'New password is required',
    changeAvatar: 'Change avatar',
    saveChanges: 'Save Changes',
    notifications: 'Notifications',
    notifyClientActivity: 'Notify me about client activity on estimates/invoices',
    ccReceiptsDefault: 'CC me on receipts by default',
    ccReceiptsDefaultDesc: 'Applies to emailed sales receipts and event registration emails.',
    notifyEventRegistrations: 'Email me when someone registers for an event',
    notifyEventRegistrationsDesc: 'Paid registrations include a receipt PDF.',
    dashboardDigests: 'Dashboard digests',
    dashboardDigestsDesc: 'Morning and end-of-day summaries for locations you can view in reports.',
    notifyMorningDigestEmail: 'Email me the morning dashboard summary',
    notifyMorningDigestEmailDesc: 'Yesterday’s results plus today’s revenue goal context.',
    notifyEodDigestEmail: 'Email me the end-of-day dashboard recap',
    notifyEodDigestEmailDesc: 'Today’s final pulse for each location you can access.',
    notifyMorningDigestPush: 'Push me the morning dashboard summary',
    notifyMorningDigestPushDesc: 'Native app only. Requires notification permission on this device.',
    pushUnavailableOnDevice: 'Push notifications are not available on this device (Dejavoo payment terminals and devices without Google Play Services). Use email digests instead.',
    notifyEodDigestPush: 'Push me the end-of-day dashboard recap',
    notifyEodDigestPushDesc: 'Native app only. Sent when the business day closes.',
    digestSendNowTitle: 'Send a digest now',
    digestSendNowDesc: 'Queues the same email and push jobs as the scheduled digest for every location.',
    digestSendMorningNow: 'Send morning digest now',
    digestSendEodNow: 'Send end-of-day digest now',
    digestSendChannelsRequired: 'Enable email or push for this digest before sending.',
    digestSendCooldownActive: 'Please wait before sending this digest again.',
    digestSendQueued: 'Digest queued for {count} location(s).',
    digestSendFailed: 'Could not queue the dashboard digest.',
    digestSendCooldownMinutes: 'Available again in {minutes}m {seconds}s',
    digestSendCooldownSeconds: 'Available again in {seconds}s',
    digestSendCooldownHours: 'Available again in {hours}h {minutes}m',
    developer: 'Developer',
    disableShadows: 'Disable all shadows (dev)',
    disableShadowsDesc: 'Disables all CSS box-shadows across the app (local device only).',
    localDevTools: 'Local dev tools',
    mockCardFlow: 'Mock card flow',
    mockCardFlowDesc: 'Step through card and split checkout without a payment gateway. Only available when running the Quasar dev server locally (not deployed dev or production). Requires a local API (APP_ENV=local).',
    updateProfilePicture: 'Update Profile Picture',
    chooseProfilePicture: 'Choose Profile Picture',
    selectProfilePicture: 'Please select a profile picture',
    uploadPicture: 'Upload Picture',
    loadFailed: 'Failed to load profile',
    updated: 'Profile updated successfully',
    pictureUpdated: 'Profile picture updated successfully',
    pictureFailed: 'Failed to update profile picture',
    passwordUpdated: 'Password updated successfully',
    passwordsNoMatch: 'Passwords do not match',
    english: 'English',
    spanish: 'Español',
    posPreferences: 'Point of sale',
    posPreferencesDesc: 'Options for the sales register and related POS screens.',
    touchNumpadMode: 'Touch numpad on number fields',
    touchNumpadModeHelp: 'Controls the on-screen numpad on web and Electron. Not available on the mobile app.',
    touchNumpadModeOff: 'Off',
    touchNumpadModeAvailable: 'Available (tap icon to open)',
    touchNumpadModeAlways: 'Always shown',
    touchNumpadFixedDecimal: 'Cash-register style numpad entry',
    touchNumpadFixedDecimalHelp: 'Digits fill from the right (6, 5, 2 becomes 6.52). The decimal key shifts two places (2, 5, . becomes 25.00).',
    registerCustomerGridEnabled: 'Customer grid on sales register',
    registerCustomerGridEnabledHelp: 'Replace inline customer search with a fullscreen grid you can scroll and tap to select a customer.',
    appearance: 'Appearance',
    appearanceDesc: 'Adjust button sizes and grid appearance for POS screens you use.',
    openUiSettings: 'UI settings',
    uiSettings: {
      title: 'UI settings',
      subtitle: 'Choose button sizes for the touch numpad, sales register actions, product grid, and cart item list.',
      numpadTitle: 'Touch numpad',
      numpadHelp: 'Applies to the on-screen numpad on web and Electron. Not shown in the mobile app.',
      saleActionsTitle: 'Sale action buttons',
      saleActionsHelp: 'Suspend, resume, and clear-sale icons next to the cart total on the sales register.',
      gridTitle: 'Product grid',
      gridHelp: 'Font size and label color for category and product buttons on the sales register grid.',
      gridFontSizeTitle: 'Grid font size',
      gridFontColorTitle: 'Grid font color',
      gridPreviewLabel: 'Preview label',
      gridPreviewDefaultLabel: 'House Special',
      gridFontColorModes: {
        automatic: 'Automatic',
        manual: 'Manual'
      },
      gridFontColors: {
        black: 'Black',
        white: 'White'
      },
      cartLineTitle: 'Cart item list',
      cartLineHelp: 'Font size, weight, and row background for items in the sales register cart.',
      cartLineFontSizeTitle: 'Cart font size',
      cartLineFontWeightTitle: 'Cart font weight',
      cartLineRowBackgroundColorTitle: 'Row background color',
      cartLineRowBackgroundOpacityTitle: 'Row background opacity',
      cartLineRowPatternTitle: 'Row pattern',
      cartLineFontWeights: {
        regular: 'Regular',
        medium: 'Medium',
        semibold: 'Semibold'
      },
      cartLineRowBackgroundColors: {
        none: 'None',
        neutral: 'Neutral',
        primary: 'Primary',
        secondary: 'Secondary'
      },
      cartLineRowBackgroundOpacities: {
        percent: '{value}%'
      },
      cartLineRowPatterns: {
        flat: 'Flat',
        striped: 'Striped'
      },
      cartLinePreviewItemName: 'House Burger',
      cartLinePreviewDiscountName: 'Side Salad',
      cartLinePreviewUnitPrice: '${price} each',
      cartLinePreviewModifiers: 'No onion (+$0.00), Extra cheese (+$1.50)',
      resetCartLineFontWeight: 'Reset font weight',
      resetCartLineRowBackgroundColor: 'Reset row color',
      resetCartLineRowBackgroundOpacity: 'Reset opacity',
      resetCartLineRowPattern: 'Reset row pattern',
      preview: 'Preview',
      resetToDefault: 'Reset to {size}',
      sizes: {
        xs: 'XS',
        sm: 'SM',
        md: 'MD',
        lg: 'LG',
        xl: 'XL'
      }
    }
  },
  business: {
    title: 'Business Info',
    subtitle: 'Branding, address, and preferences',
    businessName: 'Business Name',
    defaultLanguage: 'Default language',
    defaultTimezone: 'Default timezone',
    defaultTimezoneHint: 'Search by city or region. Used for scheduling and reporting when a location has no override.',
    digestCushion: {
      title: 'Dashboard digest timing',
      hint: 'Per-location digests send before open and after close using these cushions when operating hours are set.',
      morning: 'Minutes before open',
      morningHint: 'Morning digest lead time (default 30).',
      eod: 'Minutes after close',
      eodHint: 'End-of-day digest delay (default 120).'
    },
    dailyRevenueGoal: 'Daily revenue goal',
    dailyRevenueGoalHint: 'Each location aims for this daily revenue target. Leave blank to hide goal tracking on the dashboard.',
    yourBusiness: 'Your Business',
    businessDetails: 'Business Details',
    accountNumber: 'Account number',
    accountNumberCopied: 'Account number copied to clipboard.',
    accountNumberCopyFailed: 'Unable to copy. Please copy manually.',
    accountNumberSecureContextWarning: 'Clipboard access requires a secure context (HTTPS).',
    brandColors: 'Brand Colors',
    primaryColor: 'Primary color',
    accentColor: 'Accent color',
    address: 'Address',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    city: 'City',
    state: 'State',
    postalCode: 'Postal Code',
    country: 'Country',
    contactInformation: 'Contact Information',
    estimates: 'Estimates',
    requireEstimateApproval: 'Request approval by default when emailing estimates',
    requireEstimateSignature: 'Require customer signature when approving estimates',
    posGrid: 'POS Grid',
    preferProductImages: 'Prefer product images in POS grid when available',
    tabsSection: 'Customer tabs',
    enableCustomerTabs: 'Enable customer tabs',
    enableCustomerTabsHint:
      'Allows opening tabs, charging sales to tabs, and tab payments in POS.',
    barTabOpeningPreauth: 'Bar tab opening card hold',
    barTabOpeningPreauthHint: 'Optional amount held when verifying a card (0 saves the card with no hold).',
    barTabSameCalendarDayOnly: 'Bar tabs same calendar day only',
    barTabSameCalendarDayOnlyHint:
      'When enabled, bar tabs can only receive new charges on the calendar day they were opened.',
    barTabRequireCardOnFile: 'Require card for bar tabs',
    barTabRequireCardOnFileHint:
      'When enabled, staff must verify a card before posting charges to a bar tab. When off, card setup stays available but can be skipped.',
    orderAheadSection: 'Order ahead (pickup queue)',
    enableOrderAheadQueue: 'Enable pickup queue for staff',
    enableOrderAheadQueueHint:
      'Shows the pickup queue in POS, dashboard, and kitchen display. Pair with Order ahead settings for your public menu. Turn off when you are not taking advance orders.',
    rentalsSection: 'Rentals',
    enableRentals: 'Enable rentals module',
    enableRentalsHint:
      'Shows rentals in navigation and tools for storage units, agreements, and billing. Off by default.',
    bookingSection: 'Booking',
    enableBookingModule: 'Enable booking module',
    enableBookingModuleHint:
      'Shows booking in navigation, staff scheduling tools, and online booking for your website. Off by default.',
    invoicesSection: 'Invoices / Accounts receivable',
    enableInvoicesModule: 'Enable invoices module',
    enableInvoicesModuleHint:
      'Shows invoices navigation, estimate and invoice workflows, payment terms, and AR reports. Turn off for retail-only tenants. Disabling also turns off projects.',
    projectsSection: 'Projects / Jobs',
    enableProjectsModule: 'Enable projects module',
    enableProjectsModuleHint:
      'Track contractor job profitability with project-scoped invoices and receipt expenses. Requires invoices.',
    eventsSection: 'Events',
    enableEventsModule: 'Enable events module',
    enableEventsModuleHint:
      'Shows events in navigation, staff event management, and public registration portals. Off by default.',
    leadsSection: 'Leads',
    enableLeadsModule: 'Enable leads module',
    enableLeadsModuleHint:
      'Shows leads in navigation, intake form settings, and a contact form for your website. Off by default.',
    suspendedSalesSection: 'Suspended sales',
    suspendedSalesLocationWideResume: 'Allow any register at this location to resume suspended sales',
    suspendedSalesLocationWideResumeHint:
      'When off, only the register that suspended a sale can list or resume it. When on, any register at the same location can resume.',
    suspendedSalesPromptForNote: 'Prompt for a note when suspending a sale',
    suspendedSalesPromptForNoteHint:
      'When on, cashiers see an optional note field before a sale is put on hold. Notes can always be added or edited from the suspended sales list.',
    paymentsSection: 'Payments',
    enableCashPennyRounding: 'Cash penny rounding',
    enableCashPennyRoundingHint:
      'When enabled, cash payments round the final total to the nearest nickel after tax and discounts. Card and electronic payments stay exact.',
    receiptsSection: 'Receipts',
    showCashierOnReceipt: 'Show cashier on receipt',
    showCashierOnReceiptHint:
      'When enabled, thermal sale receipts include the cashier name. PDF and email receipts are unchanged.',
    saveChanges: 'Save Changes',
    updateLogo: 'Update Business Logo',
    chooseLogo: 'Choose Logo',
    selectLogo: 'Please select a logo',
    uploadLogo: 'Upload Logo',
    changeLogo: 'Change logo',
    logoSelectRequired: 'Please select a logo file',
    logoUpdated: 'Logo updated successfully',
    logoFailed: 'Failed to update logo',
    infoUpdated: 'Business information updated successfully',
    infoFailed: 'Failed to update business information',
    emailInvalid: 'Invalid email format',
    english: 'English',
    spanish: 'Español'
  },
  login: {
    welcomeBack: 'Welcome Back',
    signInToAccount: 'Sign in to your account',
    accountSubdomain: 'Account subdomain',
    subdomainRequired: 'Subdomain is required',
    subdomainOptionalDev: 'Leave blank to use your local API (development only).',
    subdomainInvalid: 'Use only letters, numbers, and hyphens',
    emailAddress: 'Email Address',
    emailRequired: 'Email is required',
    password: 'Password',
    passwordRequired: 'Password is required',
    forgotPassword: 'Forgot Password?',
    signInFailed: 'Sign-in failed',
    signIn: 'Sign In',
    invalidSubdomain: 'Please enter a valid account subdomain',
    invalidCredentials: 'Invalid email or password',
    csrfFailed: 'Sign-in security check failed. Close and reopen the app, then try again.',
    csrfDesktopFailed: 'Desktop app could not prepare a secure sign-in token. Restart the app or clear cookies for this account and try again.',
    signUpPrompt: 'New to Blu? ',
    signUpLink: 'Sign up on our website',
    kdsSetup: 'Kitchen display setup'
  },
  staffPassword: {
    required: 'Password is required',
    minLength: 'Password must be at least 8 characters',
    uppercase: 'Password must contain at least one uppercase letter',
    lowercase: 'Password must contain at least one lowercase letter',
    number: 'Password must contain at least one number'
  },
  forgotPassword: {
    title: 'Forgot Password',
    subtitle: 'Enter your email to reset your password',
    emailRequired: 'Email is required',
    emailInvalid: 'Please enter a valid email',
    sendFailed: "Couldn't send reset link",
    checkEmail: 'Check your email',
    successMessage: 'Password reset instructions have been sent to your email',
    sendResetLink: 'Send Reset Link',
    backToLogin: 'Back to Login',
    failedGeneric: 'Failed to send reset instructions. Please try again.'
  },
  resetPassword: {
    tokenMissing: 'Reset token is missing',
    emailMissing: 'Reset link is invalid or incomplete. Request a new reset email.',
    title: 'Reset Your Password',
    subtitle: 'Please enter your new password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordRequired: 'Password is required',
    passwordMinLength: 'Password must be at least 8 characters',
    passwordUppercase: 'Password must contain at least one uppercase letter',
    passwordLowercase: 'Password must contain at least one lowercase letter',
    passwordNumber: 'Password must contain at least one number',
    confirmRequired: 'Please confirm your password',
    passwordsNoMatch: 'Passwords do not match',
    resetFailed: "Couldn't reset password",
    resetButton: 'Reset Password',
    successNotify: 'Password has been reset successfully',
    failedGeneric: 'Failed to reset password. Please try again.'
  },
  setPassword: {
    title: 'Set Your Password',
    subtitle: 'Please set a new password for your account',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordRequired: 'Password is required',
    passwordMinLength: 'Password must be at least 8 characters',
    passwordUppercase: 'Password must contain at least one uppercase letter',
    passwordLowercase: 'Password must contain at least one lowercase letter',
    passwordNumber: 'Password must contain at least one number',
    confirmRequired: 'Please confirm your password',
    passwordsNoMatch: 'Passwords do not match',
    setFailed: "Couldn't set password",
    setButton: 'Set Password',
    failedGeneric: 'Failed to set password. Please try again.'
  },
  layout: {
    offline: "You're offline",
    offlineMessage: "This device doesn't have an internet connection. Blu is showing cached data; some actions are disabled until you're back online.",
    offlineNetwork: 'Network: {type}',
    terminalReady: 'Terminal Ready',
    terminalIssue: 'Terminal Issue',
    terminalLoading: 'Loading...',
    terminalNoStatus: 'No Terminal Status',
    terminalNoRegister: 'No Register',
    terminalNoTerminal: 'No Terminal',
    terminalRefreshTitle: 'Click to refresh terminal connection status',
    registerManageTitle: 'Click to manage register',
    sessionInfo: 'Session Information',
    sessionId: 'Session ID',
    user: 'User',
    name: 'Name',
    email: 'Email',
    id: 'Id',
    authentication: 'Authentication',
    status: 'Status',
    authenticated: 'Authenticated',
    notAuthenticated: 'Not Authenticated',
    token: 'Token',
    present: 'Present',
    none: 'None',
    currentLocation: 'Current Location',
    currentRegister: 'Current Register',
    address: 'Address',
    open: 'Open',
    closed: 'Closed',
    loading: 'Loading',
    yes: 'Yes',
    no: 'No',
    registerCount: 'Register Count',
    openRegisters: 'Open Registers',
    cookies: 'Cookies',
    totalCookies: 'Total Cookies',
    cookieData: 'Cookie Data',
    noCookiesFound: 'No cookies found',
    serverResponse: 'Server Response',
    origin: 'Origin',
    cookiesReceived: 'Cookies Received',
    lastUpdated: 'Last Updated',
    refreshSession: 'Refresh Session',
    refreshRegisters: 'Refresh Registers',
    close: 'Close',
    runtimeEnvironment: 'Runtime Environment',
    runtimeEnvironmentHint: 'Build-time values from .env / quasar.config.js. Restart quasar dev after changing .env.',
    dejavooTopNativeDiagnostics: 'Tap to Pay on iPhone (native)',
    dejavooTopNativeDiagnosticsHint: 'Resolved Info.plist Environment for IposgoSDK (UAT vs PROD). Compare with API environment on the wizard / Dejavoo PoC.',
    clickViewSession: 'Click to view session details',
    refreshSessionInfo: 'Refresh session info',
    orderAheadPickup: 'Pickup queue',
    storeOrderPickup: 'Store pickup orders',
    orderAheadOpenFull: 'Full screen',
    desktopUpdate: {
      updateNow: 'Update now',
      restartToUpdate: 'Restart to update',
      downloading: 'Downloading update ({percent}%)',
      checking: 'Checking for updates…',
      versionAvailable: 'Version {version} is available',
      latest: 'You are using the latest desktop version.',
      notPackaged: 'Updates are available only in the installed desktop app.',
      checkFailed: 'Could not check for updates: {msg}',
      checkTimedOut: 'The update check timed out. Please try again.',
      downloadFailed: 'Update download failed: {msg}',
      installFailed: 'Could not install update: {msg}',
      error: 'Update error: {msg}'
    },
    userMenu: 'Account',
    support: 'Support',
    roles: {
      owner: 'Owner',
      manager: 'Manager',
      cashier: 'Cashier',
      inventory_clerk: 'Inventory Clerk',
      accountant: 'Accountant'
    }
  },
  settings: {
    title: 'Settings',
    subtitle: 'Manage business configuration, equipment, loyalty, and account preferences',
    version: 'Blu version {version}',
    deviceIdentityLabel: 'This device',
    runtimeEnv: {
      development: 'Development',
      staging: 'Staging',
      production: 'Production'
    },
    checkForUpdates: 'Check for updates',
    open: 'Open',
    businessInfo: 'Business Info',
    businessInfoDesc: 'Branding, address, and preferences',
    locations: 'Locations',
    locationsDesc: 'Manage store locations and defaults',
    taxes: 'Taxes',
    taxesDesc: 'Manage location tax rules and preview tax outcomes',
    integrations: 'Integrations',
    integrationsDesc: 'Connect loyalty, payments, and third‑party apps',
    paymentProcessing: 'Payment Processing',
    paymentProcessingDesc: 'Manage payment processor settings',
    iphoneTopTapToPay: 'Tap to Pay on iPhone',
    iphoneTopTapToPayDesc: 'One-time setup to accept contactless payments on this iPhone',
    equipment: 'Equipment',
    equipmentDesc: 'Manage payment terminals and hardware',
    equipmentCustomerDisplay: 'Customer-facing display',
    equipmentCustomerDisplayDesc: 'Mirror the cart on a second screen (Android tablet or Windows desktop)',
    equipmentReceiptPrinter: 'Receipt printer',
    equipmentReceiptPrinterDesc: 'Volcora USB thermal printer and cash drawer (Windows desktop app)',
    receiptPrinterPageTitle: 'Receipt printer',
    receiptPrinterPageSubtitle: 'Volcora thermal receipt and cash drawer (SDK or Windows ESC/POS)',
    receiptPrinterWindowsOnly: 'Receipt printer integration is available in the Windows desktop app only.',
    receiptPrinterDllMissing: 'POS_SDK.dll was not found. Copy it from the Volcora SDK into the app resources folder (see src-electron/resources/volcora/README.txt) and rebuild.',
    receiptPrinterConfigHeading: 'Configuration',
    receiptPrinterEnableVolcora: 'Print receipts with Volcora thermal printer',
    receiptPrinterEnableHint:
      'When off, the register uses normal system printing (browser print dialog). When on, completed sales can print via the configured thermal printer in the Windows desktop app.',
    receiptPrinterDriverMode: 'Driver / transport',
    receiptPrinterDriverSdk: 'Volcora SDK (50020X USB)',
    receiptPrinterDriverEscpos: 'Windows ESC/POS (V-WRP-A1 / V-WLRP-A1)',
    receiptPrinterWindowsName: 'Windows printer',
    receiptPrinterWindowsNameManual: 'Printer name (manual)',
    receiptPrinterWindowsNameHint: 'Exact queue name from Windows Settings → Printers & scanners',
    receiptPrinterWindowsDefault: 'default',
    receiptPrinterUsbName: 'USB port name',
    receiptPrinterUsbNameHint:
      "Volcora's VC sample uses SP-USB1 for USB. Also try SP-USB001 or the value from Volcora's test tool / driver.",
    receiptPrinterPaperWidth: 'Paper width',
    receiptPrinterPaper80: '80 mm',
    receiptPrinterPaper58: '58 mm',
    receiptPrinterCutType: 'Cut type',
    receiptPrinterCutPartial: 'Partial cut',
    receiptPrinterCutFull: 'Full cut',
    receiptPrinterFeedLines: 'Feed lines before cut',
    receiptPrinterDrawerHeading: 'Cash drawer',
    receiptPrinterDrawerEnable: 'Enable cash drawer (RJ11 via printer)',
    receiptPrinterDrawerAutoCash: 'Auto-open on cash sales',
    receiptPrinterDrawerConnector: 'Drawer connector',
    receiptPrinterDrawerPin1: 'Drawer 1',
    receiptPrinterDrawerPin2: 'Drawer 2',
    receiptPrinterDrawerBoth: 'Both drawers',
    receiptPrinterDrawerTime1: 'Open pulse (×2 ms, 0–255)',
    receiptPrinterDrawerTime2: 'Close pulse (×2 ms, 0–255)',
    receiptPrinterActionsHeading: 'Actions',
    receiptPrinterSave: 'Save settings',
    receiptPrinterSaved: 'Receipt printer settings saved',
    receiptPrinterSaveFailed: 'Could not save settings',
    receiptPrinterStorageUnavailable: 'Local storage is not available in this environment.',
    receiptPrinterTestSdk: 'Print SDK test page',
    receiptPrinterTestThermal: 'Print test receipt',
    receiptPrinterOpenDrawer: 'Open cash drawer',
    receiptPrinterCheckPaper: 'Check paper status',
    receiptPrinterTestOk: 'Printer command completed',
    receiptPrinterTestFailed: 'Printer command failed',
    receiptPrinterDrawerOk: 'Drawer command sent',
    receiptPrinterDrawerFailed: 'Drawer command failed',
    receiptPrinterPaperOk: 'Paper status: OK (paper present)',
    receiptPrinterPaperLow: 'Paper status: running low (near end)',
    receiptPrinterPaperOut: 'Paper status: out or low',
    receiptPrinterPaperStatusCode: 'Paper status: printer reported code {code}',
    receiptPrinterPaperUnknown: 'Could not read paper status',
    receiptPrinterBidirectionalFailed:
      'Paper status read failed (bidirectional I/O). Try Diagnostics or enable bidirectional support in the printer port settings.',
    receiptPrinterDiagOpen: 'Diagnostics',
    receiptPrinterDiagTitle: 'Printer diagnostics',
    receiptPrinterDiagConnection: 'Connection',
    receiptPrinterDiagRefreshPrinters: 'Refresh printer list',
    receiptPrinterDiagCopyLog: 'Copy log',
    receiptPrinterDiagCopied: 'Diagnostic log copied',
    receiptPrinterDiagCopyFailed: 'Could not copy log',
    receiptPrinterDiagPrintTests: 'Print tests',
    receiptPrinterDiagDrawerTests: 'Drawer tests',
    receiptPrinterDiagStatusTests: 'Status tests',
    receiptPrinterDiagLog: 'Diagnostic log',
    receiptPrinterDiagLogEmpty: 'Run a test to populate the log.',
    receiptPrinterDiagAlign: 'Alignment sample',
    receiptPrinterDiagFonts: 'Font styles sample',
    receiptPrinterDiagLogo: 'Logo BMP sample',
    receiptPrinterDiagQr: 'QR code sample',
    receiptPrinterDiagCutPartial: 'Cut test (partial)',
    receiptPrinterDiagCutFull: 'Cut test (full/partial alt)',
    receiptPrinterDiagFeed: 'Feed only',
    receiptPrinterDiagStatusPaper: 'DLE EOT paper (n=4)',
    receiptPrinterDiagStatusOffline: 'DLE EOT offline (n=2)',
    receiptPrinterDiagStatusPrinter: 'DLE EOT printer (n=1)',
    receiptPrinterDiagStatusError: 'DLE EOT error (n=3)',
    receiptPrinterDiagStatusSdk: 'SDK paper status',
    receiptPrinterDocsNote:
      'SDK mode requires POS_SDK.dll (50020X). ESC/POS mode uses the installed Windows printer driver and does not need the DLL.',
    receiptPrinterLblPhone: 'Phone',
    receiptPrinterLblTaxId: 'Tax ID',
    receiptPrinterLblDate: 'Date',
    receiptPrinterLblSale: 'Sale',
    receiptPrinterLblCashier: 'Cashier',
    receiptPrinterLblCustomer: 'Customer',
    receiptPrinterLblUnknownProduct: 'Item',
    receiptPrinterLblLineTotal: 'Line',
    receiptPrinterLblSubtotal: 'Subtotal',
    receiptPrinterLblDiscount: 'Discount',
    receiptPrinterLblAfterDiscount: 'After discount',
    receiptPrinterLblTax: 'Tax',
    receiptPrinterLblTip: 'Tip',
    receiptPrinterLblFee: 'Fee',
    receiptPrinterLblTotal: 'TOTAL',
    receiptPrinterLblPayments: 'Payments',
    receiptPrinterLblReceived: 'Received',
    receiptPrinterLblChange: 'Change',
    receiptPrinterLblPaymentApproved: 'APPROVED',
    receiptPrinterLblPaymentDeclined: 'DECLINED',
    receiptPrinterLblAuthShort: 'Auth',
    receiptPrinterLblRefShort: 'Ref',
    receiptPrinterLblEntryModeChip: 'Chip',
    receiptPrinterLblEntryModeContactless: 'Contactless',
    receiptPrinterLblEntryModeSwipe: 'Swipe',
    receiptPrinterLblEntryModeManual: 'Manual',
    receiptPrinterLblEntryModeKeyed: 'Keyed',
    receiptPrinterLblEntryModeUnknown: 'Card',
    receiptPrinterLblThankYou: 'Thank you!',
    receiptPrinterLblTestBanner: 'Blu POS - printer test',
    receiptPrinterLblTestFooter: 'End of test',
    receiptPrinterLblPortOk: 'Port OK',
    customerDisplayPageTitle: 'Customer-facing display',
    customerDisplayPageSubtitle: 'For Android POS tablets or Windows desktop with a customer-facing monitor',
    customerDisplayHardwareType: 'Hardware type',
    customerDisplayHardwareGeneric: 'Generic Android (HDMI / USB‑C / extended display)',
    customerDisplayHardwareSunmi: 'Sunmi (secondary display / Presentation API)',
    customerDisplayHardwareHint:
      'Sunmi dual-screen devices often need Presentation mode so the customer screen can show its own content instead of mirroring the cashier UI.',
    customerDisplayHardwareWindows: 'Windows - extended desktop (second monitor)',
    customerDisplayHardwareHintWindows:
      'Blu opens a dedicated window on your secondary monitor. Extend the desktop in Windows display settings (Win + P) so the customer screen is detected.',
    customerDisplayEnable: 'Enable customer-facing display',
    customerDisplayEnableHint:
      'When enabled and a second display is connected, the register mirrors the cart and totals for customers. Works on the Android app or the Windows desktop app.',
    customerDisplayStatusHeading: 'Display status',
    customerDisplayStatusEnabled: 'Feature enabled in app',
    customerDisplayStatusDisabled: 'Feature disabled',
    customerDisplayStatusSecondary: 'Secondary displays detected: {count}',
    customerDisplayStatusPresentation: 'Presentation displays: {count}',
    customerDisplayStatusTouch: 'Customer screen reports touch: {value}',
    customerDisplayStatusWindow: 'Customer display window open: {value}',
    customerDisplayStatusUnavailable:
      'Use the Android or Windows desktop app to connect a customer-facing display. This browser session cannot drive the second screen.',
    customerDisplayPlatformNote:
      'Connect the customer display before opening the register. Turn this off in Equipment when the screen is not in use.',
    customerDisplayMirrorIdle: 'Your items will appear here.',
    customerDisplayMirrorThankYou: 'Thank you!',
    customerDisplayMirrorReceiptEmail: 'Email receipt',
    customerDisplayMirrorReceiptSms: 'Text receipt',
    customerDisplayMirrorReceiptPrint: 'Print receipt',
    customerDisplayMirrorReceiptNone: 'No receipt',
    customerDisplayMirrorReceiptPrompt: 'How would you like your receipt?',
    customerDisplayMirrorProcessing: 'Sending…',
    customerDisplayMirrorError: 'Could not complete that request.',
    customerDisplayMirrorTryAgain: 'Try again',
    customerDisplayMirrorQtyEach: '{qty} × {price}',
    loyalty: 'Loyalty',
    loyaltyDesc: 'Configure earn rates and redemption model',
    intakeForm: 'Intake Form',
    intakeFormDesc: 'Website contact form and lead inbox',
    intakeFormPreview: 'Preview',
    intakeFormBack: 'Back to Settings',
    intakeFormEnable: 'Enable intake form',
    intakeFormShowProducts: 'Show product selection on form',
    intakeFormShowProductsHint: 'When enabled, customers can select a product or service on the intake form',
    intakeFormScopeAll: 'All products',
    intakeFormScopeSpecific: 'Specific products',
    intakeFormAllProductsHint: 'All products will be available for selection.',
    intakeFormProductsLabel: 'Products to show',
    intakeFormProductsHint: 'Search and select products to offer on the form',
    intakeFormTitle: 'Form title (optional)',
    intakeFormTitleHint: 'Custom title displayed above the form',
    intakeFormSuccessMessage: 'Success message (optional)',
    intakeFormSuccessMessageHint: 'Message shown after successful submission',
    intakeFormAddressCollection: 'Address collection',
    intakeFormAddressCollectionHint: 'Whether to collect address from visitors',
    intakeFormAddressNone: 'Do not collect',
    intakeFormAddressOptional: 'Optional',
    intakeFormAddressRequired: 'Required',
    intakeFormEmbedTitle: 'Website code',
    intakeFormCopyEmbed: 'Copy',
    intakeFormSaved: 'Settings saved',
    intakeFormSaveFailed: 'Failed to save settings',
    intakeFormLoadFailed: 'Failed to load settings',
    intakeFormEmbedCopied: 'Website code copied',
    intakeFormEmbedCopyFailed: 'Failed to copy',
    onlineStore: 'Order ahead',
    onlineStoreDesc: 'Public menu and checkout for pickup (cafés, food trucks, quick service)',
    ecomEnable: 'Enable order ahead menu',
    ecomEnableHint:
      'Turn on your customer-facing menu and checkout. Also enable Order ahead queue under Business Info so staff see the pickup queue. Customer account sign-in for invoices and tabs is unchanged.',
    ecomStoreTitle: 'Menu title',
    ecomTagline: 'Tagline',
    ecomCheckoutNotice: 'Checkout message (shown before pickup time)',
    ecomPreviewShop: 'Preview menu',
    ecomSaved: 'Order ahead settings saved',
    ecomSaveFailed: 'Failed to save order ahead settings',
    retailStore: 'Blu Store',
    retailStoreDesc: 'Online boutique for retail products — catalog, cart, and ship or pickup checkout',
    storeEnable: 'Enable Blu Store',
    storeThemePreset: 'Theme preset',
    storePreview: 'Preview store',
    storeSaved: 'Blu Store settings saved',
    storeSaveFailed: 'Failed to save Blu Store settings',
    storePublicUrlHint: 'When enabled and published, shoppers reach your store from your business website address.',
    storeHomepageSections: 'Homepage sections',
    storeHomepageSectionsHint: 'Sections appear in order on the store home page (when shoppers are not searching).',
    storeSectionAdd: 'Add section',
    storeSectionHero: 'Hero',
    storeSectionFeatured: 'Featured products',
    storeSectionProductCarousel: 'Product carousel',
    storeSectionFeaturedCollections: 'Featured collections',
    storeSectionImageText: 'Image + text',
    storeSectionRichText: 'Rich text',
    storeSectionFaqAccordion: 'FAQ accordion',
    storeSectionImageRow: 'Image row',
    storeSectionProductDetails: 'Product details',
    storeThemeClassic: 'Classic',
    storeThemeBayou: 'Bayou (warm, rounded)',
    storeThemeStudio: 'Studio (minimal, sharp)',
    storeSectionCollectionSlugs: 'Collections',
    storeSectionImageTextBody: 'Body (HTML)',
    storeSectionImageSide: 'Image side',
    storeSectionHeroTitle: 'Headline',
    storeSectionHeroSubtitle: 'Subheadline',
    storeSectionBlockTitle: 'Section title',
    storeSectionFeaturedProducts: 'Products',
    storeSectionRichTextBody: 'Body (HTML)',
    storeSectionRichTextBodyHint: 'Basic HTML: p, strong, em, lists, links',
    storeSectionFaqQuestion: 'Question',
    storeSectionFaqAnswer: 'Answer (HTML)',
    storeSectionFaqAddItem: 'Add question',
    storeSectionFaqRemoveItem: 'Remove',
    storeSectionImageUrl: 'Image URL',
    storeSectionImageAlt: 'Alt text',
    storeSectionImageLink: 'Link (optional)',
    storeSectionAddImage: 'Add image',
    storeSeo: 'Store SEO',
    storeSeoTitle: 'Homepage title',
    storeSeoDescription: 'Homepage description',
    storeCheckoutShipping: 'Checkout shipping (pilot)',
    storeCheckoutShippingHint: 'Optional flat-rate shipping at Blu Store checkout. Live carrier rates are not supported yet.',
    storeCheckoutShippingEnabled: 'Offer ship-to-customer at checkout',
    storeCheckoutFlatRate: 'Flat shipping rate ($)',
    storeCheckoutFreeShippingThreshold: 'Free shipping threshold ($, optional)',
    storeIndexableFacetAxes: 'Indexable catalog filters (SEO)',
    storeIndexableFacetAxesHint:
      'Single-filter shop URLs for these options may be indexed by search engines. Other filter combinations stay shareable but use noindex.',
    storeIndexableFacetAxisSize: 'Size',
    storeIndexableFacetAxisColor: 'Color',
    storeIndexableFacetAxisCategory: 'Category',
    storeIndexableFacetAxisBrand: 'Brand',
    storeMerchandisedCollections: 'Manual collections',
    storeMerchandisedCollectionsHint:
      'Curated product lists for your store (e.g. Staff Picks). Each collection has its own link you can share. If a collection slug matches a category name, the collection takes priority.',
    storeMerchandisedCollectionTitle: 'Display title',
    storeMerchandisedCollectionSlug: 'URL slug',
    storeMerchandisedCollectionSlugHint: 'Lowercase letters, numbers, and hyphens (e.g. staff-picks).',
    storeMerchandisedCollectionImage: 'Cover image URL (optional)',
    storeMerchandisedCollectionProducts: 'Products',
    storeMerchandisedCollectionAdd: 'Add collection',
    storeMerchandisedCollectionRemove: 'Remove',
    storeMerchandisedCollectionUntitled: 'Collection {n}',
    storeMerchandisedCollectionMax: 'Maximum {max} collections.',
    storeMerchandisedCollectionIncomplete:
      'Each manual collection needs a title, slug, and at least one store-visible product.',
    storePolicyPages: 'Policy pages',
    storePolicyPagesHint:
      'Shipping, returns, privacy, and terms pages for your store. Publish from the visual editor when you are ready for shoppers to see them.',
    storePolicyPageTitle: 'Page title',
    storePolicyPageBody: 'Body (HTML)',
    storePolicyPageBodyHint: 'Basic HTML only (paragraphs, lists, links, headings). No scripts.',
    storePolicyPageSlug: {
      shipping: 'Shipping policy',
      returns: 'Returns policy',
      privacy: 'Privacy policy',
      terms: 'Terms of service',
    },
    storeUrlRedirects: 'URL redirects',
    storeUrlRedirectsHint: 'Map legacy paths (e.g. Shopify /products/handle) to Blu Store URLs.',
    storeRedirectFrom: 'From path',
    storeRedirectTo: 'To path',
    storeRedirectStatus: 'Status',
    storeRedirectAdd: 'Add redirect',
    storeBulkImportHint: 'Need to migrate a large catalog from Shopify or another platform? Contact Blu support for assisted import.',
    paymentTerms: 'Payment Terms',
    paymentTermsDesc: 'Manage invoice payment terms and defaults',
    tabs: 'Tabs',
    tabsDesc: 'Configure house and bar tab features',
    tabsHousePanelTitle: 'House tabs',
    tabsHousePanelDesc: 'Customer and group AR tabs, register house mode, and the Tabs navigation item.',
    tabsHouseEnable: 'Enable house tabs',
    tabsBarPanelTitle: 'Bar tabs',
    tabsBarPanelDesc: 'Walk-in and customer bar tabs on the register, including card verification settings.',
    tabsBarEnable: 'Enable bar tabs',
    tabsSaved: 'Tab settings saved',
    tabsSaveFailed: 'Failed to save tab settings',
    invoices: 'Invoices',
    invoicesDesc: 'Estimate defaults and invoice payment terms',
    booking: 'Booking',
    bookingDesc: 'Online booking, deposits, website widget, and register handoff',
    rentals: 'Rentals',
    rentalsDesc: 'Rental policies, buildings, units, and billing defaults',
    scheduling: 'Scheduling',
    schedulingDesc: 'Earlier scheduling tools (use Booking when available)',
    invoicesEstimatesPanelTitle: 'Estimates',
    invoicesEstimatesPanelDesc: 'Default behavior when creating new estimates.',
    invoicesPortalPanelTitle: 'Payment portal',
    invoicesPortalPanelDesc: 'Options for customer-facing invoice payment links.',
    invoicePortalTippingEnabled: 'Allow tips on invoice payment links',
    customerAcceptanceGate: 'Customer acceptance required',
    customerAcceptanceGateHint: 'Choose when customers must approve or sign before you issue or collect payment.',
    customerAcceptanceGateNone: 'None',
    customerAcceptanceGateEstimate: 'On estimate (before issuing invoice)',
    customerAcceptanceGateInvoice: 'On invoice (before payment)',
    requireCustomerSignature: 'Require customer signature when acceptance is enabled',
    estimateDefaultValidityDays: 'Default estimate validity (days)',
    estimateDefaultValidityDaysHint: 'Leave blank for no automatic expiry.',
    invoiceRemindersPanelTitle: 'Payment reminders',
    invoiceRemindersPanelDesc: 'Automated email reminders for unpaid invoices.',
    invoiceRemindersEnabled: 'Send automated reminders',
    invoiceRemindersEmail: 'Email',
    invoiceRemindersIntervalDays: 'Minimum days between reminders',
    invoiceRemindersMax: 'Maximum reminders per invoice',
    invoiceRemindersOnlyOverdue: 'Only when overdue',
    invoiceLabelsTitle: 'Invoice labels',
    invoiceLabelsDesc: 'Create optional labels to organize and filter invoices (no defaults are provided).',
    invoiceLabelsEmpty: 'No labels yet.',
    invoiceLabelsAdd: 'Add label',
    invoiceLabelsEdit: 'Edit label',
    invoiceLabelsName: 'Label name',
    invoiceLabelsColor: 'Color',
    invoiceLabelsIcon: 'Icon',
    invoiceLabelsIconPlaceholder: 'Choose an icon',
    invoiceLabelsIconNoMatch: 'No matching icons',
    invoiceLabelsNameRequired: 'Label name is required',
    invoiceLabelIcons: {
      tag: 'Tag',
      folder: 'Folder',
      install: 'Install / service',
      repair: 'Repair',
      warranty: 'Warranty',
      retail: 'Retail / reseller',
      delivery: 'Delivery',
      project: 'Project',
      plumbing: 'Plumbing',
      electrical: 'Electrical',
      hvac: 'HVAC',
      water: 'Water',
      residential: 'Residential',
      commercial: 'Commercial',
      priority: 'Priority',
      construction: 'Construction'
    },
    invoiceLabelsSaved: 'Label saved',
    invoiceLabelsSaveFailed: 'Could not save label',
    invoiceLabelsLoadFailed: 'Could not load labels',
    invoiceLabelsDeleteTitle: 'Remove label?',
    invoiceLabelsDeleteMessage: 'Remove “{name}”? It will be unlinked from any invoices.',
    invoiceLabelsArchived: 'Label removed',
    invoiceLabelsArchiveFailed: 'Could not remove label',
    invoicesSaved: 'Invoice settings saved',
    invoicesSaveFailed: 'Failed to save invoice settings',
    paymentTermsPanelTitle: 'Payment terms',
    paymentTermsNew: 'New terms',
    paymentTermsEdit: 'Edit terms',
    paymentTermsName: 'Name',
    paymentTermsDays: 'Days',
    paymentTermsDefault: 'Default',
    paymentTermsSaveFailed: 'Failed to save payment terms',
    paymentTermsDeleteTitle: 'Delete payment terms?',
    paymentTermsDeleteMessage: 'Delete "{name}"? This cannot be undone.',
    paymentTermsDeleteFailed: 'Failed to delete payment terms',
    userManagement: 'User Management',
    userManagementDesc: 'Invite team and assign roles',
    profile: 'Profile',
    profileDesc: 'Update your name, email, and password',
    updateAvailable: 'A new version of Blu is available.',
    updateCurrentLatest: 'Current: {current} · Latest: {latest}',
    reloadNow: 'Reload now',
    later: 'Later',
    latestVersion: 'You are running the latest version of Blu.',
    versionLabel: 'Version {version}',
    updateCheckFailed: 'Update check failed. Please try again.'
  },
  customers: {
    title: 'Customers',
    subtitle: 'Manage customer profiles and loyalty',
    manageGroups: 'Manage Groups',
    exportCsv: 'Export CSV',
    comingSoon: 'Coming soon',
    newCustomer: 'New Customer',
    loadFailed: "Couldn't load customers",
    customerUpdated: 'Customer updated successfully',
    customerCreated: 'Customer created successfully',
    saveFailed: 'Error saving customer',
    emailInUseHint: 'That email belongs to another customer. Merge profiles or choose a different email.',
    merge: {
      action: 'Merge customer',
      title: 'Merge another customer into this profile',
      subtitle: 'Move history, emails, and portal access from a duplicate profile into this one. The other profile will be archived.',
      sourceLabel: 'Customer to merge in',
      confirm: 'Merge profiles',
      success: 'Customers merged successfully',
      failed: 'Could not merge customers'
    },
    astroLinked: 'Linked to Astro',
    astroUnlinked: 'Unlinked from Astro',
    retry: 'Retry',
    search: 'Search',
    searchPlaceholder: 'Name, email, phone, city...',
    searchHint: 'Server-side search (matches backend results)',
    hasEmail: 'Has email',
    hasPhone: 'Has phone',
    minLoyalty: 'Min loyalty',
    pts: 'pts',
    apply: 'Apply',
    clear: 'Clear',
    noCustomers: 'No customers found.',
    editCustomer: 'Edit Customer',
    loyaltyHistory: 'Loyalty History',
    openInAstro: 'Open in Astro',
    deleteCustomer: 'Archive Customer',
    editCustomerTitle: 'Edit Customer',
    newCustomerTitle: 'New Customer',
    editCustomerSubtitle: 'Update profile, contact info, and notes',
    newCustomerSubtitle: 'Create a customer profile for invoices and loyalty',
    basicInfo: 'Basic Information',
    addressInfo: 'Address Information',
    contactInfo: 'Contact Information',
    schedulingAppointments: 'Appointments',
    schedulingAppointmentsEmpty: 'No upcoming or recent appointments.',
    firstName: 'First Name',
    lastName: 'Last Name',
    suffix: 'Suffix',
    suffixPlaceholder: 'e.g., Jr., Sr., III',
    taxId: 'Tax ID',
    firstNameRequired: 'First name is required',
    lastNameRequired: 'Last name is required',
    stateProvince: 'State/Province',
    notes: 'Notes',
    additionalInfo: 'Additional Information',
    astro: 'Astro',
    astroCustomerId: 'Astro Customer ID',
    astroLinkPlaceholder: 'Enter Astro ID to link',
    link: 'Link',
    unlink: 'Unlink',
    confirmDelete: 'Confirm Archive',
    confirmDeleteMessage: 'Archive {name}? Archived customers are hidden from lists but remain on historical sales and invoices.',
    deleted: 'Customer archived successfully',
    deleteFailed: 'Error archiving customer',
    moreActions: 'More actions',
    restoreArchivedCustomers: 'Restore archived customers',
    restoreModeTitle: 'Archived customers',
    restoreModeSubtitle: 'Review archived customers and restore them to the active list',
    backToCustomers: 'Back to customers',
    archivedAt: 'Archived',
    archivedBy: 'Archived by',
    noArchivedCustomers: 'No archived customers found.',
    restoreCustomer: 'Restore customer',
    confirmRestore: 'Confirm restore',
    confirmRestoreMessage: 'Restore {name} to the active customer list?',
    restored: 'Customer restored successfully',
    restoreFailed: 'Error restoring customer',
    currentBalance: 'Current Balance',
    pointsAvailable: 'Points available',
    totalPointsEarned: 'Total Points Earned',
    cashRedemptions: 'Cash Redemptions',
    productRedemptions: 'Product Redemptions',
    transactionHistory: 'Transaction History',
    noLoyaltyTransactions: 'No loyalty transactions found',
    loyaltyLoadFailed: 'Failed to load loyalty history',
    tableName: 'Name',
    tablePhoto: 'Photo',
    tableContactInfo: 'Contact Information',
    tableCity: 'City',
    tableState: 'State',
    tableActions: 'Actions',
    viewProfile: 'View profile',
    profile: {
      title: 'Customer profile',
      subtitle: 'Insights, history, and loyalty at a glance',
      loyaltyTabHint: 'View points earned, redemptions, and full transaction history.',
      back: 'Back to customers',
      loadFailed: 'Could not load customer profile',
      scopeAll: 'All locations',
      scopeCurrent: 'This location',
      totalVisits: 'Total visits',
      totalVisitsHint: 'Completed sales that count toward revenue (excludes charge-to-tab).',
      totalSpent: 'Total spent',
      totalSpentHint: 'Sum of goods on revenue-counted sales; tab pay-downs count once when settled.',
      loyaltyPoints: 'Loyalty points',
      lastVisit: 'Last visit',
      memberSince: 'Member since',
      onlineAccess: {
        title: 'Online account',
        notEligible: 'Add a primary email to enable online sign-in.',
        neverInvited: 'Can sign in online — customer has not been emailed a link yet.',
        linkSent: 'Sign-in link sent — not used yet',
        linkSentAt: 'Last link sent {date}',
        active: 'Has signed in online',
        lastSignIn: 'Last sign-in {date}',
        sendLink: 'Send sign-in link',
        resendLink: 'Resend sign-in link',
        sendSuccess: 'Sign-in link emailed to the customer.',
        sendFailed: 'Could not send sign-in link.',
        firstInviteTitle: 'Send first sign-in link?',
        firstInviteMessage: 'This customer has not requested online access before. Only send if they asked you to (for example in store or by phone). The email is a secure sign-in link, not a marketing message.',
        firstInviteConfirm: 'Send link'
      },
      favoriteCategory: 'Favorite category',
      topProductsCaption: 'Often buys: {names}',
      notesPreferences: 'Notes & preferences',
      noNotes: 'No notes yet.',
      recentPurchases: 'Recent purchases',
      viewAllPurchases: 'View all',
      noPurchases: 'No purchase history for this customer yet.',
      loyaltyProgress: '{points} points',
      pointsToReward: '{count} points to next reward',
      rewardReady: 'Ready to redeem',
      openFullProfile: 'Open full profile',
      tabOverview: 'Overview',
      tabPurchases: 'Purchases',
      purchasesListHint: 'Up to {count} most recent items.',
      purchaseQtyLine: '{qty} × {price}',
      tabTabs: 'Tabs',
      tabInvoices: 'Invoices',
      tabBooking: 'Booking',
      tabLoyalty: 'Loyalty',
      openTabs: 'Open tabs',
      openInvoices: 'Open invoices',
      noOpenTabs: 'No open tabs for this customer.',
      noInvoices: 'No invoices found.',
      noAppointments: 'No appointments found.',
      averageTicket: 'Avg. ticket'
    },
    profilePhoto: 'Profile photo',
    profilePhotoHint: 'Helps staff recognize this customer.',
    photoChooseFile: 'Choose file',
    /** Mobile: opens system picker (camera, gallery, files) */
    photoAddPhoto: 'Add photo',
    photoTakePicture: 'Take picture',
    photoUseWebcam: 'Use webcam',
    photoRemove: 'Remove photo',
    photoViewOnly: 'You can view this photo; only users with customer management access can change it.',
    photoUploadSuccess: 'Photo updated',
    photoUploadFailed: 'Could not upload photo',
    photoRemoveSuccess: 'Photo removed',
    photoRemoveFailed: 'Could not remove photo',
    webcamTitle: 'Webcam',
    webcamHelp: 'Start the camera, then capture a frame.',
    webcamStart: 'Start camera',
    webcamCapture: 'Capture',
    webcamNotSupported: 'This browser does not support webcam capture. Use Choose file or Take picture instead.',
    webcamPermissionDenied: 'Camera access was denied. Check browser permissions or use Choose file.',
    webcamWaitForVideo: 'Wait for the video preview to appear, then try again.',
    loyaltyDate: 'Date',
    loyaltyType: 'Type',
    loyaltyBalanceBefore: 'Balance Before',
    loyaltyPoints: 'Points',
    loyaltyBalanceAfter: 'Balance After',
    loyaltySale: 'Sale',
    loyaltySaleNumber: 'Sale #{id}',
    loyaltyProductDetails: 'Product Details',
    loyaltyProductFallback: 'Product',
    loyaltyNotes: 'Notes',
    loyaltyFilterAll: 'All',
    loyaltyFilterEarned: 'Earned',
    loyaltyFilterCashRedeemed: 'Cash redeemed',
    loyaltyFilterProductRedeemed: 'Product redeemed',
    loyaltyTypeEarned: 'Earned',
    loyaltyTypeCashRedeemed: 'Cash redeemed',
    loyaltyTypeProductRedeemed: 'Product redeemed',
    more: 'more',
    manageCards: 'Manage cards',
    paymentMethods: {
      title: 'Cards on file',
      addCard: 'Add card',
      addCardTitle: 'Add card on file',
      addCardHint: 'A $1.00 authorization validates the card and is voided immediately after the card is saved.',
      addCardKeyedEntry: 'Add card (keyed entry)',
      empty: 'No cards on file yet.',
      setDefault: 'Set as default',
      editLabel: 'Edit label',
      editLabelTitle: 'Card label',
      remove: 'Remove',
      removeTitle: 'Remove card',
      removeMessage: 'Remove {card} from this customer?',
      removed: 'Card removed',
      removeFailed: 'Could not remove card',
      cardSaved: 'Card saved',
      defaultUpdated: 'Default card updated',
      labelUpdated: 'Label updated',
      updateFailed: 'Could not update card',
      captureUnavailable: 'Card capture is not available. Configure Dejavoo CNP or a SPIn terminal.'
    }
  },
  locations: {
    title: 'Locations',
    subtitle: 'Manage store locations and current session location',
    newLocation: 'New Location',
    loadFailed: "Couldn't load locations",
    retry: 'Retry',
    search: 'Search',
    searchPlaceholder: 'Name, city, state…',
    state: 'State',
    stateAll: 'All',
    currentOnly: 'Current only',
    apply: 'Apply',
    clear: 'Clear',
    noLocations: 'No locations found.',
    editLocation: 'Edit Location',
    deleteLocation: 'Delete Location',
    current: 'Current',
    setAsCurrent: 'Set as Current Location',
    editTitle: 'Edit Location',
    newTitle: 'New Location',
    editSubtitle: 'Update address, contact, timezone, and operating hours for this store.',
    newSubtitle: 'Add a store location with address, contact, and schedule details.',
    section: {
      details: 'Location details',
      detailsHint: 'Name and phone number shown on receipts and internal reports.',
      address: 'Address',
      addressHint: 'Physical address used for taxes, invoices, and location context.',
      schedule: 'Schedule & timezone',
      scheduleHint: 'Timezone and hours drive dashboard digests and local reporting.'
    },
    locationName: 'Location Name',
    locationNameRequired: 'Location name is required',
    addressRequired: 'Address is required',
    cityRequired: 'City is required',
    stateRequired: 'State is required',
    postalCodeRequired: 'Postal code is required',
    phoneRequired: 'Phone number is required',
    timezone: 'Timezone override',
    timezoneHint: 'Optional. Search by city or region. Leave blank to use the business default.',
    operatingHours: {
      title: 'Operating hours',
      hint: 'Used to schedule dashboard digests before open and after close for this location.',
      open24_7: 'Open 24/7',
      open24_7Hint: 'Uses default digest times instead of open/close hours.',
      fallbackHint: 'Dashboard digests use the default morning (7:00 AM) and end-of-day (8:00 PM) schedule.',
      emptyFallbackHint: 'Leave all days closed to use the default digest schedule until hours are configured.',
      columnDay: 'Day',
      columnStatus: 'Status',
      closed: 'Closed',
      open: 'Open',
      close: 'Close',
      weekdays: {
        sunday: 'Sunday',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday'
      }
    },
    update: 'Update',
    create: 'Create',
    deleteTitle: 'Delete Location',
    confirmDelete: 'Are you sure you want to delete "{name}"? This action cannot be undone.',
    deleted: 'Location deleted successfully',
    updated: 'Location updated successfully',
    created: 'Location created successfully',
    saveFailed: 'Failed to save location',
    loadFailedGeneric: 'Failed to load locations',
    setCurrentSuccess: '{name} set as current location',
    setCurrentFailed: 'Failed to set current location: {message}',
    tableName: 'Location Name',
    tableAddress: 'Address',
    tablePhone: 'Phone',
    tableCurrent: 'Current',
    tableActions: 'Actions'
  },
  invoices: {
    title: 'Invoices',
    invoiceLabel: 'Invoice',
    documentTitle: {
      draft: 'Draft',
      draftUntitled: 'Draft',
      estimate: 'Estimate',
      invoice: 'Invoice'
    },
    documentStatus: {
      unpaid: 'Unpaid',
      unpaidAcceptanceHint: 'Customer must accept before paying'
    },
    subtitle: 'View, create, and manage customer invoices',
    recurringNav: 'Recurring billing',
    recurring: {
      listTitle: 'Recurring billing',
      listSubtitle: 'Subscriptions, autopay, and scheduled invoices',
      schedulesTableTitle: 'Recurring schedules',
      templateColumn: 'Template',
      templateBadge: 'Recurring template',
      editSchedule: 'Edit schedule',
      editTemplate: 'Edit template',
      viewTemplate: 'View template',
      generatedInvoices: 'Generated invoices',
      noGeneratedInvoices: 'No generated invoices yet.',
      generatedFromTemplate: 'Generated from recurring template.',
      nextRun: 'Next run',
      statusActive: 'Active',
      statusPaused: 'Paused',
      statusEnded: 'Ended',
      editScheduleTitle: 'Edit recurring schedule',
      editScheduleSubtitle: 'Update timing, frequency, and email settings',
      saveSchedule: 'Save schedule',
      scheduleSaved: 'Recurring schedule saved',
      scheduleSaveFailed: 'Failed to save recurring schedule',
      scheduleActivated: 'Recurring schedule activated',
      saveTemplate: 'Save template',
      templateSaved: 'Template saved',
      templateContentsSubtitle: 'Template contents',
      saveAndActivateSchedule: 'Save & activate schedule',
      disableRecurringTitle: 'Disable recurring?',
      disableRecurringMessage: 'This will end the recurring schedule when you save.',
      frequency: 'Frequency',
      startDate: 'Start date',
      timeOfDay: 'Time of day',
      endDateOptional: 'End date (optional)',
      autoEmail: 'Auto-email invoices',
      every: 'Every',
      daysOfWeek: 'Days of week',
      dayOfMonth: 'Day of month',
      upcomingRuns: 'Upcoming runs',
      issueDate: 'Issue date',
      dueDate: 'Due date',
      modeSimple: 'Simple',
      modeAdvanced: 'Advanced',
      planName: 'Plan or service name',
      cadencePreset: 'Billing cadence',
      presetMonthly: 'Monthly',
      presetQuarterly: 'Quarterly',
      presetAnnual: 'Annual',
      collectionMode: 'Collection',
      collectionInvoiceOnly: 'Invoice each cycle',
      collectionAutopay: 'Autopay (card on file)',
      paymentMethodOnFile: 'Card on file',
      defaultCard: 'default',
      autopayStatus: 'Autopay',
      autopayReady: 'Card on file',
      autopayNeedsCard: 'Needs card setup',
      autopayFailed: 'Last charge failed',
      sendEnrollmentLink: 'Send autopay setup link',
      sendEnrollmentLinkHint: 'Email a secure link so the customer can save a card for autopay.',
      enrollmentLinkSent: 'Autopay setup link sent',
      enrollmentLinkFailed: 'Could not send autopay setup link',
      bulkImport: 'Bulk import',
      bulkImportTitle: 'Import subscribers',
      bulkImportHint: 'CSV header: email, plan_name, amount, frequency, interval, collection_mode, start_date',
      bulkImportCsvLabel: 'CSV rows',
      bulkSendEnrollmentLinks: 'Email autopay setup links for autopay rows without a card',
      bulkImportRun: 'Import',
      bulkImportDone: 'Created {created} schedule(s). {errors} row error(s).',
      freqDaily: 'Daily',
      freqWeekly: 'Weekly',
      freqMonthly: 'Monthly',
      freqYearly: 'Yearly',
      firstRunStartDate: 'First run on start date',
      firstRunNow: 'First run now',
      firstRunAfterPeriod: 'After initial period',
      weekdaySun: 'Sun',
      weekdayMon: 'Mon',
      weekdayTue: 'Tue',
      weekdayWed: 'Wed',
      weekdayThu: 'Thu',
      weekdayFri: 'Fri',
      weekdaySat: 'Sat'
    },
    newInvoice: 'New Invoice',
    search: 'Search',
    searchPlaceholder: 'Number, customer, status…',
    status: 'Status',
    issueFrom: 'Issue from',
    issueTo: 'Issue to',
    assignedDay: 'Assigned Day',
    apply: 'Apply',
    clear: 'Clear',
    rentalOnly: 'Rental invoices only',
    rentalBadge: 'Rental',
    setDay: 'Set Day',
    applyDay: 'Apply Day',
    startRoute: 'Start Route',
    view: 'View',
    directions: 'Directions',
    edit: 'Edit',
    cancel: 'Cancel',
    statusAll: 'All',
    statusDraft: 'Draft',
    statusEstimate: 'Estimate',
    statusIssued: 'Issued',
    statusPartiallyPaid: 'Partially Paid',
    statusPaid: 'Paid',
    statusOverdue: 'Overdue',
    statusPastDue: 'Past due',
    statusCancelled: 'Cancelled',
    statusExpired: 'Expired',
    statusVoided: 'Voided',
    statusUnknown: 'Unknown',
    tableNumber: 'Number',
    tableCustomer: 'Customer',
    tableIssueDate: 'Issue Date',
    tableDueDate: 'Due Date',
    tableTotal: 'Total',
    tableLabels: 'Labels',
    labelsFilter: 'Labels',
    labelsField: 'Labels',
    tableStop: 'Stop #',
    editInvoice: 'Edit Invoice',
    newInvoiceTitle: 'New Invoice',
    recurringTimezone: 'Timezone',
    recurringTimezoneHint: 'Search by city or region. Defaults to your business timezone.',
    editRecurring: 'Edit Recurring Invoice Schedule',
    newRecurring: 'New Recurring Invoice Schedule',
    issueDate: 'Issue Date',
    terms: 'Terms',
    termsRequired: 'Terms required',
    paymentDueDate: 'Payment Due Date',
    poNumber: 'PO Number',
    headerDescription: 'Description',
    headerDescriptionHint: 'Shown to the customer on the invoice, payment portal, PDF, and email.',
    billTo: 'Bill To',
    shipTo: 'Ship To',
    lineItems: 'Line Items',
    selectProduct: 'Select product',
    productIdFallback: 'Product #{id}',
    lineDescriptionPlaceholder: 'Add a description',
    noResults: 'No results.',
    addNewProduct: 'Add new product',
    addNewProductCaption: 'If not found in results',
    createNewTerms: 'Create new terms',
    createNewTermsCaption: 'Saved for reuse on future invoices',
    createNewTermsSubtitle: 'Applied to this invoice when you save',
    noTermsConfigured: 'No payment terms yet.',
    termsName: 'Terms name',
    termsNameRequired: 'Name is required',
    termsDays: 'Due in (days)',
    termsDaysRequired: 'Enter zero or more days',
    termsSetDefault: 'Set as default for new invoices',
    createTermsFailed: 'Could not create payment terms',
    termsCreatedAndSelected: 'Payment terms created and selected',
    invoicePreview: 'Invoice Preview',
    previewViewer: {
      subtitle: 'Customer-facing layout',
      deviceMobile: 'Mobile',
      deviceTablet: 'Tablet',
      deviceDesktop: 'Desktop',
      portrait: 'Portrait',
      landscape: 'Landscape',
      zoom: '{percent}%',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      resetView: 'Reset'
    },
    estimate: 'Estimate',
    emailInvoice: 'Email Invoice',
    emailInvoiceSubtitle: 'Send to the customer email on file (or override below)',
    to: 'To',
    subject: 'Subject',
    attachPdf: 'Attach PDF',
    requestApproval: 'Request Approval',
    send: 'Send',
    approved: 'Approved',
    by: 'by',
    viewSignature: 'View signature',
    customer: 'Customer',
    billToAnchor: {
      modeCustomer: 'Bill to customer',
      modeProject: 'Bill to project',
      project: 'Project',
      searchProject: 'Search projects',
      projectNeedsCustomer: 'This project has no customer — select one for the invoice.',
      viewProject: 'View project',
      creatingForProject: 'Creating invoice for {project}',
      backToProject: 'Back to project',
      projectRequired: 'Select a project',
      customerRequired: 'Select a customer'
    },
    billToEntity: {
      company: 'Company',
      ownerContact: 'Owner contact: {name}'
    },
    recipient: {
      groupBilling: 'Group billing',
      groupMember: 'Group member',
      custom: 'Custom address'
    },
    void: 'Void',
    refund: 'Refund',
    preview: 'Preview',
    text: 'Text',
    applyPayment: 'Apply Payment',
    addFulfillment: 'Add Fulfillment',
    fulfillmentHistory: 'Fulfillment History',
    undoFulfillment: 'Remove',
    undoFulfillmentConfirmTitle: 'Remove fulfillment?',
    undoFulfillmentConfirmMessage: 'This removes the fulfillment record and updates line quantities. No payment or inventory changes are made.',
    undoFulfillmentLinkedSale: 'Linked to a sale — cannot remove manually',
    reviseBlockedFulfillments: 'Remove all fulfillments before editing invoice lines.',
    convert: {
      fromTabBanner: 'This invoice was created from a running tab.',
      viewTab: 'View tab'
    },
    editIssuedInvoice: 'Edit Invoice (issued)',
    saveInvoice: 'Save',
    rentalCustomerLocked: 'Customer is locked for rental invoices.',
    issue: 'Issue',
    issueNow: 'Issue now',
    saveDraft: 'Save draft',
    draftSaved: 'Invoice saved',
    includeDrafts: 'Include drafts',
    promoteToEstimate: 'Save as estimate',
    promoteToEstimateSuccess: 'Estimate saved with number assigned',
    promoteToEstimateFailed: 'Could not save as estimate',
    deleteDraftTitle: 'Delete draft?',
    deleteDraftMessage: 'This permanently removes the draft and cannot be undone.',
    filters: {
      title: 'Find invoices',
      subtitle: 'Search, filter by stage, or narrow by labels and dates.',
      subtitleV2: 'Search by customer or number, then filter by status or labels.',
      stageLabel: 'Stage',
      stageColumn: 'Stage',
      deliveryLabel: 'Client delivery',
      moreLabel: 'Dates & delivery',
      active: 'Active filters',
      labelsCount: '{count} label(s)',
      groupDraftQuotes: 'Drafts & estimates',
      groupInvoices: 'Invoices & payment',
      groupClosed: 'Closed'
    },
    lifecycle: {
      filterLabel: 'Stage',
      reminderCount: '{count} reminder(s) sent',
      draft: 'Draft',
      estimate_not_sent: 'Estimate not sent',
      estimate_sent: 'Estimate sent',
      estimate_viewed: 'Estimate viewed',
      estimate_approved: 'Estimate approved',
      expired: 'Expired',
      cancelled: 'Cancelled',
      issued_not_sent: 'Invoice not sent',
      invoice_sent: 'Invoice sent',
      invoice_viewed: 'Invoice viewed',
      awaiting_acceptance: 'Awaiting acceptance',
      awaiting_payment: 'Awaiting payment',
      partially_paid: 'Partially paid',
      overdue: 'Overdue',
      paid: 'Paid',
      voided: 'Voided',
      tooltip: {
        draft: 'Internal draft — not visible to customers',
        estimate_not_sent: 'Estimate created but not emailed or texted',
        estimate_sent: 'Sent to customer; not opened yet',
        estimate_viewed: 'Customer opened the estimate link',
        estimate_approved: 'Customer approved or signed',
        expired: 'Estimate validity ended',
        cancelled: 'Estimate was cancelled',
        issued_not_sent: 'Invoice issued but not sent',
        invoice_sent: 'Invoice sent; not opened yet',
        invoice_viewed: 'Customer opened the invoice',
        awaiting_acceptance: 'Customer must accept before paying',
        awaiting_payment: 'Balance due',
        partially_paid: 'Partial payment received',
        overdue: 'Past due date',
        paid: 'Paid in full',
        voided: 'Voided'
      }
    },
    engagement: {
      columnLabel: 'Client',
      filterLabel: 'Client engagement',
      filterNotSent: 'Not sent to client',
      filterSentNotViewed: 'Sent, not viewed',
      filterViewed: 'Viewed by client',
      filterApproved: 'Estimate approved',
      panelTitle: 'Client delivery',
      panelDesc: 'Whether this was delivered to the customer and if they opened or approved it.',
      summaryEmpty: 'No delivery activity recorded yet.',
      summaryNotSent: 'Not sent to the customer yet',
      summarySent: 'Sent to the customer',
      summaryEmailed: 'Emailed {at}',
      summaryTexted: 'Texted {at}',
      summaryViewed: 'Opened {at}',
      summaryNotViewedYet: 'Not opened yet',
      summaryApproved: 'Approved {at}',
      summaryApprovalPending: 'Approval pending',
      viewTimeline: 'View full activity timeline',
      sentShort: 'Sent',
      notSentShort: 'Not sent',
      viewedShort: 'Viewed',
      notViewedShort: 'Not viewed',
      approvedShort: 'Approved',
      notApprovedShort: 'Pending',
      sentTooltip: 'Sent to client',
      notSentTooltip: 'Not emailed or texted yet',
      notViewedTooltip: 'Customer has not opened the link yet',
      emailedAt: 'Emailed {at}',
      textedAt: 'Texted {at}',
      viewedAt: 'Customer viewed {at}',
      approvedAt: 'Approved {at}'
    },
    activity: {
      deliverySummaryTitle: 'At a glance',
      loadMore: 'Load more',
      loadFailed: 'Could not load activity.',
      lastEmailed: 'Last emailed {at}',
      lastSms: 'Last texted {at}',
      lastViewed: 'Customer viewed {at}',
      approvedAt: 'Approved {at}',
      notSentEstimate: 'Not sent yet',
      notSentInvoice: 'Not sent yet',
      emptyTitleEstimate: 'No client activity yet',
      emptyTitleInvoice: 'No client activity yet',
      emptySubtitleEstimate: 'Send this estimate or share the approval link to see opens and approvals here.',
      emptySubtitleInvoice: 'Send this invoice or share the payment link to see opens and payments here.',
      toRecipient: 'To {to}',
      paymentAmount: 'Amount ${amount}',
      approvedBy: 'Signed by {name}',
      kind: {
        issued: 'Invoice issued',
        email_sent: 'Email sent',
        sms_sent: 'Text message sent',
        email_opened: 'Email opened',
        link_viewed: 'Link viewed',
        estimate_approved: 'Estimate approved',
        payment_submitted: 'Payment received',
        reminder_email_sent: 'Payment reminder emailed',
        reminder_sms_sent: 'Payment reminder texted'
      }
    },
    detail: {
      tabDetails: 'Details',
      tabDetailsDesc: 'Line items, payments, notes, and attachments for this document.',
      tabClientActivity: 'Client activity',
      tabClientActivityDesc: 'Delivery, opens, approvals, and payments from the customer’s perspective.',
      back: 'Back to Invoices',
      balanceDue: 'Balance due',
      paidProgress: '{percent}% paid',
      subtotal: 'Subtotal',
      tax: 'Tax',
      details: 'Details',
      routeOrder: 'Route stop',
      addresses: 'Addresses',
      rentalContext: 'Rental',
      servicePeriod: 'Service period: {start} – {end}',
      viewAgreement: 'View rental agreement',
      colItem: 'Item',
      colLineNumber: '#',
      colProduct: 'Product',
      colDescription: 'Description',
      colQty: 'Qty',
      colUnitPrice: 'Unit price',
      colDiscount: 'Discount',
      colExtPrice: 'Ext price',
      colLineTotal: 'Line total',
      colAmount: 'Amount',
      colFulfillment: 'Fulfillment',
      colDate: 'Date',
      colMethod: 'Method',
      colReference: 'Reference',
      colTip: 'Tip',
      paymentHistory: 'Payment history',
      noPayments: 'No payments applied yet.',
      internalNotes: 'Internal notes',
      staffOnly: 'Staff only — not visible to customers',
      attachments: 'Attachments',
      manageAttachments: 'Manage attachments',
      attachmentsHint: 'Upload images or PDFs to keep with this invoice',
      uploadFiles: 'Upload files',
      noAttachments: 'No attachments yet.',
      recurringSchedule: 'Recurring schedule',
      pauseRecurring: 'Pause',
      resumeRecurring: 'Resume',
      endRecurring: 'End schedule',
      upcomingRuns: 'Upcoming runs',
      noUpcomingRuns: 'No upcoming runs scheduled.',
      recurringStart: 'Start',
      recurringEnd: 'End',
      recurringNoEnd: 'No end date',
      fulfillmentShipment: 'Shipment',
      fulfillmentPos: 'POS sale',
      fulfillmentAdjustment: 'Adjustment',
      more: 'More',
      menuShare: 'Share',
      menuCollect: 'Collect',
      menuField: 'Field',
      menuAdmin: 'Admin',
      downloadPdf: 'Download PDF',
      email: 'Email',
      loadFailed: "Couldn't load invoice",
      retry: 'Retry',
      textInvoice: 'Text invoice',
      textInvoiceSubtitle: 'Send to the customer phone on file (or override below)',
      phoneRequired: 'Phone number is required',
      phoneUsOnly: 'SMS can only be sent to US phone numbers',
      phoneUsHint: 'US phone numbers only',
      cancelEstimateTitle: 'Cancel invoice?',
      cancelEstimateMessage: 'This will cancel the estimate and prevent issuing it.',
      voidTitle: 'Void invoice?',
      voidMessage: 'This will void the invoice and keep it from being paid.',
      refundTitle: 'Create refund?',
      refundMessage: 'This will create a credit memo for the full invoice amount.',
      creditMemoCreated: 'Credit memo created',
      emailSent: 'Email sent',
      smsSent: 'Invoice texted',
      previewFailed: 'Failed to load preview',
      attachmentOpenFailed: 'Unable to open attachment',
      directionsFailed: 'No valid address available for directions',
      endRecurringTitle: 'End recurring schedule?',
      endRecurringMessage: 'This will stop future invoices from being generated.',
      uploadFailed: 'Failed to upload attachment(s)',
      deleteAttachmentFailed: 'Failed to delete attachment',
      sendEmailFailed: 'Failed to send email',
      sendSmsFailed: 'Failed to send text'
    },
    recordPayment: {
      action: 'Record payment',
      title: 'Record payment',
      subtitle: 'Record a payment received outside the register',
      balanceDue: 'Balance due',
      amount: 'Amount',
      payFullBalance: 'Pay full balance',
      method: 'Payment method',
      receivedDate: 'Received date',
      reference: 'Reference (optional)',
      notes: 'Notes (optional)',
      checkNumber: 'Check number (optional)',
      bankName: 'Bank name (optional)',
      authCode: 'Authorization / reference code (optional)',
      cardLast4: 'Last 4 digits (optional)',
      methodCash: 'Cash',
      methodCheck: 'Check',
      methodCardExternal: 'Card (already processed)',
      methodBankTransfer: 'Bank transfer',
      methodOther: 'Other',
      cardExternalHint: 'This records a payment already charged outside Blu. It does not run a card transaction. To charge a card now, use Pay at Register.',
      submit: 'Record payment',
      success: 'Payment recorded',
      failed: 'Failed to record payment',
      remove: 'Remove',
      removeTitle: 'Remove recorded payment?',
      removeMessage: 'This removes the payment record and restores the invoice balance. Use this only to correct a mistake.',
      removeSuccess: 'Payment removed',
      removeFailed: 'Failed to remove payment',
      methodLabels: {
        cash: 'Cash',
        check: 'Check',
        card_online: 'Card (online)',
        card_external: 'Card (already processed)',
        bank_transfer: 'Bank transfer',
        klarna: 'Klarna',
        other: 'Other'
      }
    }
  },
  sales: {
    title: 'Sales',
    subtitle: 'Sales history and receipt access',
    newSale: 'New Sale',
    loadFailed: "Couldn't load sales",
    retry: 'Retry',
    search: 'Search',
    searchPlaceholder: 'Sale #, customer, notes...',
    status: 'Status',
    saleStatusAll: 'All statuses',
    saleStatusPending: 'Pending',
    saleStatusCompleted: 'Completed',
    saleStatusVoid: 'Void',
    saleStatusRefunded: 'Refunded',
    saleStatusUnknown: 'Unknown',
    voidedFilter: 'Voided sales',
    voidedFilterExclude: 'Hide voided',
    voidedFilterInclude: 'Include voided',
    voidedFilterOnly: 'Voided only',
    voidedFilterHint: 'Includes voided sales from the server',
    payment: 'Payment',
    paymentAll: 'All payments',
    location: 'Location',
    locationAll: 'All locations',
    noLocationsAvailable: 'No locations available',
    from: 'From',
    to: 'To',
    apply: 'Apply',
    clear: 'Clear',
    salesHistory: 'Sales History',
    viewReceipt: 'View Receipt',
    receipt: 'Receipt',
    emailReceipt: 'Email receipt',
    textReceipt: 'Text receipt',
    ccMe: 'CC me',
    print: 'Print',
    cfdGreetingMorning: 'Good morning!',
    cfdGreetingAfternoon: 'Good afternoon!',
    cfdGreetingEvening: 'Good evening!',
    cfdGreetingMorningName: 'Good morning, {name}!',
    cfdGreetingAfternoonName: 'Good afternoon, {name}!',
    cfdGreetingEveningName: 'Good evening, {name}!',
    cfdDiscountCaptionSale: 'includes sale discount ({label})',
    receiptShareFailed: 'Could not open the receipt. Try again.',
    receiptThermalFallback: 'Thermal printer failed; using system print instead.',
    postSaleReceiptTitle: 'Receipt options',
    postSaleReceiptSubtitle: 'How would you like to handle the receipt for this sale?',
    postSaleReceiptNone: 'No receipt',
    postSaleReceiptView: 'View receipt',
    postSaleReceiptSaveToCustomer: 'Save to customer record',
    postSaleReceiptMissingSale: 'Sale information is no longer available.',
    postSaleReceiptInvalidEmail: 'Enter a valid email address.',
    postSaleReceiptInvalidPhone: 'Enter a valid US phone number.',
    postSaleReceiptFailed: 'Could not complete the receipt action.',
    postSaleReceiptEmailed: 'Receipt emailed',
    postSaleReceiptTexted: 'Receipt texted',
    postSaleReceiptBrowserPrintHint: 'Use View receipt to print from the browser if needed.',
    postSaleReceiptUnknownChoice: 'Unknown receipt option.',
    finishReceiptBeforeNextSale: 'Finish receipt options for the current sale before starting another payment.',
    postSaleTipHeading: 'Tip on terminal',
    postSaleTipHint: 'The customer added a tip on the card terminal.',
    postSaleCashChangeTitle: 'Cash payment complete',
    postSaleCashChangeSubtitle: 'Give change to the customer, then continue.',
    postSaleCashChangeNoChangeDue: 'No change due',
    postSaleCashChangeContinue: 'Continue',
    postSaleCompleteTitle: 'Sale complete',
    postSaleCompleteSubtitle: 'Give change if needed, then choose a receipt option.',
    postSaleReceiptHandledPrint: 'Receipt sent to the printer.',
    postSaleReceiptHandledEmail: 'Receipt emailed.',
    postSaleReceiptHandledSms: 'Receipt texted.',
    postSaleReceiptHandledNone: 'No receipt selected.',
    postSaleReceiptHandledOnDisplay: 'Customer chose a receipt option on the display.',
    saleReceiptSubtitle: 'Sale summary and payment details',
    saleReceiptSaleDetails: 'Sale details',
    saleReceiptType: 'Receipt type',
    saleReceiptCustomerDetails: 'Customer details',
    saleReceiptItems: 'Items',
    saleReceiptPaymentDetails: 'Payment details',
    saleReceiptActions: 'Actions',
    saleReceiptLoyalty: 'Loyalty program',
    saleReceiptItemsRedeemed: 'Items redeemed',
    saleReceiptTableProduct: 'Product',
    saleReceiptTableQty: 'Qty',
    saleReceiptTablePrice: 'Price',
    saleReceiptTableDiscount: 'Discount',
    saleReceiptTableLineTotal: 'Line total',
    saleReceiptDate: 'Date',
    saleReceiptSaleNumber: 'Sale #',
    saleReceiptCustomerLabel: 'Customer',
    saleReceiptWalkIn: 'Walk-In',
    saleReceiptPaymentMethod: 'Payment method',
    tabPaymentReceipt: {
      lineItem: 'Tab payment — Tab #{id}',
      itemsTitle: 'Tab purchases',
      ledgerHint: 'Items charged to this tab',
      entryQty: 'Qty {qty}',
      entryQtyPrice: 'Qty {qty} × {price}',
      summaryTitle: 'Tab payment summary',
      receiptTitle: 'Tab Payment Receipt',
      tabAccountSection: 'Tab account',
      thisPaymentSection: 'This payment',
      itemsChargedToTab: 'Items charged to tab',
      tabChargesTotal: 'Tab charges total',
      priorPayments: 'Prior payments',
      amountPaid: 'Amount paid',
      paidInFull: 'Paid in full',
      balanceBefore: 'Balance before payment',
      thisPayment: 'This payment',
      paymentAmount: 'Payment amount',
      remainingBalance: 'Remaining balance',
      totalCharged: 'Total charged',
      badge: 'Tab payment'
    },
    invoicePaymentReceipt: {
      receiptTitle: 'Invoice Payment Receipt',
      itemsTitle: 'Invoices paid'
    },
    saleReceiptSaleSource: 'Sale source',
    saleSourcePos: 'In-app register',
    saleSourceTerminalFeed: 'Terminal (FEED)',
    salesColumnSaleSource: 'Sale source',
    saleReceiptName: 'Name',
    saleReceiptPhoneLabel: 'Phone',
    saleReceiptEmailLabel: 'Email',
    saleReceiptTaxId: 'Tax ID',
    saleReceiptSubtotal: 'Subtotal',
    saleReceiptSaleDiscount: 'Sale discount',
    saleReceiptDiscountedSubtotal: 'Discounted subtotal',
    saleReceiptTax: 'Tax',
    saleReceiptTip: 'Tip',
    saleReceiptConvenienceFee: 'Convenience fee',
    saleReceiptPennyRounding: 'Penny rounding',
    saleReceiptCashTotal: 'Total (cash)',
    saleReceiptTotal: 'Total',
    saleReceiptAmountReceived: 'Amount received',
    saleReceiptChangeGiven: 'Change given',
    saleReceiptCardType: 'Card type',
    saleReceiptCardNumber: 'Card number',
    saleReceiptAuthorization: 'Authorization',
    saleReceiptTransactionId: 'Transaction ID',
    saleReceiptSplitPayments: 'Split payments',
    saleReceiptCfTotal: 'Convenience fee total',
    saleReceiptPrevBalance: 'Previous balance',
    saleReceiptPointsEarned: 'Points earned',
    saleReceiptPointsRedeemed: 'Points redeemed',
    saleReceiptNewBalance: 'New balance',
    saleReceiptBusinessPhone: 'Phone',
    saleReceiptBusinessEmail: 'Email',
    saleReceiptPaymentCard: 'Card',
    saleReceiptVoidPayment: 'Void payment',
    saleReceiptRefundPayment: 'Refund payment',
    saleReceiptConfirmVoidTitle: 'Confirm void',
    saleReceiptConfirmRefundTitle: 'Confirm refund',
    saleReceiptConfirmVoidMessage: 'Are you sure you want to void this payment? This will cancel the same-day transaction.',
    saleReceiptConfirmRefundMessage: 'Are you sure you want to refund this payment? This will create a refund on the processor.',
    saleReceiptVoidRequested: 'Payment void requested',
    saleReceiptRefundRequested: 'Payment refund requested',
    saleReceiptRefundRequestFailed: 'Failed to submit request',
    searchProducts: 'Search Products',
    scanBarcode: 'Scan Barcode',
    quickCreate: 'Quick Create',
    quickCreateProduct: 'Quick Create Product',
    myGrid: 'My Grid',
    globalGrid: 'Global Grid',
    rentalGrid: 'Rental Grid',
    refreshRentalGridTooltip: 'Reload rental buildings and unit map from the server',
    customizeGrid: 'Customize Grid',
    customizeMyGrid: 'Customize My Grid',
    customizeGlobalGrid: 'Customize Global Grid',
    refreshGrid: 'Refresh grid',
    refreshGridTooltip: 'Reload products, categories, and grid layout from the server',
    statusActive: 'Active',
    statusVoided: 'Voided',
    statusAll: 'All',
    paymentCash: 'Cash',
    paymentCard: 'Card',
    paymentKlarna: 'Klarna',
    paymentSplit: 'Split',
    paymentTab: 'Tab',
    paymentTabHouse: 'House tab',
    paymentTabBar: 'Bar tab',
    paymentTabPortal: 'Online tab',
    paymentTabPaymentBar: 'Bar payment',
    paymentCheck: 'Check',
    paymentUnknown: 'Payment',
    openRegisterBeforeCardPayment: 'Open your assigned register before taking card payments.',
    tapToPayPreparingTitle: 'Preparing Tap to Pay',
    tapToPayPreparingHint: 'Please wait…',
    cardSettlementProcessingTitle: 'Processing card payment',
    cardSettlementProcessingHint: 'Please wait…',
    tapToPaySaleMissing: 'Sale could not be created for card payment. Check your connection and try again.',
    inventoryOversoldLine: 'Recorded stock was low for "{product}": {available} on hand, {requested} sold. Inventory was adjusted.',
    inventoryOversoldLinkedModifier: 'Recorded stock was low for add-on "{product}": {available} on hand, {requested} deducted. Inventory was adjusted.',
    inventoryOversoldGeneric: 'Inventory note: {code}',
    inventoryOversoldUnknownProduct: 'Item',
    cardModeIntegratedUnavailable: 'Integrated terminal (DvPayLite) is not available on this device or this register’s terminal. Use a different card mode or open the payment dialog.',
    cardModePhysicalTerminalUnavailable: 'This register needs an active terminal ready for physical card payments. Check the terminal or register settings.',
    iphoneTopSetupButton: 'Set up Tap to Pay',
    iphoneTopSetupButtonTooltip: 'Complete one-time Tap to Pay on iPhone setup before taking card payments on this device.',
    cardModeTapOnPhoneUnavailable: 'Tap on Phone cannot be used in this setup. Install the Blu POS Android app and ensure Tap on Phone is configured, or choose a different card mode.',
    cardModeKeyedUnavailable: 'Keyed entry is not available. Enable it on your payment gateway or choose a different card mode.',
    cardPaymentsUnavailable: 'Card payments are not available on this register. Use cash or contact your administrator.',
    tableSaleNumber: 'Sale #',
    tableDate: 'Date',
    tableCustomer: 'Customer',
    tableTotal: 'Total',
    tablePaymentMethod: 'Payment Method',
    tableStatus: 'Status',
    tableActions: 'Actions',
    noProductsFound: 'No Products Found',
    noProductsMatchHint: "We couldn't find any products matching your search.",
    quickCreateHintBefore: "Don't see what you're looking for? Click the",
    quickCreateHintAfter: 'Quick Create button above to add a new product.',
    customerHasOpenTabs: 'Customer has open tab(s)',
    recommendUseTab: 'Recommend using an existing tab when possible.',
    tabOwner: 'Owner',
    moreTabs: 'more',
    loadingCart: 'Loading cart...',
    cartConcurrentActivity:
      'The cart was also updated from another device or tab. Your changes are merged.',
    posLowStockAddWarning:
      'Low stock for {product}. Double-check availability.',
    posLowStockQuantityWarning:
      'Only {available} recorded in stock. Quantity updated anyway.',
    pendingTabPayment: 'Pending tab payment',
    amount: 'Amount',
    noItemsInCart: 'No items in cart',
    redeeming: 'REDEEMING',
    modifiers: 'Modifiers:',
    removeItem: 'Remove Item',
    ringByAmountTitle: 'Enter amount',
    ringByAmountLabel: 'Total amount',
    ringByAmountMin: 'Enter at least $0.01',
    ringByAmountUnitPrice: 'Unit price',
    ringByAmountQuantity: 'Quantity',
    ringByAmountConfirm: 'Add to cart',
    ringByAmountEdit: 'Edit amount',
    ringByAmountLineCaption: '${total} total at ${unit}/unit',
    cartLineEntryQuantityTitle: 'Enter quantity',
    cartLineEntryLineTitle: 'Edit line',
    cartLineEntryQuantityLabel: 'Quantity',
    cartLineEntryUnitPriceLabel: 'Unit price',
    cartLineEntryLineTotal: 'Line total',
    cartLineEntryQuantityRequired: 'Enter a quantity',
    cartLineEntryQuantityMinFractional: 'Enter at least 0.0001',
    cartLineEntryQuantityMinInteger: 'Enter a whole number of at least 1',
    cartLineEntryPriceMin: 'Price must be zero or greater',
    cartLineEntryAdd: 'Add to cart',
    cartLineEntrySave: 'Save',
    cartLineEntryRemove: 'Remove from cart',
    cartLineEntryRemoveHint: 'Quantity zero removes this line from the cart.',
    openPriceTitle: 'Enter price',
    openPriceConfirm: 'Add to cart',
    openPriceMin: 'Enter at least $0.01',
    decreaseQuantity: 'Decrease Quantity',
    increaseQuantity: 'Increase Quantity',
    setDiscount: 'Set Discount',
    discountFormat: 'Format',
    save: 'Save',
    original: 'Original',
    discounted: 'Discounted',
    subtotal: 'Subtotal',
    subtotalAndTax: 'Subtotal & tax',
    barTabTotal: 'Bar tab total',
    saleDiscount: 'Sale Discount',
    showSaleDiscount: 'Show sale discount',
    hideSaleDiscount: 'Hide sale discount',
    clearDiscount: 'Clear Discount',
    discountedSubtotal: 'Discounted Subtotal',
    tax: 'Tax',
    loyaltyPoints: 'Loyalty Points',
    available: 'available',
    redeemPoints: 'Redeem Points',
    clearPoints: 'Clear Points',
    pointsValue: 'Points Value',
    pointsToEarn: 'Points to Earn:',
    itemsToRedeem: 'Items to Redeem:',
    redeemProducts: 'Redeem Products',
    redeemProductsFor: 'Redeem Products — {name}',
    redemptionAvailablePoints: 'Available Points',
    redemptionPointsUnit: 'points',
    redemptionLoadingProducts: 'Loading redeemable products…',
    redemptionCanAfford: 'Can afford',
    redemptionInsufficientPoints: 'Insufficient points',
    redemptionQuantityMin: 'Quantity must be at least 1',
    redemptionNotesOptional: 'Notes (Optional)',
    redemptionAddToCart: 'Add to Cart',
    redemptionLoadFailed: 'Failed to load redeemable products',
    redemptionNotEnoughPoints: 'Customer does not have enough points for this product',
    addProductsForRedemption: 'Add products to cart for loyalty redemption',
    loyaltyDisabledBlockPayment:
      'The loyalty program is disabled. Remove redemption items and clear redeemed points from the cart, or enable loyalty in Settings.',
    sendToAstro: 'Send to Astro',
    total: 'Total',
    cash: 'Cash',
    card: 'Card',
    split: 'Split',
    chargeToTab: 'Charge to Tab',
    selectCustomerForTab: 'Select a customer to charge to a tab',
    selectCustomerForRental: 'Select a customer on the register before renting a unit',
    registerTabsEntry: 'Tabs',
    barTab: 'Bar Tab',
    barTabCustomerShortcut: 'Open bar tab for customer',
    barTabCustomerShortcutVerify: 'Verify card for bar tab',
    barTabCustomerShortcutAttach: 'Attach bar tab to register',
    barTabCustomerShortcutCharge: 'Charge cart to bar tab',
    barTabAttachOrChargeTitle: 'Bar tab ready',
    barTabAttachOrChargeMessage: 'Attach the tab to this register only, or charge the current cart to the tab now?',
    barTabAttachOrChargeAttachOnly: 'Attach tab only',
    barTabAttachOrChargeChargeNow: 'Charge cart to tab now',
    barTabAddRounds: 'Add to tab',
    barTabAddRoundsSuccess: 'Items added to bar tab',
    cfdBarTabAddRoundsSuccess: '{amount} added to your tab',
    cfdBarTabAddRoundsSuccessShort: 'Added to your tab',
    barTabAddRoundsNeedItems: 'Add items to the register cart first',
    barTabAddRoundsNeedItemsOrChanges: 'Add items to the cart or update tab items first',
    barTabUpdateTab: 'Save tab changes',
    barTabUpdateTabSuccess: 'Tab updated',
    barTabUpdateTabFailed: 'Could not update tab',
    barTabLedgerUnsaved: 'unsaved',
    barTabModeEntered: 'Bar tab mode: {label}',
    barTabModeDetach: 'Detach bar tab',
    barTabReleaseTab: 'Exit Bar Tab',
    barTabReleaseTabTooltip: 'Exit bar tab mode — the tab stays open',
    barTabRemoveCustomerTooltip: 'Clear customer from the register and detach the bar tab',
    barTabModeFlipBack: 'Customer',
    barTabModeBlockedPendingPayment: 'Complete or clear the pending tab payment before entering bar tab mode',
    barTabModeBlockedPendingCredit: 'Complete or clear the pending tab credit before entering bar tab mode',
    barTabModeBlockedHouseTabActive: 'Exit house tab mode before starting bar tab mode',
    barTabOnTabSection: 'On tab',
    barTabNewItemsSection: 'New items',
    barTabLedgerLoading: 'Loading tab…',
    barTabCloseOutAdding: 'Adding items to tab…',
    barTabCloseOutCollecting: 'Collect payment…',
    barTabCloseOutNoBalance: 'Tab balance is already zero',
    barTabCloseOutFailed: 'Could not close out the bar tab',
    barTabCloseOutCashTooltip: 'Charge new items (if any), then collect full tab balance in cash',
    barTabCloseOutCardTooltip: 'Charge new items (if any), then collect full tab balance by card',
    barTabCloseOutSplitTooltip: 'Charge new items (if any), then collect full tab balance with split payment',
    barTabCloseOutPreauthReleased: 'Tab paid in cash. Any card hold from verification was released, not charged.',
    suspendBlockedBarTabMode: 'Exit bar tab mode or complete checkout before suspending',
    barTabStripVerified: 'Verified',
    barTabCardVerifiedBadge: 'Card verified',
    barTabOpenedAt: 'Opened {datetime}',
    tabPrint: 'Print',
    tabPrintSuccess: 'Tab statement sent to printer',
    tabPrintFailed: 'Unable to print tab statement',
    barTabStripCardRequired: 'Card required',
    barTabStripDetach: 'Detach bar tab from register',
    barTabGridTitle: 'Open bar tabs',
    barTabGridSubtitle: 'Select an open tab to continue on this register, or start a new walk-in tab.',
    barTabGridSelectHint: 'Tap a tab below to open it on this register.',
    barTabGridFilterPlaceholder: 'Search by name or card…',
    barTabGridEmpty: 'No open bar tabs at this location.',
    barTabGridRemove: 'Remove',
    barTabGridRemoveConfirmTitle: 'Remove bar tab?',
    barTabGridRemoveConfirmMessage: 'Remove {label} from open bar tabs? This closes the tab with no sale.',
    barTabGridRemoveSuccess: 'Bar tab removed',
    barTabGridRemoveFailed: 'Could not remove bar tab',
    barTabNew: 'New bar tab',
    barTabNewWalkIn: 'New walk-in bar tab',
    barTabNewForCustomer: 'New bar tab for customer',
    barTabNeedCartItems: 'Add items to the cart before charging a bar tab.',
    barTabChargeTitle: 'Charge to bar tab',
    barTabChargeHint: 'Select an open bar tab or start a new one, then secure the card.',
    barTabSelectExisting: 'Open bar tabs',
    barTabContinue: 'Continue',
    barTabAttach: 'Attach',
    barTabPay: 'Pay tab',
    barTabCharge: 'Charge',
    barTabAttached: 'Bar tab: {label}',
    barTabChargeSuccess: 'Items charged to bar tab',
    barTabChargeSuccessDetail: 'Charged to bar tab #{id}',
    barTabInferredName: 'Card name: {name}',
    barTabVerifyCard: 'Verify card',
    barTabSimulateCard: 'Simulate card verification',
    barTabWizardSubtitle: 'Attach a tab, charge the cart, verify a card, or pay a balance.',
    barTabWizardDevBanner: 'Bar tab dev mode — card verification is simulated (no payment gateway required).',
    barTabWizardIntentTitle: 'What would you like to do?',
    barTabWizardIntentAttach: 'Attach tab',
    barTabWizardIntentCharge: 'Charge cart',
    barTabWizardIntentVerify: 'Verify card',
    barTabWizardIntentPay: 'Pay balance',
    barTabWizardProgressIntent: 'Choose an action',
    barTabWizardProgressSelect: 'Select a bar tab',
    barTabWizardProgressCard: 'Verify card on file',
    barTabWizardProgressConfirm: 'Confirm charge',
    barTabWizardConfirmTitle: 'Charge cart to bar tab?',
    barTabWizardConfirmHint: 'These items will be added to the tab balance.',
    barTabWizardCartTotal: 'Cart total',
    barTabWizardDoneTitle: 'Done',
    barTabWizardVerifySuccess: 'Card verified for bar tab',
    barTabWizardPayNeedsVerify: 'Verify a card on file before paying this bar tab.',
    barTabWizardPayQueued: 'Tab payment ready — complete checkout when ready.',
    barTabWizardSelectTabFirst: 'Select a bar tab first.',
    houseTab: 'House Tab',
    houseTabCustomerShortcut: 'Open house tab for customer',
    houseTabCustomerShortcutAttach: 'Attach house tab to register',
    houseTabCustomerShortcutCharge: 'Charge cart to house tab',
    houseTabCustomerShortcutPay: 'Pay house tab balance',
    houseTabAddToTab: 'Add to tab',
    houseTabAddToTabSuccess: 'Items added to house tab',
    houseTabAddToTabNeedItemsOrChanges: 'Add items to the cart or update tab items first',
    houseTabUpdateTab: 'Save tab changes',
    houseTabUpdateTabSuccess: 'Tab updated',
    houseTabUpdateTabFailed: 'Could not update tab',
    houseTabLedgerUnsaved: 'unsaved',
    houseTabLedgerUnsavedBadge: 'Unsaved',
    houseTabModeEntered: 'House tab mode: {label}',
    houseTabReleaseTab: 'Exit House Tab',
    houseTabReleaseTabTooltip: 'Exit house tab mode — the tab stays open',
    houseTabModeBlockedPendingPayment: 'Complete or clear the pending tab payment before entering house tab mode',
    houseTabModeBlockedPendingCredit: 'Complete or clear the pending tab credit before entering house tab mode',
    houseTabModeBlockedBarTabActive: 'Exit bar tab mode before starting house tab mode',
    houseTabOnTabSection: 'On tab',
    houseTabNewItemsSection: 'New items',
    houseTabLedgerLoading: 'Loading tab…',
    houseTabCloseOutAdding: 'Adding items to tab…',
    houseTabCloseOutCollecting: 'Collect payment…',
    houseTabCloseOutNoBalance: 'Tab balance is already zero',
    houseTabCloseOutFailed: 'Could not pay down the house tab',
    houseTabCloseOutCashTooltip: 'Charge new items (if any), then apply a cash payment to the tab (partial or full)',
    houseTabCloseOutCardTooltip: 'Charge new items (if any), then apply a card payment to the tab (partial or full)',
    houseTabCloseOutSplitTooltip: 'Charge new items (if any), then apply a split payment to the tab (partial or full)',
    tabPaymentAmountLabel: 'Payment amount',
    tabPaymentAmountHint: 'Outstanding balance: ${max}',
    tabPaymentCashRoundingHint: 'Outstanding balance: ${balance} · Cash due: ${cashDue}',
    tabPaymentAmountRequired: 'Enter a payment amount greater than zero',
    tabPaymentCashBelowRoundedDue: 'Amount must be at least ${min} with penny rounding',
    tabPaymentAmountExceedsBalance: 'Payment cannot exceed ${max}',
    houseTabMoreActions: 'More',
    houseTabPrintTab: 'Print tab',
    houseTabPrintTabSuccess: 'Tab statement sent to printer',
    houseTabPrintTabFailed: 'Unable to print tab statement',
    houseTabTotal: 'Tab balance',
    houseTabPickerTitle: 'Open house tab',
    houseTabPickerSubtitle: 'Select a customer with an open house tab',
    houseTabPickerFilterPlaceholder: 'Search customers with house tabs',
    houseTabPickerEmpty: 'No customers with open house tabs at this location',
    houseTabPickerNoTabForCustomer: 'This customer does not have an open house tab',
    houseTabPickerSegmentCustomers: 'Customers',
    houseTabPickerSegmentGroupTabs: 'Group tabs',
    houseTabPickerGroupTabsTitle: 'Group house tabs',
    houseTabPickerGroupTabsSubtitle: 'Select a group tab, then choose who is buying',
    houseTabPickerGroupTabsFilterPlaceholder: 'Search group name or phone',
    houseTabPickerGroupTabsEmpty: 'No open group house tabs at this location',
    houseTabGroupMembersTitle: 'Who is buying?',
    houseTabGroupMembersSubtitle: 'Charge to {group} on behalf of a member',
    houseTabGroupMembersSubtitleGeneric: 'Select a group member for this charge',
    houseTabGroupMembersFilterPlaceholder: 'Search group members',
    houseTabGroupMembersEmpty: 'No members found for this group',
    houseTabGroupMembersLoadFailed: 'Could not load group members',
    houseTabParticipantSyncFailed: 'Could not add this member to the group tab',
    houseTabGroupTabLine: 'Tab #{id}',
    houseTabGroupFallbackName: 'Group #{id}',
    houseTabGroupUnknown: 'Group tab',
    houseTabTargetPickerTitle: 'Charge to which tab?',
    houseTabTargetPickerSubtitle: 'Choose personal or group account for {name}',
    houseTabTargetPersonal: 'Personal',
    houseTabTargetPersonalOpen: 'Your open personal house tab',
    houseTabTargetPersonalNew: 'Opens a new personal house tab',
    suspendBlockedHouseTabMode: 'Exit house tab mode or complete checkout before suspending',
    tabOnTabSection: 'On tab',
    tabLedgerLoading: 'Loading tab…',
    tabLedgerUnsaved: 'unsaved',
    registerTabsBalanceSummary: '{count} open · {amount} {currency}',
    registerTabsCreditDisplay: 'Cr {amount}',
    registerTabActionsTitle: 'Tab actions',
    registerTabActionsHint:
      'Charge this sale to a customer tab, add prepayment credit, or pay down an existing tab balance.',
    registerTabActionsOpenList: 'Open tabs',
    registerTabLine: 'Tab #{id} · {owner}',
    registerTabChargeNeedItems: 'Add at least one line item to charge to a tab.',
    registerTabPaySelectCustomer: 'Select a customer to manage open tabs.',
    registerTabPayNeedEmptyCart:
      'Clear the cart before paying a tab. Tab payments must be processed on their own.',
    registerTabPayPending:
      'A tab payment is already pending. Complete or cancel it before starting another.',
    registerTabCreditPending:
      'A tab credit is already pending. Complete or cancel it before starting another.',
    registerTabCreditNeedEmptyCart:
      'Clear the cart before adding tab credit. Prepayments must be processed on their own.',
    addTabCredit: 'Add Tab Credit',
    addTabCreditTitle: 'Add tab credit',
    addTabCreditHint:
      'Record a prepayment on this customer\'s tab. Complete checkout with Cash or Card to apply the credit.',
    createNewTabForCredit: 'Create new tab',
    tabCreditAmount: 'Credit amount',
    tabCreditDescription: 'Description (optional)',
    tabCreditPreviewLabel: 'Selected tab',
    tabCreditAvailable: 'Credit on tab: {amount}',
    tabLineBalanceOnly: 'Balance {balance}',
    tabLineBalanceAndCredit: 'Balance {balance} · Credit {credit}',
    tabLineCreditOnly: 'Credit {credit}',
    queueTabCredit: 'Queue credit',
    tabCreditQueued: 'Tab credit queued. Use Cash or Card to complete payment.',
    tabPaymentQueued: 'Tab payment queued. Use Cash or Card to complete payment.',
    tabCreditAppliedSuccess: 'Tab credit applied successfully',
    tabCreditAppliedFailed: 'Payment was recorded, but could not be applied as tab credit. Please contact support with the sale number.',
    tabPaymentAppliedSuccess: 'Tab payment applied successfully',
    tabPaymentItemizedPrintTitle: 'Print tab item list?',
    tabPaymentItemizedPrintMessage: 'Print an itemized list of all charges on this tab?',
    tabPaymentItemizedPrintYes: 'Print list',
    tabPaymentItemizedPrintNo: 'Skip',
    tabLinkageRecoveryTitle: 'Tab link failed — payment recorded',
    tabLinkageRecoveryBody: 'Sale #{saleId} was recorded but could not be linked to Tab #{tabId}. Retry the link or contact support if this persists.',
    tabLinkageRecoveryHint: 'Payment was recorded (Sale #{saleId}) but could not be linked to the tab. Use Retry link below.',
    tabLinkageRetry: 'Retry link to tab',
    dismiss: 'Dismiss',
    payInvoice: 'Pay invoice',
    payInvoiceDialogHint:
      'Select one or more open invoices and collect payment at the register (cash, card, or other).',
    pendingInvoicePayment: 'Pending invoice payment',
    invoicePaymentQueued: 'Invoice payment queued. Use Cash or Card to complete payment.',
    invoicePaymentAppliedSuccess: 'Invoice payment applied successfully',
    registerInvoicePayPending: 'Finish or cancel the pending invoice payment first.',
    noOpenInvoices: 'No open invoices for this customer.',
    invoiceLinkageRecoveryTitle: 'Invoice link failed — payment recorded',
    invoiceLinkageRecoveryBody: 'Sale #{saleId} was recorded but could not be applied to the invoice(s). Retry the link or contact support if this persists.',
    invoiceLinkageRecoveryHint: 'Payment was recorded (Sale #{saleId}) but could not be applied to the invoice(s). Use Retry link below.',
    invoiceLinkageRetry: 'Retry link to invoice(s)',
    payAtRegister: 'Pay at register',
    pendingTabCredit: 'Pending tab credit',
    payCloseTab: 'Pay / Close Tab',
    payTabDialogHint:
      'Select an open tab and record a payment taken at the register (cash, card, or other). This reduces the tab balance and can close the tab when fully paid.',
    payTabBalancePreview: 'Outstanding balance',
    or: 'or',
    barcodeNotFound: 'Barcode Not Found',
    alsoIngestImage: 'Also ingest product image into gallery',
    quickCreateInstead: 'Quick Create Instead',
    lookUpProduct: 'Look Up Product',
    importAddToCart: 'Import & Add To Cart',
    openTabsForCustomer: 'Open tabs for customer',
    noOpenTabs: 'No open tabs for this customer',
    paymentAmount: 'Payment amount',
    closeTabAuto: 'Close tab automatically if this fully pays the balance',
    applyPayment: 'Apply payment',
    close: 'Close',
    email: 'Email',
    text: 'Text',
    send: 'Send',
    dropHere: 'Drop here',
    cellColor: 'Cell color',
    clearColor: 'Clear color',
    gridEditorHint: 'Drag items from pickers into cells to configure your initial grid layout.',
    gridEditorGlobalHint: 'Changes apply to the Global Grid for all users on this account.',
    gridEditorUserScope: 'Editing: My Grid',
    gridEditorGlobalScope: 'Editing: Global Grid (all users)',
    gridEditorRoot: 'Root grid',
    gridEditorGroups: 'Groups',
    gridEditorPresets: 'Presets',
    gridEditorPresetsDragHint: 'Drag a preset onto the grid. Create presets with the copy button on a product tile.',
    gridEditorPresetsEmpty: 'No presets yet. Use the copy button on a product tile to create one.',
    gridEditorClonePreset: 'Create preset',
    gridEditorEditPreset: 'Edit preset',
    gridEditorPresetCreated: 'Preset saved. Drag it from the Presets list onto the grid.',
    gridEditorDeletePreset: 'Delete preset',
    gridEditorPresetDisplayName: 'Display name',
    gridEditorPresetFeeMode: 'Convenience fee',
    gridEditorPresetFeeModeHint: 'Whether card convenience fees apply when this preset is rung.',
    gridEditorPresetLinkedProduct: 'Product: {name}',
    gridEditorPresetDialogConfirm: 'Save preset',
    gridEditorPresetDialogCreateTitle: 'New product preset',
    gridEditorPresetDialogEditTitle: 'Edit product preset',
    gridEditorPresetDialogDeleteTitle: 'Delete preset?',
    gridEditorPresetDialogDeleteMessage: 'This removes the preset from the layout. Tiles using it will be cleared on save.',
    gridEditorNewGroup: 'New group',
    gridEditorNewGroupDragHint: 'Drag onto an empty grid cell to create and configure a group.',
    gridEditorCategoryContents: 'Contents of {name}',
    gridEditorCategorySpatialHint: 'Drag categories and products from the pickers into grid cells.',
    gridEditorCategoryDefaultHint: 'No custom layout — the register uses automatic order from your catalog. Drag items here to customize.',
    gridEditorResetCategoryLayout: 'Reset to default',
    gridEditorResetCategoryLayoutDone: 'Category layout reset. The register will use catalog order.',
    gridEditorGroupContents: 'Group contents',
    gridEditorGroupName: 'Group name',
    gridEditorGroupIcon: 'Icon',
    gridEditorGroupIconHint: 'Search or pick an icon for this group.',
    gridEditorGroupIconSearchPlaceholder: 'Search icons (e.g. beer, food, star…)',
    gridEditorGroupIconNoResults: 'No icons match your search.',
    gridEditorGroupIconCurrent: 'Current icon',
    gridEditorGroupIconCustom: 'Custom icon',
    gridEditorGroupIcons: {
      folder: 'Folder',
      star: 'Star',
      grade: 'Top rated',
      hot: 'Hot / popular',
      quick: 'Quick picks',
      favorite: 'Favorite',
      bar: 'Bar / beer',
      sportsBar: 'Sports bar',
      cafe: 'Coffee / café',
      softDrink: 'Soft drink',
      wine: 'Wine',
      restaurant: 'Restaurant',
      fastFood: 'Fast food',
      lunch: 'Lunch',
      dinner: 'Dinner',
      breakfast: 'Breakfast',
      bakery: 'Bakery',
      cake: 'Cake / dessert',
      iceCream: 'Ice cream',
      pizza: 'Pizza',
      ramen: 'Ramen / noodles',
      combo: 'Combo / special',
      grill: 'Grill / BBQ',
      foodDrink: 'Food & drink',
      water: 'Water',
      basket: 'Basket / grocery',
      cart: 'Shopping cart',
      store: 'Storefront',
      inventory: 'Inventory',
      category: 'Category',
      label: 'Label / tag',
      deal: 'Deal / offer',
      percent: 'Percent off',
      gift: 'Gift / reward',
      giftCard: 'Gift card',
      people: 'People / party',
      celebration: 'Celebration',
      event: 'Event',
      sunny: 'Sunny / patio',
      nightlife: 'Nightlife',
      spa: 'Spa / wellness',
      pets: 'Pets',
      kids: 'Kids',
      schedule: 'Schedule',
      time: 'Time / hours'
    },
    gridEditorDeleteGroup: 'Delete group',
    gridEditorGroupDialogCreateTitle: 'New group',
    gridEditorGroupDialogEditTitle: 'Edit group',
    gridEditorGroupDialogCreateHint: 'Name your group, then arrange tiles on its grid.',
    gridEditorGroupDialogConfirm: 'OK',
    gridEditorGroupDialogDeleteTitle: 'Delete group?',
    gridEditorGroupDialogDeleteMessage: 'This removes the group and its tile from the root grid.',
    gridEditorGroupSpatialHint: 'Drag categories and products from the pickers into grid cells.',
    gridEditorOrderedListHint: 'Drag to reorder subcategories and products. Order is saved with your grid layout.',
    gridEditorEmptyCategoryOrder: 'No items yet. Add categories or products from the pickers.',
    gridEditorEmptyGroup: 'No items yet. Drag categories or products from the pickers.',
    gridEditorSaved: 'Grid layout saved',
    gridEditorSaveFailed: 'Could not save grid layout',
    globalGridViewOnlyHint: 'Global Grid is shared. Ask a manager to customize it.',
    pickers: 'Pickers',
    categories: 'Categories',
    products: 'Products',
    searchProductsPlaceholder: 'Search products',
    cancel: 'Cancel',
    discountCannotBeNegative: 'Discount cannot be negative',
    lineDiscountSyncFailed: 'Could not save line discount. Try again.',
    astroCircuitOpen: 'Astro is temporarily unavailable. We will not send until service recovers.',
    ptsEach: 'pts each',
    nonTaxable: 'Non-taxable',
    pointsCannotBeNegative: 'Points cannot be negative',
    cannotRedeemMorePoints: 'Cannot redeem more points than available',
    suspendSale: 'Suspend',
    resumeSale: 'Resume',
    clearSale: 'Clear sale',
    clearSaleDisabledEmptyCart: 'Add items to the cart before clearing',
    clearSaleDisabledBusy: 'Please wait for the current action to finish',
    cartActionsMenu: 'Cart actions',
    cartActionsMenuTooltip: 'More cart actions',
    suspendOk: 'Sale suspended',
    suspendFailed: 'Could not suspend sale',
    resumeOk: 'Sale resumed',
    resumeFailed: 'Could not resume sale',
    suspendedLines: 'Lines',
    suspendedAt: 'Suspended at',
    suspendedRegister: 'Register',
    resumeSuspendedTitle: 'Resume suspended sale',
    resumeSuspendedScopeLocationHint:
      'These holds may come from any register at this location - confirm the register column before resuming.',
    suspendedPickerEmpty: 'No suspended sales for this register',
    suspendedPickerFilterPlaceholder: 'Search by customer, staff, register, or note',
    suspendedPickerFilterEmpty: 'No suspended sales match your search',
    clearSaleTitle: 'Clear sale?',
    clearSaleMessage:
      'This clears the cart on the server, removes any pending tab payment on this lane, and resets scheduling context. This cannot be undone.',
    clearSaleConfirm: 'Clear',
    clearSaleDone: 'Sale cleared',
    clearSaleFailed: 'Could not clear sale',
    suspendNeedRegister: 'Select an open register first',
    suspendNeedItems: 'Add items to the cart before suspending',
    suspendBlockedPendingTab: 'Complete or clear the pending tab payment before suspending',
    suspendBlockedScheduling: 'Finish or clear the scheduling sale before suspending',
    resumeNeedRegister: 'Select an open register first',
    resumeNeedEmptyCart: 'Cart must be empty to resume - use Clear sale if needed',
    resumeBlockedPendingTab: 'Complete or clear the pending tab payment before resuming',
    resumeBlockedScheduling: 'Finish or clear the scheduling context before resuming',
    suspendedListFailed: 'Could not load suspended sales',
    resumeCartNotEmpty: 'Cart must be empty to resume',
    resumeRouteNeedEmptyCart: 'Clear the cart before resuming a suspended sale',
    suspendedPickerSubtitle: 'Tap a row to resume, or use Resume / Delete on the right.',
    suspendedPickerSuspendedBy: 'Hold by {name}',
    suspendedPickerMetaTime: 'When',
    suspendedPickerMetaStaff: 'Staff',
    suspendedPickerMetaCustomer: 'Customer',
    suspendedPickerCustomerId: 'Customer #{id}',
    suspendedPickerLineItems: 'Items in this hold',
    suspendedPickerMoreLines: '+{count} more line(s) not shown',
    suspendedPickerDelete: 'Delete',
    suspendedPickerDeleteTitle: 'Delete suspended sale?',
    suspendedPickerDeleteMessage: 'Remove hold #{id}? This cannot be undone.',
    suspendedPickerDeleteDone: 'Suspended sale removed',
    suspendedPickerDeleteFailed: 'Could not remove suspended sale',
    suspendedPickerCheckedOut: 'Open elsewhere',
    suspendedTakeoverTitle: 'Sale open on another window',
    suspendedTakeoverMessage: 'This hold is active on another POS tab or device. Take over to load it here and clear the other session’s live cart.',
    suspendedTakeoverConfirm: 'Take over',
    suspendedAbandonForceTitle: 'Force remove hold?',
    suspendedAbandonForceMessage: 'This sale is checked out elsewhere. Removing it clears the other session’s open cart for that hold.',
    suspendedAbandonForceConfirm: 'Remove anyway',
    suspendedPickerOrderDiscountPct: 'Sale discount · {pct}%',
    suspendedPickerOrderDiscountFixed: 'Sale discount · ${amt}',
    suspendNoteTitle: 'Suspend sale',
    suspendNoteMessage: 'Add an optional note to help find this hold later.',
    suspendedSaleNoteLabel: 'Note',
    suspendedSaleNotePlaceholder: 'e.g. blue jacket, customer name, table number…',
    suspendedSaleNoteEdit: 'Note',
    suspendedSaleNoteSave: 'Save note',
    suspendedSaleNoteUpdateOk: 'Note saved',
    suspendedSaleNoteUpdateFailed: 'Could not save note',
    suspendedPickerLayoutList: 'List',
    suspendedPickerLayoutGrid: 'Grid',
    suspendedPickerLayoutToggle: 'Suspended sales layout',
    browseCustomers: 'Browse customers',
    customerGridTitle: 'Select customer',
    customerGridSubtitle: 'Scroll and tap a customer to attach them to this sale.',
    customerGridFilterPlaceholder: 'Filter by name, email, or phone',
    customerGridEmpty: 'No customers found',
    customerGridLoadFailed: 'Could not load customers',
    customerGridOpenTabs: '{count} open tabs · {balance}',
    customerGridTabLine: '{name} · {summary}'
  },
  products: {
    title: 'Products',
    subtitle: 'Manage products, pricing, and availability',
    manageModifiers: 'Manage Modifiers',
    manageCategories: 'Manage Categories',
    newProduct: 'New Product',
    search: 'Search',
    searchPlaceholder: 'Name, barcode…',
    searchHint: 'Server-side search (matches backend results)',
    category: 'Category',
    uncategorized: 'Uncategorized',
    uncategorizedFilterHint: 'Products missing a category or still assigned to Uncategorized',
    showArchived: 'Show archived',
    lowStockOnly: 'Low stock only',
    apply: 'Apply',
    clear: 'Clear',
    editProduct: 'Edit Product',
    adjustPricing: 'Adjust Pricing',
    justTCGFeed: 'JustTCG Feed',
    pricingHistory: 'Pricing History',
    archiveProduct: 'Archive Product',
    unarchiveProduct: 'Unarchive Product',
    archived: 'Archived',
    active: 'Active',
    justTCGSearch: 'JustTCG Search (type to search by card name)',
    productName: 'Product Name',
    cost: 'Cost',
    costCannotBeNegative: 'Cost cannot be negative',
    price: 'Price',
    profitMargin: 'Profit Margin',
    profitAmount: 'Profit Amount',
    barcodeOptional: 'Barcode (Optional)',
    lookUpBarcode: 'Look up barcode',
    importedImagePreview: 'Imported image preview',
    ingestPreviewImage: 'Ingest preview image',
    currentProductImage: 'Current product image',
    manageImages: 'Manage Images',
    quantity: 'Quantity',
    lowStockThreshold: 'Low Stock Threshold (Default)',
    description: 'Description',
    justTCGPrice: 'JustTCG Price',
    allowFractionalQuantities: 'Allow Fractional Quantities',
    ringByAmount: 'Ring by amount',
    ringByAmountHint: 'Cashier enters a dollar total at the register (e.g. fuel). Quantity is calculated from the unit price.',
    alwaysEnterQuantity: 'Always enter quantity',
    alwaysEnterQuantityHint: 'Prompts the cashier for quantity each time this product is added at the register.',
    openPrice: 'Open price',
    openPriceHint: 'Cashier enters unit price at the register (e.g. misc food). Catalog price and cost are optional. Each add creates a separate cart line.',
    openPriceCatalogPrice: 'Reference price (optional)',
    priceCannotBeNegative: 'Price cannot be negative',
    priceDecimalsThree: '3-decimal unit price',
    priceDecimalsThreeHint: 'Use for fuel and other items priced to the tenth of a cent (e.g. $3.459). Sale totals still use cents.',
    nonTaxable: 'Non-Taxable',
    convenienceFeeMode: 'Convenience fee',
    convenienceFeeModeInherit: 'Inherit from category',
    convenienceFeeModeApply: 'Apply fee',
    convenienceFeeModeExempt: 'Exempt from fee',
    convenienceFeeModeHint: 'Overrides the category setting for this product when set.',
    nonStockProduct: 'Non-Stock Product',
    includeInGrid: 'Include in register grid',
    includeInGridHint: 'Shows this product when staff drill into its category on the sales register. Ignored when the category has "Include all products in register grid" enabled. Does not affect products placed directly on the grid.',
    visibleOnStore: 'Show on Blu Store',
    visibleOnStoreHint: 'Lists this product on the retail storefront when Blu Store is enabled. Requires a URL slug.',
    storeSlug: 'Store URL slug',
    storeSlugHint: 'Lowercase path segment for /products/{slug}. Leave blank to auto-generate from the product name when visible on store.',
    storeBrand: 'Brand',
    storeBrandHint: 'Optional. Used for Blu Store brand filtering when set on the parent product.',
    storeCompareAt: 'Store compare-at price',
    storeCompareAtHint: 'Optional strikethrough on Blu Store only. Does not change POS original price or register pricing.',
    storeVariantsTitle: 'Store variants',
    storeVariantsHint: 'Single-level size/color (or custom) options for Blu Store. Each variant is a sellable SKU — use the barcode field; the storefront exposes it as SKU.',
    storeVariantsLoading: 'Loading variants…',
    storeVariantsOptionAxes: 'Option keys',
    storeVariantsAddAxis: 'Add key',
    storeVariantsBarcodeSku: 'Barcode (store SKU)',
    storeVariantsBarcodeSkuLabel: 'Store SKU / barcode',
    storeVariantsBarcodeSkuHelp: 'Optional. Saved as product barcode; Blu Store shows it as the variant SKU.',
    storeVariantsBarcodeSkuHint: 'Storefront SKU (optional)',
    storeVariantsReordering: 'Saving variant order…',
    storeVariantsReorderFailed: 'Could not save variant order',
    storeVariantsAddRow: 'Add variant',
    storeVariantsActions: 'Actions',
    storeVariantsSaved: 'Variant saved',
    storeVariantsSaveFailed: 'Could not save variant',
    storeVariantsRemoved: 'Variant archived',
    storeVariantsRemoveFailed: 'Could not archive variant',
    storeVariantsLoadFailed: 'Could not load variants',
    storeVariantsOptionsRequired: 'Enter at least one option value',
    storeVariantsFillAllAxes: 'Fill every option column for this variant',
    storeVariantsNewVariant: 'Variant',
    storeVariantsSaveParentFirst: 'Save the product first, then add store variants.',
    storeVariantsEnable: 'Manage store variants',
    storeVariantsManage: 'Manage store variants',
    storeVariantsManageHint: 'Open the dedicated variant matrix (sizes, SKUs, stock) for Blu Store.',
    storeVariantsManageOnParent: 'Manage variants on parent product',
    storeVariantsPageTitle: 'Store variants',
    storeVariantsBackToProducts: 'Back to products',
    storeVariantsEditParent: 'Edit parent product',
    storeVariantsLoadingParent: 'Loading product…',
    storeVariantsLoadParentFailed: 'Could not load this product',
    storeVariantsInvalidProduct: 'Invalid product',
    storeVariantsColumn: 'Store variants',
    storeVariantsCount: '{count} variants',
    storeVariantsStockAtsHint: '{sellable} sellable ({onHand} on hand, {reserved} in carts)',
    storeVariantChildBanner: 'This row is a store variant. Edit options, price, and stock from the parent product’s store variants page.',
    bonusLoyaltyPoints: 'Bonus Loyalty Points',
    loyaltyRedemptionSettings: 'Loyalty Redemption Settings',
    enableLoyaltyRedemption: 'Enable Loyalty Redemption',
    redemptionCostPoints: 'Redemption Cost (Points)',
    redemptionPreview: 'Redemption Preview',
    cancel: 'Cancel',
    save: 'Save',
    changeImage: 'Change Image',
    addImage: 'Add Image',
    removeImage: 'Remove Image',
    currentPrice: 'Current Price',
    lastUpdated: 'Last Updated',
    variant: 'Variant',
    linked: 'Linked',
    variantStatistics: 'Variant Statistics',
    metric: 'Metric',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    close: 'Close',
    newCost: 'New Cost',
    newPrice: 'New Price',
    newProfitMargin: 'New Profit Margin',
    newProfitAmount: 'New Profit Amount',
    operationType: 'Operation Type',
    notesOptional: 'Notes (Optional)',
    updatePricing: 'Update Pricing',
    priceAdjustment: 'Price Adjustment',
    costAdjustment: 'Cost Adjustment',
    purchase: 'Purchase',
    bulkUpdate: 'Bulk Update',
    vendorChange: 'Vendor Change',
    marketAdjustment: 'Market Adjustment',
    date: 'Date',
    oldCost: 'Old Cost',
    newCostCol: 'New Cost',
    costChange: 'Cost Change',
    oldPrice: 'Old Price',
    newPriceCol: 'New Price',
    priceChange: 'Price Change',
    notes: 'Notes',
    taxStatus: 'Tax Status',
    stock: 'Stock',
    redemption: 'Redemption',
    notRedeemable: 'Not Redeemable',
    status: 'Status',
    bonusPoints: 'Bonus Points',
    tableActions: 'Actions',
    newProductSubtitle: 'Add details, pricing, and inventory for a new catalog item.',
    editProductSubtitle: 'Update catalog fields, loyalty rules, and images.',
    sectionPricing: 'Pricing',
    sectionSelling: 'Selling & stock',
    sectionPhotos: 'Photos',
    sectionLoyalty: 'Loyalty',
    adjustPricingSubtitle: 'Set new cost and price and record how the change should appear in history.',
    pricingHistorySubtitle: 'Review past cost and price adjustments for this product.',
    justFeedDialogSubtitle: 'Market stats and recent price movement from JustTCG.',
    justVariantSearchHint: 'Selecting a variant will auto-fill Name, Description, and Price.',
    lowStockThresholdHint: 'Used for all locations unless overridden per location.',
    loyaltyRedeemToggleHint: 'Allow customers to redeem points for this product.',
    loyaltyRedemptionCostHint: 'Points required to redeem this product.',
    loyaltyBonusHint: 'Bonus points earned per unit when this product is purchased (0 = use standard earn rate).',
    redemptionPreviewPoints: 'Customers can redeem this product for {points} points.',
    redemptionPreviewExample: 'Example: With {examplePoints} points, a customer could redeem {count} unit(s).',
    noJustPriceHistory: 'No price history available.',
    noJustData: 'No data returned from JustTCG.',
    confirmArchiveTitle: 'Archive product?',
    confirmArchiveMessage: 'Archive “{name}”? You can unarchive it later.',
    confirmArchive: 'Archive',
    confirmUnarchiveTitle: 'Unarchive product?',
    confirmUnarchiveMessage: 'Restore “{name}” to active products?',
    confirmUnarchive: 'Unarchive',
    archivedSuccess: 'Product archived successfully',
    unarchivedSuccess: 'Product unarchived successfully',
    archiveFailed: 'Error archiving product',
    unarchiveFailed: 'Error unarchiving product',
    galleryTitle: 'Product images',
    gallerySubtitle: 'Upload, import, and organize cover and grid photos.',
    galleryUploadImage: 'Upload image',
    galleryUpload: 'Upload',
    galleryImportUrl: 'Import image URL',
    galleryImportUpc: 'Import UPC preview image',
    galleryNoImages: 'No images uploaded yet.',
    galleryCover: 'Cover',
    galleryGrid: 'Grid',
    gallerySortOrder: 'Sort order',
    galleryDelete: 'Delete',
    galleryLoadFailed: 'Could not load product images',
    galleryUploadFailed: 'Upload failed',
    galleryImportFailed: 'Import failed',
    galleryUpdateFailed: 'Could not update image',
    galleryDeleteFailed: 'Could not delete image',
    inventorySetup: 'Inventory Setup'
  },
  inventorySetup: {
    title: 'Inventory Setup',
    subtitle: 'Scan barcodes to receive stock or create new products quickly',
    locationLabel: 'Location: {name}',
    backToProducts: 'Back to Products',
    scanBarcode: 'Scan barcode',
    scanWithCamera: 'Scan with camera',
    incrementToggle: 'Increment existing items (+1)',
    incrementToggleHelp: 'When on, scanning a product already in your catalog adds 1 to stock without opening the form.',
    existingProduct: 'Existing product',
    newProduct: 'New product',
    productName: 'Product name',
    barcode: 'Barcode',
    currentStock: 'Current stock',
    addQuantity: 'Add quantity',
    initialStock: 'Initial stock',
    cost: 'Cost',
    price: 'Price',
    description: 'Description',
    importedImagePreview: 'Imported image preview',
    importImage: 'Import product image',
    clear: 'Clear',
    saveAndNext: 'Save & next scan',
    cancel: 'Cancel',
    cameraTitle: 'Scan with camera',
    cameraHelp: 'Point the camera at a barcode. Scanning stops automatically when a code is read.',
    cameraUnavailable: 'Camera is not available on this device.',
    cameraStartFailed: 'Could not start the camera. Try again or use a hardware scanner.',
    nameRequired: 'Product name is required',
    priceRequired: 'Price must be zero or greater',
    noLocation: 'Select a location before receiving inventory.',
    lookupNotFound: 'No product found for this barcode.',
    lookupRateLimit: 'Lookup limit reached. Try again later.',
    lookupFailed: 'Lookup failed. You can enter details manually.',
    nonStockIncrementWarning: 'This is a non-stock product. Enter details to continue.',
    incrementSuccess: '+1 {name} → stock {stock}',
    updatedSuccess: 'Updated {name} → stock {stock}',
    createdSuccess: 'Created: {name}',
    saveFailed: 'Could not save product'
  },
  categories: {
    title: 'Categories',
    subtitle: 'Organize products for browsing, reporting, and pricing',
    newCategory: 'New Category',
    categoryTree: 'Category Tree',
    details: 'Details',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    move: 'Move',
    delete: 'Delete',
    name: 'Name',
    slug: 'Slug',
    slugOptional: 'Slug (optional)',
    active: 'Active',
    includeAllProductsInGrid: 'Include all products in register grid',
    includeAllProductsInGridHint: 'When enabled, every product in this category appears when staff drill into the category on the sales register. When off, only products individually marked "Include in grid" appear.',
    icon: 'Icon',
    categoryColor: 'Category color',
    clear: 'Clear',
    imageUnavailable: 'Image unavailable',
    changeImage: 'Change Image',
    addImage: 'Add Image',
    removeImage: 'Remove Image',
    selectCategory: 'Select a category to view details.',
    newCategoryTitle: 'New Category',
    parentOptional: 'Parent (optional)',
    create: 'Create',
    moveCategory: 'Move Category',
    newParent: 'New Parent',
    selectImage: 'Select Image',
    saveImage: 'Save Image',
    close: 'Close',
    confirmDeleteTitle: 'Delete category',
    confirmDeleteMessage: 'Are you sure? This cannot be undone.',
    confirmDelete: 'Delete',
    finishEditsBeforeSwitch: 'Finish or cancel edits before switching categories',
    categoryUpdated: 'Category updated',
    categoryDeleted: 'Category deleted',
    categoryCreated: 'Category created',
    categoryMoved: 'Category moved',
    updateFailed: 'Update failed',
    deleteFailed: 'Delete failed',
    moveFailed: 'Move failed',
    createFailed: 'Create failed',
    imageSaved: 'Image saved',
    imageSaveFailed: 'Failed to save image',
    slugMaxLength: 'Max 64 characters',
    slugFormatHint: 'Lowercase letters, numbers, and hyphens only',
    convenienceFeeMode: 'Convenience fee',
    convenienceFeeModeInherit: 'Inherit',
    convenienceFeeModeApply: 'Apply fee',
    convenienceFeeModeExempt: 'Exempt from fee',
    convenienceFeeModeHint: 'Card convenience fees apply only when enabled on the gateway and this category (or an ancestor) is set to apply.'
  },
  modifiers: {
    title: 'Modifiers',
    subtitle: 'Manage modifier groups, modifiers, templates, and attachments',
    howModifiersWork: 'How modifiers work',
    newGroup: 'New Group',
    newModifier: 'New Modifier',
    newSet: 'New Set',
    groups: 'Groups',
    modifiers: 'Modifiers',
    sets: 'Sets',
    attachments: 'Attachments',
    searchGroups: 'Search groups',
    searchGroupsPlaceholder: 'Name, description…',
    searchModifiers: 'Search modifiers',
    searchModifiersPlaceholder: 'Name, code…',
    searchSets: 'Search sets',
    searchSetsPlaceholder: 'Name…',
    apply: 'Apply',
    clear: 'Clear',
    noModifierGroupsFound: 'No modifier groups found',
    noModifiersFound: 'No modifiers found',
    noSetsFound: 'No sets found',
    category: 'Category',
    product: 'Product',
    applySetOptional: 'Apply set (optional)',
    load: 'Load',
    applySet: 'Apply Set',
    noGroupsAttached: 'No groups attached',
    addGroup: 'Add Group',
    add: 'Add',
    save: 'Save',
    directAttachments: 'Direct Attachments',
    noDirectAttachments: 'No direct attachments',
    overrides: 'Overrides',
    inherit: 'Inherit',
    noOverrides: 'No overrides',
    addOverrideGroup: 'Add Override Group',
    productSearch: 'Product (search)',
    defineGroupSubtitle: 'Define selection rules and defaults for a modifier group',
    name: 'Name',
    descriptionInternal: 'Description (internal)',
    sortOrder: 'Sort order',
    visibility: 'Visibility',
    active: 'Active',
    selectionBehavior: 'Selection behavior',
    requiredChooseOne: 'Required (customer must choose one)',
    minimumSelections: 'Minimum selections',
    noMaximum: 'No maximum',
    maximumSelections: 'Maximum selections',
    addModifier: 'Add modifier',
    noModifiersInGroup: 'No modifiers in this group yet',
    modifiersInGroup: 'Modifiers in this group',
    cancel: 'Cancel',
    group: 'Group',
    modifier: 'Modifier',
    code: 'Code',
    priceAdjustment: 'Price adjustment',
    customModifierPrices: 'Custom modifier prices',
    customModifierPricesHint:
      'Overrides replace the catalog price adjustment for this product only. Leave the override blank to use the catalog default.',
    catalogDelta: 'Catalog default',
    overrideDelta: 'Override',
    overridePlaceholder: 'Override (blank = catalog)',
    customModifierPricesEmpty:
      'Load a product to see modifiers. Attach groups at the category or product level first.'
  },
  reports: {
    title: 'Reports',
    subtitle: 'Run reports and export results',
    inventoryLogs: 'Inventory Logs',
    pricingLogs: 'Pricing Logs',
    reportType: 'Report Type',
    from: 'From',
    to: 'To',
    timeWindow: 'Time Window',
    categories: 'Categories',
    allCategories: 'All Categories',
    run: 'Run',
    clear: 'Clear',
    loadFailed: "Couldn't load report",
    retry: 'Retry',
    results: 'Results',
    excel: 'Excel',
    csv: 'CSV',
    pdf: 'PDF',
    salesSummary: 'Sales Summary',
    paymentBreakdown: 'Payment Breakdown',
    inventoryDetail: 'Inventory Detail',
    loyaltySummary: 'Loyalty Summary',
    arAging: 'A/R Aging',
    salesByCategory: 'Sales by Category',
    customerPurchaseDetail: 'Customer Purchase Detail',
    category: 'Category',
    products: 'Products',
    allProducts: 'All products',
    noMatchingProducts: 'No matching products',
    openProductsDropdown: 'Open the dropdown to browse products',
    selectedProducts: 'Selected',
    moreProducts: '+{count} more',
    uncategorized: 'Uncategorized',
    customerPurchaseDetailPeriod: 'Period: {start} to {end}',
    reportPeriod: 'Period: {period}',
    noRows: 'No rows for this report.',
    columns: {
      date: 'Date',
      period: 'Period',
      total_sales: 'Total Sales',
      total_revenue: 'Total Revenue',
      goods_and_tips_total: 'Goods + Tips',
      tip_total: 'Tips',
      tax_total: 'Tax',
      cash_payment_total: 'Cash Payment',
      card_payment_total: 'Card Payment',
      convenience_fee_total: 'Convenience Fee',
      payment_method: 'Payment Method',
      total_payments: 'Total Payments',
      total_amount: 'Total Amount',
      cash_total: 'Cash Total',
      product_id: 'Product ID',
      product_name: 'Product',
      sku: 'SKU',
      starting_inventory: 'Starting Inventory',
      ending_inventory: 'Ending Inventory',
      net_movement: 'Net Movement',
      stock_in: 'Stock In',
      stock_out: 'Stock Out',
      unit_price: 'Unit Price',
      inventory_value: 'Inventory Value',
      low_stock: 'Low Stock',
      earned: 'Earned',
      redeemed: 'Redeemed',
      category_name: 'Category',
      quantity_sold: 'Quantity Sold',
      revenue: 'Revenue',
      customer_id: 'Customer ID',
      current: 'Current',
      d0_30: '1–30 Days',
      d31_60: '31–60 Days',
      d61_90: '61–90 Days',
      d90_plus: '90+ Days'
    },
    grandTotalQuantity: 'Total quantity',
    grandTotalSubtotal: 'Total subtotal',
    grandTotalTax: 'Total tax',
    grandTotalAmount: 'Total amount',
    customerPurchaseDetailEmpty: 'No purchase detail for the selected period and filters.',
    taxIdCustomersOnly: 'Tax ID customers only',
    groupByCustomer: 'Group by customer',
    colCustomer: 'Customer',
    colTaxId: 'Tax ID',
    customerTaxIdCaption: 'Tax ID: {taxId}',
    customerSubtotal: 'Customer subtotal',
    colSaleId: 'Sale #',
    colSaleDate: 'Date',
    colProduct: 'Product',
    colQuantity: 'Qty',
    colUnitPrice: 'Unit price',
    colSubtotal: 'Subtotal',
    colTax: 'Tax',
    colTotal: 'Total',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    suspendedSalesNav: 'Suspended sales',
    suspendedSalesTitle: 'Suspended sales',
    suspendedSalesSubtitle: 'Lane holds that are not yet checked out',
    suspendedSalesExportCsv: 'Export CSV',
    suspendedSalesGoToRegister: 'Sales register',
    suspendedSalesRegisterFilter: 'Register',
    suspendedSalesScopeLocationHint:
      'Your business allows resuming from any register at this location - the Register column shows where each sale was parked.',
    suspendedSalesEmpty: 'No suspended sales',
    suspendedSalesSuspendedBy: 'Suspended by',
    suspendedSalesCustomer: 'Customer',
    suspendedSalesCustomerId: 'Customer ID',
    suspendedSalesAbandon: 'Delete',
    suspendedSalesAbandonTitle: 'Delete suspended sale?',
    suspendedSalesAbandonMessage: 'Remove hold #{id}? This cannot be undone.',
    suspendedSalesAbandonDone: 'Suspended sale removed',
    suspendedSalesAbandonFailed: 'Could not remove suspended sale',
    suspendedSalesLoadFailed: 'Could not load suspended sales',
    suspendedSalesExportStarted: 'Download started',
    suspendedSalesExportFailed: 'Could not export CSV',
    suspendedSalesAbandonNoRegister: 'This row is missing register information',
    suspendedSalesNote: 'Note'
  },
  dev: {
    mockCardFlowPromptTitle: 'Mock card payment',
    mockCardFlowPromptBody: 'Approve to record a successful mock payment on your local API. Decline to cancel this step.',
    mockCardFlowApprove: 'Approve',
    mockCardFlowDecline: 'Decline',
    mockCardFlowDeclined: 'Mock card payment declined.',
    mockCardFlowGenericFlow: 'Card payment',
    mockCardFlowAmountLine: 'Amount: ${amount}',
    mockCardFlowActiveBanner: 'Mock card flow is on — payments are simulated locally; no gateway is used.',
    mockCardFlowStepTapToPay: 'Tap to Pay (mock)',
    mockCardFlowStepTerminal: 'Physical terminal (mock)',
    mockCardFlowStepKeyed: 'Keyed entry (mock)',
    mockCardFlowStepIntegrated: 'Integrated terminal (mock)',
    mockCardFlowStepCardOnFile: 'Card on file (mock)'
  },
  registers: {
    title: 'Registers',
    subtitle: 'Manage sales registers, status, terminals, and audit logs',
    newRegister: 'New Register',
    createRegisterTooltip: 'Create a new sales register',
    openRegisterElsewhere: 'You already have a register open in',
    closeRegisterFirst: 'Close that register (or switch back to that location) before opening a new one.',
    totalRegisters: 'Total Registers',
    active: 'Active',
    currentlyOpen: 'Currently Open',
    available: 'Available',
    search: 'Search',
    searchPlaceholder: 'Register name, terminal label…',
    status: 'Status',
    apply: 'Apply',
    clear: 'Clear',
    refreshTerminalStatus: 'Refresh terminal status',
    refreshRegisters: 'Refresh registers',
    open: 'Open',
    cardReader: 'Card Reader',
    viewDetails: 'View Details',
    edit: 'Edit',
    closeRegister: 'Close Register',
    openRegister: 'Open Register',
    manageTerminal: 'Manage Terminal',
    assignTerminal: 'Assign Terminal',
    auditLog: 'Audit Log',
    delete: 'Delete',
    noRegistersFound: 'No registers found',
    createFirstRegister: 'Create First Register',
    registerName: 'Register Name',
    description: 'Description',
    cancel: 'Cancel',
    update: 'Update',
    create: 'Create',
    registerDetails: 'Register Details',
    basicInformation: 'Basic Information',
    name: 'Name',
    location: 'Location',
    currentStatus: 'Current Status',
    currentUser: 'Current User',
    openedAt: 'Opened At',
    performanceMetrics: 'Performance Metrics',
    totalSales: 'Total Sales',
    totalRevenue: 'Total Revenue',
    avgTransaction: 'Avg Transaction',
    currentTerminal: 'Current Terminal',
    unknown: 'Unknown',
    unassignTerminal: 'Unassign Terminal',
    assignNewTerminal: 'Assign New Terminal',
    selectTerminal: 'Select Terminal',
    close: 'Close',
    auditEntries: 'Audit Entries',
    noAuditEntries: 'No audit entries found',
    statusAll: 'All',
    statusInactive: 'Inactive',
    statusMaintenance: 'Maintenance',
    cardPaymentMode: 'Card payment routing',
    cardPaymentModeHint: 'Pick one exclusive method per register.',
    cardPaymentModeAlwaysAsk: 'Let cashier choose',
    cardPaymentModePhysicalTerminalOnly: 'Physical terminal only',
    cardPaymentModeTapOnPhoneOnly: 'Tap on Phone only',
    cardPaymentModeKeyedOnly: 'Keyed card entry only',
    cardPaymentModeIntegratedOnly: 'Integrated Dejavoo terminal only (DvPay Lite)',
    cardPaymentTopDisabledAndroid: 'Use the Blu POS Android app for Tap on Phone.',
    cardPaymentTopDisabledIpad: 'Tap to Pay on iPhone is only available on a physical iPhone. Use another card method on iPad.',
    cardPaymentTopDisabledDevice: 'This iPhone model does not support Tap to Pay on iPhone. Use iPhone Xs or later.',
    cardPaymentTopDisabledOs: 'Update this iPhone to the latest iOS version to use Tap to Pay on iPhone.',
    cardPaymentTopDisabledConfig: 'Tap on Phone is not configured for this merchant.',
    cardPaymentTopDisabledDejavooTerminal: 'Tap on Phone is not used on Dejavoo payment terminals. Use integrated (DvPayLite) checkout instead.',
    cardPaymentIntegratedDisabledWhitelist: 'Add this device to the Dejavoo hardware whitelist before enabling integrated checkout.',
    cardPaymentIntegratedDisabledDeviceClass: 'Integrated (DvPayLite) checkout is only for whitelisted Dejavoo payment terminals.',
    cardPaymentKeyedDisabledGateway: 'Keyed entry is not enabled for your gateway.',
    cardPaymentKeyedDisabledEcomCapability: 'The assigned terminal does not have Ecom enabled.',
    cardPaymentKeyedDisabledDetail: '{detail}',
    cardPaymentIntegratedDisabledPlatform: 'Integrated terminal checkout requires the Blu POS Android app.',
    cardPaymentIntegratedDisabledCapability: 'The assigned terminal does not support integrated (DvPay Lite) checkout.',
    cardPaymentPhysicalDisabled: 'Assign a terminal that can accept physical-card payments.',
    cardPaymentModeOptionsFilteredNote: 'Unavailable options appear disabled below with a short reason.'
  },
  dashboard: {
    title: 'Dashboard',
    subtitle: "Today's performance and insights",
    refresh: 'Refresh',
    iphoneTopBanner: {
      title: 'Tap to Pay on iPhone',
      body: 'Accept contactless payments on this iPhone—no extra card reader. Finish one-time setup to start taking payments on the register.',
      ctaSetup: 'Set up Tap to Pay on iPhone',
      ctaAskAdmin: 'Ask a manager',
      learnMore: 'Learn more'
    },
    loadFailed: "Couldn't load dashboard",
    todaysSales: "Today's Sales",
    percentFromYesterday: 'from yesterday',
    productsSold: 'Products Sold',
    lowStockItems: 'Low Stock Items',
    needsAttention: 'Needs attention',
    allGood: 'All good',
    recentSales: 'Recent Sales',
    lowStock: 'Low Stock',
    products: 'Products',
    low: 'Low',
    status: 'Status',
    noSalesYet: 'No sales yet.',
    noLowStockItems: 'No low stock items.',
    lowStockOnHand: 'On hand: {count}',
    lowStockThreshold: 'Threshold: {count}',
    tableSaleNumber: 'Sale #',
    tableDate: 'Date',
    tableCustomer: 'Customer',
    tableTotal: 'Total',
    tableAmount: 'Amount',
    pulse: {
      ordersToday: '{count} orders today',
      vsLastWeekday: '{percent}% vs last {weekday}',
      updatedAgo: 'Updated {time}',
      updatedJustNow: 'Updated just now',
      allClear: 'All clear - nothing needs you right now.',
      attentionTitle: 'Needs attention',
      statusNeedsAttention: '{count} items need your attention',
      statusAhead: 'On pace - {percent}% ahead of last {weekday}',
      statusBehind: 'Slower day - {percent}% behind last {weekday}',
      statusEven: 'Even with last {weekday}',
      tiles: {
        registers: 'Registers',
        registersValue: '{open} of {active} open',
        orderAhead: 'Order ahead',
        orderAheadWaiting: '{count} waiting',
        orderAheadClear: 'Queue clear',
        openTabs: 'Open tabs',
        openTabsValue: '{count} · {balance}',
        lowStock: 'Low stock',
        lowStockValue: '{count} items'
      },
      attention: {
        lowStock: '{name} is low ({stock} left)',
        queueStale: 'Order waiting {minutes}+ min',
        noRegistersOpen: 'No registers open',
        openTabLiability: '{count} open tabs · {balance} outstanding'
      },
      weekdays: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday'
      },
      rhythmTitle: "Today's rhythm",
      rhythmSubtitle: 'Compared to last {weekday}',
      chartToday: 'Today',
      chartLastWeekday: 'Last {weekday}',
      chartRevenue: 'Revenue',
      chartOrders: 'Orders',
      goalProgressLabel: '{today} of {target} toward today’s goal',
      goalRingCaption: 'Daily goal',
      averageTicket: 'Average ticket',
      tipsToday: 'Tips today',
      topSellersTitle: 'Top sellers today',
      topSellerRow: '{rank}. {name} - {quantity}',
      topSellerQuantity: '{quantity} sold',
      noSalesYetToday: 'No sales yet today.',
      chartTooltipOrders: '{count} orders'
    }
  },
  events: {
    title: 'Events',
    subtitle: 'Create and manage events and registrations',
    createEvent: 'Create Event',
    editEvent: 'Edit Event',
    formSubtitle: 'Event details, schedule, location, and registration settings',
    detailSubtitle: 'Event details, registration links, and registrants',
    backToEvents: 'Back to Events',
    noEventsFound: 'No events found.',
    view: 'View',
    edit: 'Edit',
    unlimited: 'Unlimited',
    remaining: 'remaining',
    tickets: 'tickets',
    noLimit: 'No limit',
    free: 'Free',
    titleCol: 'Title',
    start: 'Start',
    end: 'End',
    status: 'Status',
    registrants: 'Registrants',
    capacity: 'Capacity',
    price: 'Price',
    copyLink: 'Copy link',
    downloadQr: 'Download QR',
    openPublic: 'Open public',
    publishToEnableLinks: 'Publish the event to enable public links',
    schedule: 'Schedule',
    location: 'Location',
    registrationLinks: 'Registration links',
    newLink: 'New link',
    noLinksYet: 'No links yet. Public slug link is always available.',
    customLink: 'Custom link',
    ticketPackages: 'Ticket packages',
    newPackage: 'New package',
    exportCsv: 'Export CSV',
    addRegistrant: 'Add registrant',
    resend: 'Resend',
    refund: 'Refund',
    addRegistrantTitle: 'Add registrant',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    cancel: 'Cancel',
    add: 'Add',
    newRegistrationLink: 'New Registration Link',
    freeLink: 'Free link',
    create: 'Create',
    packageName: 'Name',
    description: 'Description',
    quantity: 'Quantity',
    useDefaultTicketPrice: 'Use default ticket price',
    packagePrice: 'Package price',
    save: 'Save',
    deletePackage: 'Delete package',
    delete: 'Delete',
    confirmRefund: 'Confirm refund',
    refundRegistrant: 'Refund registrant',
    resendRegistrationEmail: 'Resend registration email',
    to: 'To',
    ccMe: 'CC me',
    send: 'Send',
    addressLine1: 'Address line 1',
    addressLine2: 'Address line 2',
    city: 'City',
    stateRegion: 'State/Region',
    postalCode: 'Postal Code',
    startRequired: 'Start time is required',
    capacityHint: 'Required unless marked no limit',
    noLimitToggle: 'No limit',
    showTicketsRemaining: 'Show tickets remaining on public page',
    publishHintCapacity: 'Switch to Draft and save before changing capacity, then re-publish when done.',
    priceHint: 'Required unless marked free',
    freeToggle: 'Free',
    publishHintPrice: 'Switch to Draft and save before changing price, then re-publish when done.',
    publishHintPriceCapacity: 'This event was published. Switch to Draft and save before changing price/capacity, then re-publish when done.',
    coverImage: 'Cover image',
    viewCurrent: 'View',
    current: 'Current',
    saveEvent: 'Save Event',
    draft: 'Draft',
    published: 'Published',
    cancelled: 'Cancelled',
    loading: 'Loading...',
    nameRequired: 'Name is required',
    registrantAdded: 'Registrant added',
    registrantRefunded: 'Registrant refunded',
    eventSaved: 'Event saved',
    registrationEmailSent: 'Registration email sent',
    unableToSendEmail: 'Unable to send registration email',
    qty: 'Qty',
    amount: 'Amount',
    package: 'Package',
    registered: 'Registered',
    actions: 'Actions',
    noPackagesYet: 'No packages yet.',
    noRegistrantsYet: 'No registrants yet.',
    manualRegistrationsHint: 'Manual registrations do not collect payment; this is for attendance tracking only.',
    editTicketPackage: 'Edit ticket package',
    newTicketPackage: 'New ticket package',
    defaultTicketPrice: 'Default ticket price',
    deletePackageConfirm: 'Delete "{name}"? This can\'t be undone.',
    refundConfirmMessage: 'Refunding will mark the registrant as refunded and free up their spot. Continue?',
    refundCannotUndone: 'Refunds cannot be undone here; re-register to add them back.',
    packagePriceHint: 'If "Use default ticket price" is enabled, the package price is computed as event price × quantity.'
  },
  groups: {
    title: 'Groups',
    subtitle: 'Manage customer groups and ownership',
    detailTitle: 'Group profile',
    editGroup: 'Edit group',
    editGroupTitle: 'Edit group',
    editGroupSubtitle: 'Update owner, status, and billing contact as needed',
    noAddressOnFile: 'No address on file',
    contactSameAsOwner: 'Billing & contact same as group owner',
    contactSameAsOwnerHint: 'We’ll copy email, phone, and address from the owner when you save.',
    contactSameAsOwnerPickOwner: 'Choose an owner to use their contact details.',
    contactSameAsOwnerBadge: 'Matches group owner’s contact info',
    customContactHint: 'Use a different billing email, phone, or address for this group.',
    ownerContactIncomplete: 'This customer has no email, phone, or address on file yet.',
    ownerContactLoadFailed: 'Could not load owner contact details',
    newGroup: 'New Group',
    searchGroups: 'Search groups',
    searchPlaceholder: 'Search by group name…',
    activeOnly: 'Active only',
    apply: 'Apply',
    clear: 'Clear',
    loadFailed: "Couldn't load groups",
    retry: 'Retry',
    status: 'Status',
    tableActions: 'Actions',
    viewGroup: 'View group',
    noGroupsFound: 'No groups found.',
    noGroupsHint: 'Create a group to share tabs and billing across customers.',
    createGroup: 'Create Group',
    createGroupSubtitle: 'Choose an owner — billing contact defaults from their profile',
    basicDetails: 'Basic details',
    ownership: 'Ownership',
    name: 'Name',
    nameOptional: 'Name (optional)',
    notes: 'Notes',
    ownerOptional: 'Owner (optional)',
    ownerRequired: 'An owner customer is required.',
    createFailed: 'Failed to create group',
    active: 'Active',
    cancel: 'Cancel',
    save: 'Save',
    membersHint: 'Customers who can run tabs under this group.',
    noMembers: 'No members yet. Search above to add customers.',
    removeMember: 'Remove member',
    removeMemberConfirm: 'Remove {name} from this group?',
    memberRemoved: 'Member removed',
    unnamedGroup: 'Unnamed Group',
    groupId: 'Group #',
    inactive: 'Inactive',
    back: 'Back',
    contact: 'Contact',
    website: 'Website',
    address: 'Address',
    addressLine1: 'Address line 1',
    addressLine2: 'Address line 2',
    city: 'City',
    stateRegion: 'State / Region',
    postalCode: 'Postal code',
    country: 'Country',
    owner: 'Owner',
    members: 'Members',
    addMember: 'Add member',
    add: 'Add',
    runningTotals: 'Running Totals',
    perMemberTotals: 'Per-Member Running Totals (Open Group Tabs)',
    noRunningTotals: 'No running totals available.',
    customer: 'Customer',
    charges: 'Charges',
    credits: 'Credits',
    net: 'Net',
    groupSaved: 'Group saved',
    failedToSaveGroup: 'Failed to save group',
    viewDevLog: 'View dev log',
    hideDevLog: 'Hide dev log',
    billingPortal: {
      title: 'Group billing account',
      notEligible: 'Set an active owner and billing email to enable the account portal for this group.',
      missingEmail: 'Add a billing email on this group to send an account portal sign-in link.',
      emailConflict: 'That billing email is already tied to another customer. Fix the duplicate before sending a group link.',
      inactive: 'Activate this group before sending a billing portal link.',
      neverInvited: 'Billing contact can sign in to pay group invoices — no link sent yet.',
      linkSent: 'Sign-in link sent — not used yet',
      linkSentAt: 'Last link sent {date}',
      active: 'Billing contact has signed in to the account portal',
      lastSignIn: 'Last sign-in {date}',
      sendLink: 'Send account link',
      resendLink: 'Resend account link',
      sendSuccess: 'Account portal link emailed to the group billing address.',
      sendFailed: 'Could not send the account portal link.',
      firstInviteTitle: 'Send first account link?',
      firstInviteMessage: 'This billing address has not received a group account link before. Only send if they asked you to (for example in store or by phone). The email opens group-scoped billing in My Account, not a marketing message.',
      firstInviteConfirm: 'Send link'
    },
    member: 'Member',
    customerId: 'Customer #'
  },
  tabs: {
    title: 'Tabs',
    subtitle: 'Monitor open tabs and manage balances',
    exportCsv: 'Export CSV',
    exportXlsx: 'Export Excel',
    export: 'Export',
    failedToExportXlsx: 'Failed to export Excel',
    newTab: 'New Tab',
    location: 'Location',
    status: 'Status',
    search: 'Search',
    searchPlaceholder: 'Customer, group, or tab #',
    apply: 'Apply',
    clear: 'Clear',
    creditDisplay: 'Cr {amount}',
    viewTab: 'View tab',
    payTabAtRegister: 'Pay Tab at register',
    tab: 'Tab',
    tabNumber: 'Tab #{id}',
    moreActions: 'More',
    addEntrySubtitle: 'Charge, credit, or adjustment',
    entryType: 'Entry type',
    entryTypeCharge: 'Charge to tab',
    entryTypeCredit: 'Credit / payment',
    entryTypeAdjustment: 'Adjustment',
    amountLabel: 'Amount',
    amountHint: 'Required — amount to charge or credit',
    amountRequired: 'Amount is required.',
    taxOptional: 'Tax (optional)',
    quantity: 'Quantity',
    description: 'Description',
    chargeToTabTitle: 'Charge to Tab',
    chargeToTabHint: 'Choose an open tab or create a new one',
    selectExistingTab: 'Select existing tab',
    chooseOpenTab: 'Choose an open tab',
    openTabsCustomerHint: 'Only open tabs for this customer are listed.',
    createNewTab: 'Create new tab',
    chargeAmount: 'Charge amount',
    cartTotal: 'Cart total',
    chargeSelectedTab: 'Charge selected tab',
    createTabAndCharge: 'Create tab and charge',
    posChargeDefault: 'POS charge',
    customerLabel: 'Customer',
    customerNumber: 'Customer #{id}',
    generateLinkTitle: 'Generate payment link',
    generateLinkSubtitle: 'Link expires in 7 days',
    generateLinkFailed: 'Failed to generate link',
    maxPaymentOptional: 'Max payment amount (optional)',
    linkClickCopy: 'Link (click to copy)',
    clickToCopy: 'Click to copy',
    copied: 'Copied!',
    copyFailed: 'Copy failed',
    copyNotSupported: 'Copy not supported',
    copySecureContextRequired: 'Clipboard access requires a secure context (HTTPS).',
    copyManual: 'Unable to copy. Please copy manually.',
    linkCopied: 'Payment link copied to clipboard.',
    generate: 'Generate',
    close: 'Close',
    emailLinkTitle: 'Email payment link',
    recipientEmail: 'Recipient email',
    recipientEmailRequired: 'Recipient email is required.',
    subjectOptional: 'Subject (optional)',
    send: 'Send',
    emailLinkSent: 'Payment link emailed.',
    emailLinkFailed: 'Failed to send payment link.',
    ledgerWhen: 'When',
    ledgerType: 'Type',
    ledgerCustomer: 'Customer',
    ledgerDescription: 'Description',
    ledgerQty: 'Qty',
    ledgerAmount: 'Amount',
    ledgerStatus: 'Status',
    ledgerVoided: 'Voided',
    voidEntry: 'Void',
    restoreEntry: 'Restore',
    voidEntryConfirmTitle: 'Void ledger entry?',
    voidEntryConfirmMessage: 'This entry will be excluded from tab totals but kept in the ledger for audit.',
    restoreEntryConfirmTitle: 'Restore ledger entry?',
    restoreEntryConfirmMessage: 'This entry will count toward tab totals again.',
    voidEntrySuccess: 'Entry voided.',
    voidEntryFailed: 'Could not void entry.',
    restoreEntrySuccess: 'Entry restored.',
    restoreEntryFailed: 'Could not restore entry.',
    owner: 'Owner',
    people: 'People',
    opened: 'Opened',
    lastActivity: 'Last Activity',
    currentTotal: 'Current Total',
    payments: 'Payments',
    balance: 'Balance',
    daysOpen: 'Days Open',
    actions: 'Actions',
    group: 'Group',
    customer: 'Customer',
    allLocations: 'All Locations',
    all: 'All',
    open: 'Open',
    closed: 'Closed',
    suspended: 'Suspended',
    writtenOff: 'Written off',
    openTabs: 'Open Tabs',
    tabsList: 'Tabs',
    addEntry: 'Add entry',
    generateLink: 'Generate link',
    paymentLink: 'Payment link',
    paymentLinkTitle: 'Payment link',
    paymentLinkEmailSection: 'Email link (optional)',
    emailLink: 'Email link',
    payTab: 'Pay Tab',
    payTabTooltip: 'Open the Sales Register to pay this tab',
    closeTab: 'Close tab',
    tabActions: 'Tab actions',
    markClosed: 'Mark closed',
    markClosedConfirmTitle: 'Mark tab closed?',
    markClosedConfirmMessage: 'This closes the tab when the balance is zero. Continue?',
    tabClosedSuccess: 'Tab closed',
    tabClosedFailed: 'Could not close tab',
    editTabName: 'Edit tab name',
    editWalkInBarTabNote: 'Edit tab note',
    walkInBarTabNoteTitle: 'Tab note',
    walkInBarTabNoteHint: 'Optional label to help identify this walk-in bar tab (for example, jacket color or seat).',
    editCreditLimit: 'Edit credit limit',
    creditLimitLabel: 'Credit limit',
    noCreditLimit: 'No limit',
    creditLimitInvalid: 'Enter a valid credit limit amount',
    tabUpdated: 'Tab updated',
    tabUpdateFailed: 'Could not update tab',
    noBalanceDue: 'No balance due',
    balanceLabel: 'Balance',
    summary: 'Summary',
    netChargesLabel: 'Net charges',
    storeCreditsLabel: 'Store credits',
    creditOnTabLabel: 'Credit on tab',
    currentTotalLabel: 'Current total',
    paymentsLabel: 'Payments',
    balanceLabelAlt: 'Balance',
    groupOwnedTab: 'Group-owned tab',
    customerOwnedTab: 'Customer-owned tab',
    groupOwner: 'Group owner',
    participants: 'Participants',
    addCustomerToTab: 'Add customer to tab',
    add: 'Add',
    ledger: 'Ledger',
    openNewTab: 'Open New Tab',
    chooseOwner: 'Choose a customer or group owner',
    ownerType: 'Owner type',
    creditLimitOptional: 'Credit limit (optional)',
    creditLimitHint: 'Set a maximum balance for this tab',
    ownerDescription: 'The owner can be an individual customer or a customer group. You can change or close the tab later from the Tabs page.',
    openTab: 'Open tab',
    secureTabWithCard: 'Secure tab with card',
    secureTabWithCardHint: 'Optionally validate or add a card on file for this tab.',
    cardSetupDescription: 'Add a card on file to secure this tab. You can validate an existing saved card or skip to add one when the customer pays via payment link.',
    validateSavedCard: 'Validate saved card',
    noSavedCardHint: 'No saved card for this customer. Customer can add a card when paying via payment link.',
    skip: 'Skip',
    cardValidated: 'Card validated successfully',
    cardSaved: 'Card saved for tab',
    tapCardAtTerminal: 'Tap card at terminal',
    tapCardAtTerminalHint: 'Customer taps, inserts, or swipes card on the physical terminal',
    openAsBarTab: 'Bar tab (same-day, card required)',
    openAsBarTabHint: 'Customer must verify a card before charges post. Skip is not available.',
    openAsBarTabHintOptional: 'Optionally verify a card when opening the tab. You can skip if no card is needed.',
    barTabCardSetupDescription: 'Verify the customer\'s card for this bar tab-tap at the terminal, validate a saved card, or add a card before ringing items.',
    barTabBadge: 'Bar tab',
    barTabCardRequired: 'Bar tab · Card required',
    barTabVerified: 'Bar tab · Verified',
    barTabSameDayExpired: 'Same-day expired',
    barTabSameDayChargeBlocked: 'This bar tab can only receive charges on the same calendar day it was opened.',
    openingPreauthLabel: 'Opening card hold',
    cofVerifiedBadge: 'Card verified',
    cofNotVerifiedBadge: 'Card not verified',
    cofNoneBadge: 'No cards on file',
    cofCountBadge: '{count} card(s) on file',
    manageCardsOnFile: 'Manage cards on file',
    chargeSavedCard: 'Charge saved card',
    chargeSavedCardConfirmTitle: 'Charge card on file?',
    chargeSavedCardConfirmMessage: 'This will charge the customer\'s saved card for the full tab balance ({amount}). Use when the patron could not pay in person.',
    chargeSavedCardSuccess: 'Card charged successfully',
    chargeSavedCardFailed: 'Could not charge saved card',
    convert: {
      action: 'Convert to invoice',
      title: 'Convert tab to invoice',
      subtitle: 'Issue an invoice for a date range and move the balance to AR.',
      startDate: 'Start date',
      endDate: 'End date',
      createInvoice: 'Create invoice',
      invoiceTotal: 'Invoice total',
      appliedPaymentsNote: 'Includes {amount} of tab payments applied to this period.',
      previewFailed: 'Could not load conversion preview.',
      success: 'Invoice created from tab.',
      failed: 'Could not convert tab to invoice.',
      lineFallback: 'Tab charge',
      colTransactionDate: 'Date',
      paymentLinkToggle: 'Create invoice for period and send invoice payment link',
      paymentLinkHint: 'Creates an issued invoice for the selected dates and returns an invoice payment link (not a tab portal link).',
      paymentLinkSubtitle: 'Invoice payment link for selected period'
    },
    statement: {
      title: 'Tab Statement',
      subtitle: 'Active ledger entries and balance summary',
      viewStatement: 'View statement',
      statement: 'Statement',
      print: 'Print',
      email: 'Email',
      text: 'Text',
      emailTitle: 'Email tab statement',
      textTitle: 'Text tab statement',
      exportCsv: 'Export CSV',
      exportXlsx: 'Export Excel',
      exportCsvSuccess: 'Tab statement exported as CSV',
      exportXlsxSuccess: 'Tab statement exported as Excel',
      exportCsvFailed: 'Failed to export tab statement CSV',
      exportXlsxFailed: 'Failed to export tab statement Excel',
      downloadPdf: 'PDF',
      downloadPdfFailed: 'Unable to download tab statement PDF',
      loadFailed: 'Unable to load tab statement',
      emailSuccess: 'Tab statement emailed',
      emailFailed: 'Unable to send tab statement email',
      textSuccess: 'Tab statement texted',
      textFailed: 'Unable to send tab statement text',
      printFailed: 'Unable to share tab statement PDF',
      thermalFallback: 'Thermal printer unavailable; use browser print instead',
      phoneRequired: 'Phone number is required',
      phoneUsOnly: 'SMS can only be sent to US phone numbers',
      owner: 'Owner',
      startedOn: 'Started on',
      printedOn: 'Printed on',
      chargedOn: 'Charged on',
      undatedCharges: 'Undated charges',
      barTab: 'Bar tab',
      charges: 'Charges',
      credits: 'Credits',
      paymentsLabel: 'Payments to date',
      netChargesLabel: 'Net charges',
      currentTotalLabel: 'Current total',
      balanceDue: 'Balance due',
      balanceDueHint: 'This amount has not been paid yet.',
      creditBalance: 'Credit balance',
      noBalanceDue: 'No balance due',
      paymentsSection: 'Payments'
    },
    cardSetupMethodSavedCard: 'Saved card',
    cardSetupMethodNewCard: 'New card',
    cardSetupMethodKeyedEntry: 'Keyed entry',
    selectSavedCard: 'Select saved card',
    verifyCardWithKeyedEntry: 'Verify card (keyed entry)',
    verifyCardAction: 'Verify card',
    unverifiedBarTabBanner: 'This bar tab requires a verified card on file before charges can be posted.',
    optionalBarTabBanner: 'No card on file yet. You can still post charges, or verify a card to secure this tab.',
    cardSetupCancel: 'Cancel',
    cardSetupFailed: 'Card verification failed',
    cardSetupSaveModeTitle: 'Save card on file',
    cardSetupSaveModeMessage: 'This customer already has saved cards. How should the new card be saved?',
    cardSetupSaveModeAdd: 'Add as additional card',
    cardSetupSaveModeReplaceDefault: 'Replace default card',
    cardSetupSaveModeReplaceSpecific: 'Replace a specific card',
    selectCardToReplace: 'Select card to replace',
    chargeSavedCardSelectTitle: 'Select card to charge',
    barTabNoCardOptionsHint: 'No saved card or terminal available. Use keyed entry, integrated reader, or configure a SPIn terminal.',
    continue: 'Continue',
    failedToExportCsv: 'Failed to export CSV',
    clearCurrentSale: 'Clear current sale?',
    clearCartMessage: 'The Sales Register currently has items in the cart. Paying this tab is a standalone transaction and will clear those items. Do you want to proceed?',
    proceedAndClearCart: 'Proceed and clear cart',
    cancel: 'Cancel',
    failedToClearCart: 'Failed to clear current cart; cannot start tab payment.',
    unableToVerifyCart: 'Unable to verify current cart contents. Proceeding will start a standalone tab payment.'
  },
  leads: {
    title: 'Leads',
    subtitle: 'Intake form submissions',
    formSettings: 'Form Settings',
    status: 'Status',
    product: 'Product',
    from: 'From',
    to: 'To',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    date: 'Date',
    view: 'View',
    convertToCustomer: 'Convert to customer',
    leadDetails: 'Lead Details',
    address: 'Address',
    message: 'Message',
    all: 'All',
    productSearchHint: 'Type at least {count} characters to search products',
    productSearchMinChars: 'Enter at least {count} characters to search',
    productSearchNoResults: 'No matching products',
    search: 'Search',
    exportCsv: 'Export CSV',
    exportSuccess: 'Leads exported',
    exportFailed: 'Failed to export leads',
    new: 'New',
    contacted: 'Contacted',
    converted: 'Converted',
    closed: 'Closed',
    failedToLoad: 'Failed to load leads',
    statusUpdated: 'Status updated',
    failedToUpdate: 'Failed to update',
    failedToLoadDetails: 'Failed to load details',
    convertTitle: 'Convert to Customer',
    convertMessage: 'Create a customer from {name}?',
    customerCreated: 'Customer created',
    failedToConvert: 'Failed to convert'
  },
  taxSettings: {
    title: 'Tax Settings',
    subtitle: 'Manage location tax rules and run backend-accurate tax previews',
    backToSettings: 'Back to Settings',
    location: 'Location',
    bannerText: 'Tax rates are additive. Excluded categories take precedence over included categories.',
    ruleName: 'Rule Name',
    ratePercent: 'Rate (%)',
    priority: 'Priority',
    active: 'Active',
    saveRule: 'Save Rule',
    includeCategories: 'Include Categories',
    excludeCategories: 'Exclude Categories',
    cancelEdit: 'Cancel Edit',
    refresh: 'Refresh',
    includes: 'Includes',
    excludes: 'Excludes',
    inactive: 'Inactive',
    noRulesYet: 'No tax rules for this location yet.',
    taxRuleSaved: 'Tax rule saved.',
    failedToSaveRule: 'Failed to save tax rule.',
    taxRuleDeleted: 'Tax rule deleted.',
    failedToDeleteRule: 'Failed to delete tax rule.',
    failedToLoad: 'Failed to load tax settings: {error}'
  },
  integrations: {
    title: 'Integrations',
    subtitle: 'Connect loyalty, data feeds, and third-party services',
    refresh: 'Refresh',
    backToSettings: 'Back to Settings',
    errorBanner: "Some integration statuses couldn't be loaded. You can still open an integration to configure it.",
    astroLoyalty: 'Astro Loyalty',
    astroDescription: 'Frequent buyer, offers, coupons, and points',
    justTCG: 'JustTCG',
    justTCGDescription: 'Trading card data and pricing feed',
    installed: 'Installed',
    notInstalled: 'Not Installed',
    configure: 'Configure'
  },
  staffDirectory: {
    title: 'Staff',
    subtitle: 'Service providers, linked users, and availability',
    backToSettings: 'Back to Settings',
    open: 'Open Staff',
    settingsTileHint: 'Manage bookable providers and weekly hours',
    linkedUser: 'Linked user',
    serviceProviderSection: 'Service provider profile',
    offersBookableServices: 'Offers bookable services',
    manageAvailability: 'Manage availability'
  },
  adminUsers: {
    title: 'User Management',
    subtitle: 'Invite your team and manage access',
    manageRoles: 'Manage Roles',
    newUser: 'New User',
    backToSettings: 'Back to Settings',
    loadError: 'Failed to load users. Please refresh and try again.',
    search: 'Search',
    searchPlaceholder: 'Name or email...',
    roles: 'Roles',
    rolesPlaceholder: 'Filter by roles',
    apply: 'Apply',
    clear: 'Clear',
    users: 'Users',
    noUsersFound: 'No users found.',
    editUser: 'Edit User',
    createUser: 'Create User',
    name: 'Name',
    email: 'Email',
    passwordOptional: 'Password (optional)',
    cancel: 'Cancel',
    save: 'Save',
    actions: 'Actions',
    failedToLoad: 'Failed to load users',
    userUpdated: 'User updated',
    userCreated: 'User created',
    userDeleted: 'User deleted',
    saveFailed: 'Save failed',
    deleteFailed: 'Delete failed'
  },
  adminRoles: {
    title: 'Roles',
    subtitle: 'Define role abilities and system access',
    newRole: 'New Role',
    backToSettings: 'Back to Settings',
    loadError: 'Failed to load roles. Please refresh and try again.',
    search: 'Search',
    searchPlaceholder: 'Name or title...',
    type: 'Type',
    apply: 'Apply',
    clear: 'Clear',
    roles: 'Roles',
    noRolesFound: 'No roles found.',
    editRole: 'Edit Role',
    createRole: 'Create Role',
    name: 'Name',
    titleLabel: 'Title',
    abilities: 'Abilities',
    cancel: 'Cancel',
    save: 'Save',
    actions: 'Actions',
    system: 'System',
    custom: 'Custom',
    all: 'All',
    failedToLoad: 'Failed to load roles',
    roleUpdated: 'Role updated',
    roleCreated: 'Role created',
    roleDeleted: 'Role deleted',
    saveFailed: 'Save failed',
    deleteFailed: 'Delete failed'
  },
  shared: {
    switchLocation: 'Switch Location',
    selectLocation: 'Select Location',
    manageLocations: 'Manage Locations',
    manageLocationsCaption: 'Add, edit, or remove locations',
    switchedTo: 'Switched to {name}',
    registerOpenInLocation: 'You already have a register open in {location}. {action}',
    closeBeforeSwitch: 'Close it before switching locations.',
    removeCustomer: 'Remove Customer',
    openInAstro: 'Open in Astro',
    searchCustomer: 'Search Customer',
    groupMember: 'Group member',
    noCustomersFound: 'No customers found',
    typeToSearchCustomers: 'Type to search customers by name, email, or phone.',
    searchingCustomers: 'Searching…',
    openDropdownForRecentCustomers: 'Open the search dropdown to view recent customers.',
    newCustomer: 'New Customer',
    noCustomersYet: 'No customers yet',
    recentCustomers: 'Recent Customers',
    quickAddSubtitle: 'Quick add while selecting a customer',
    firstName: 'First Name',
    lastName: 'Last Name',
    firstNameRequired: 'First name is required',
    lastNameRequired: 'Last name is required',
    suffixOptional: 'Suffix (Optional)',
    suffixPlaceholder: 'Jr., Sr., III, etc.',
    email: 'Email',
    emailRequired: 'Email is required',
    invalidEmail: 'Invalid email format',
    phone: 'Phone',
    phoneRequired: 'Phone is required',
    cancel: 'Cancel',
    ok: 'OK',
    create: 'Create',
    customer: 'Customer',
    group: 'Group',
    failedToCreateCustomer: 'Failed to create customer',
    customers: 'Customers',
    phoneNumbers: 'Phone Numbers',
    addPhone: 'Add Phone',
    primary: 'Primary',
    editPhone: 'Edit Phone',
    deletePhone: 'Delete Phone',
    noPhonesYet: 'No phone numbers added yet',
    editPhoneTitle: 'Edit Phone',
    addPhoneTitle: 'Add Phone',
    phoneNumber: 'Phone Number',
    phoneRequiredValidation: 'Phone number is required',
    labelOptional: 'Label (optional)',
    labelPlaceholder: 'e.g., Mobile, Work, Home',
    setPrimaryPhone: 'Set as primary phone',
    save: 'Save',
    confirmDelete: 'Confirm Delete',
    confirmDeletePhone: 'Are you sure you want to delete {phone}?',
    phoneUpdated: 'Phone updated successfully',
    phoneAdded: 'Phone added successfully',
    phoneDeleted: 'Phone deleted successfully',
    failedToLoadPhones: 'Failed to load phones',
    errorSavingPhone: 'Error saving phone',
    errorDeletingPhone: 'Error deleting phone',
    emailAddresses: 'Email Addresses',
    addEmail: 'Add Email',
    editEmail: 'Edit Email',
    deleteEmail: 'Delete Email',
    noEmailsYet: 'No email addresses added yet',
    editEmailTitle: 'Edit Email',
    addEmailTitle: 'Add Email',
    emailAddress: 'Email Address',
    emailLabelPlaceholder: 'e.g., Work, Personal',
    setPrimaryEmail: 'Set as primary email',
    confirmDeleteEmail: 'Are you sure you want to delete {email}?',
    emailUpdated: 'Email updated successfully',
    emailAdded: 'Email added successfully',
    emailDeleted: 'Email deleted successfully',
    failedToLoadEmails: 'Failed to load emails',
    errorSavingEmail: 'Error saving email',
    errorDeletingEmail: 'Error deleting email',
    taxPreview: 'Tax Preview',
    previewLocation: 'Preview Location',
    previewBanner: 'Preview uses the same tax calculation as checkout.',
    product: 'Product',
    qty: 'Qty',
    unitPrice: 'Unit Price',
    lineDiscount: 'Line Discount',
    discountType: 'Discount Type',
    runPreview: 'Run Preview',
    previewTotals: 'Preview Totals',
    subtotal: 'Subtotal',
    tax: 'Tax',
    grandTotal: 'Grand Total',
    taxBreakdown: 'Tax Breakdown',
    rate: 'Rate',
    base: 'Base',
    noTaxComponents: 'No tax components returned for this preview.',
    fixed: 'Fixed ($)',
    percentage: 'Percent (%)',
    taxable: 'taxable',
    nonTaxable: 'non-taxable',
    selectPaymentTerminal: 'Select Payment Terminal',
    terminalRequired: 'Terminal is required',
    noTerminalsAvailable: 'No terminals available',
    contactAdminForTerminals: 'Contact your administrator to set up payment terminals',
    chooseLocationForPreview: 'Choose a location to run tax preview.',
    chooseProductForPreview: 'Choose a product to run tax preview.',
    quantityMustBePositive: 'Quantity must be greater than 0.',
    previewLocationUnavailable: 'Selected preview location is unavailable.',
    switchedForPreview: 'Switched current location to {name} for backend-accurate preview.',
    failedToRunPreview: 'Failed to run tax preview.'
  },
  error: {
    nothingHere: 'Oops. Nothing here...',
    pageNotFound: 'The page you\'re looking for doesn\'t exist.',
    goHome: 'Go Home'
  },
  payments: {
    title: 'Payment Processing',
    subtitle: 'Manage gateways and terminal configuration',
    backToSettings: 'Back to Settings',
    connextPayMx: 'ConnextPay / Mx',
    connextPayMxDesc: 'Manage Mx Merchant configuration',
    dejavoo: 'Dejavoo',
    dejavooDesc: 'View Dejavoo payment setup status and assign terminals to registers',
    iphoneTopSetupDesc: 'Register this iPhone for Apple Tap to Pay and link it to Blu',
    backToPayments: 'Back to Payments',
    gateway: {
      colGateway: 'Gateway',
      colStatus: 'Status',
      settlementStatus: 'Settlement: {status}',
      viewTimeline: 'Gateway events',
      timelineTitle: 'Payment gateway activity',
      timelineLoadFailed: 'Could not load gateway transaction details.',
      klarnaRequestId: 'Klarna payment request',
      referenceKlarnaRequest: 'Klarna request {id}',
      referenceProcessor: '{gateway} reference {id}',
      processorReference: '{gateway} reference',
      noEvents: 'No gateway events recorded yet.',
      filterAll: 'All gateways',
      filterKlarna: 'Klarna only',
      status: {
        pending: 'Pending',
        approved: 'Approved',
        settled: 'Settled',
        declined: 'Declined',
        error: 'Error',
        created: 'Created',
        voided: 'Voided',
        refunded: 'Refunded',
      },
    },
    dejavooSettings: {
      pageSubtitleReadOnly: 'Payment processor configuration is managed by Blu. Assign terminals to registers below.',
      adminManagedBanner: 'Gateway credentials and terminals are configured by Blu support. You can still manage convenience fees below.',
      readinessTitle: 'Setup readiness',
      readinessLead: 'Green checks mean that track is ready for use. Warnings or errors may block Tap to Pay, keyed entry, or card-present flows.',
      readinessAllClear: 'All payment tracks are ready.',
      readinessIncomplete: 'One or more payment tracks are not ready yet. Resolve the items above or contact Blu support for gateway credentials.',
      summaryTitle: 'Configuration summary',
      summaryLead: 'Non-secret settings for this merchant (managed by Blu).',
      configured: 'Configured',
      notConfigured: 'Not configured',
      scenarioCnp: 'Online / keyed (CNP)',
      scenarioCardPresent: 'Card present (SPIn)',
      scenarioTapOnPhone: 'Tap to Pay (Android)',
      scenarioBnpl: 'Klarna BNPL (web)',
      assignmentsTitle: 'Registers and terminals',
      assignmentsLead: 'You can assign existing terminals to sales registers. Adding or editing processor credentials requires Blu Admin.',
      openRegisters: 'Open register management',
      pageSubtitle: 'Merchant ID, SPIn API auth, FTD, Google Pay, convenience fees, keyed entry, and terminals',
      loadFailed: 'Could not load payment settings. Refresh the page and try again.',
      sectionFtd: 'Dejavoo gateway',
      sectionFtdLead: 'Shared settings for SPIn REST, FTD card-not-present flows (portals, invoices, tabs, Google Pay), convenience fees, and Sales Register options.',
      gatewayAuthKey: 'Gateway auth key (SPIn)',
      gatewayAuthKeyHint: 'Server-side SPIn REST credential. The saved value is never shown; only whether one is configured.',
      gatewayAuthKeyConfigured: 'A gateway auth key is saved for this merchant.',
      gatewayAuthKeyNotConfigured: 'No gateway auth key is saved.',
      gatewayAuthKeyPendingRemoval: 'The saved key will be removed when you save.',
      gatewayAuthKeyClear: 'Remove saved key',
      gatewayAuthKeyUndoClear: 'Undo removal',
      mid: 'Merchant ID (MID)',
      midHint: 'MID assigned by Dejavoo for this merchant',
      ecomTerminal: 'E-commerce terminal',
      ecomTerminalHint: 'Terminal used for Ecom (tabs, portals, and similar)',
      ecomTerminalHintEmpty: 'No terminals found. Add an Ecom or Tap to Pay terminal in Terminal Management.',
      ecomTerminalNoOption: 'No Dejavoo terminals available. Create an Ecom or Tap to Pay terminal in Terminal Management first.',
      ftdMode: 'FTD mode',
      gpayMerchantId: 'Google Pay merchant ID',
      gpayMode: 'Google Pay mode',
      modeTest: 'Test',
      modeProduction: 'Production',
      keyedEntry: 'Allow keyed entry on the Sales Register',
      keyedEntryHint: 'Requires Dejavoo FTD and an E-commerce terminal with a valid auth token (same prerequisites as online card payments).',
      convenienceFee: 'Convenience fee',
      convenienceFeeLead: 'Optional card-only surcharge on eligible categories and products (amount plus tip, pro-rated). It does not change the sale or invoice balance.',
      convenienceFeeScopeHint: 'When enabled, the fee applies only to products in categories marked to apply the fee (or products explicitly set to apply). Exempt categories and products are excluded.',
      convenienceFeeEnable: 'Enable convenience fee',
      convenienceFeePercent: 'Convenience fee %',
      convenienceFeePercentHint: 'Example: 3.50',
      convenienceFeeInvalid: 'Convenience fee % must be a non-negative number',
      save: 'Save settings',
      saveConvenienceFee: 'Save convenience fee',
      saved: 'Settings saved',
      saveFailed: 'Could not save settings',
      terminalsSection: 'Terminals',
      terminalsSectionLead: 'Active Dejavoo terminals for this merchant. Manage devices and assignments in Terminal Management.',
      openTerminalMgmt: 'Open Terminal Management',
      activeTerminals: 'Active terminals',
      noActiveTerminals: 'No active Dejavoo terminals',
      colId: 'ID',
      colLabel: 'Label',
      colStatus: 'Status',
      colExternalId: 'External ID',
      terminalsLoadFailed: 'Failed to load terminals',
    },
    open: 'Open',
    cardOptionTapToPay: 'Tap to Pay (this phone)',
    cardOptionTapToPayIos: 'Tap to Pay on iPhone',
    cardOptionTapToPayAndroid: 'Tap to Pay (this phone)',
    tapToPayOnIphoneBanner: 'Customer pays with Tap to Pay on iPhone. Approve the amount, then complete the sale on the Tap to Pay screen.',
    tapToPayAndroidBanner: 'Customer pays with Tap to Pay on this phone (NFC). Approve the amount, then complete the sale.',
    tapToPayNfcOffWarning: 'This device reports NFC off or missing. The payment may not start. Choose Physical Terminal if the register has one.',
    cardOptionPhysicalTerminal: 'Physical Terminal',
    cardOptionKeyedEntry: 'Keyed entry (manual card)',
    cardOptionIntegratedTerminal: 'Integrated terminal (DvPayLite)',
    integratedReaderCapture: 'Use integrated reader',
    integratedReaderCaptureHint: 'Customer taps, inserts, or swipes on this device. A ${amount} hold secures the card for the tab.',
    integratedReaderCaptureZeroHoldHint: 'Customer taps, inserts, or swipes on this device. The card is verified and saved with no hold.',
    integratedReaderCaptureWalletHint: 'Customer taps, inserts, or swipes on this device. A $1.00 verification hold is voided after the card is saved.',
    integratedCaptureFailed: 'Integrated card capture failed. Try again or use another method.',
    integratedCaptureNoToken: 'Card could not be saved. The terminal did not return a vault token.',
    integratedCaptureCancelled: 'Card capture was cancelled.',
    cardOptionCardOnFile: 'Card on File',
    barTabCofPayWith: 'Pay with card on file: {card}',
    barTabCofSelectCard: 'Select card on file',
    barTabCofDeclined: 'Card on file was declined. Try another payment method.',
    sandbox: {
      title: 'Sandbox payments',
      lead: 'Card charges in this environment are for testing only. No real money will be captured.',
      ftdMode: 'FTD mode: {mode}'
    },
    keyedEntryChecking: 'Checking keyed entry availability…',
    keyedEntryBanner: 'Manually enter the customer’s card details. PAN is submitted to Dejavoo for tokenization; Blu never stores raw card numbers.',
    keyedEntryNotReady: 'Keyed entry is enabled but FTD bootstrap data is missing. Save Dejavoo settings and ensure the Ecom terminal has an auth token.',
    keyedEntryFtdLoading: 'Loading secure card entry…',
    cardholderName: 'Cardholder name',
    cardNumber: 'Card number',
    cardExpiry: 'Expiry (MM/YY)',
    cardCvc: 'Security code',
    keyedEntryCardholderRequired: 'Enter the cardholder name as shown on the card.',
    keyedEntryNotReadyShort: 'Keyed entry form is not ready.',
    keyedEntryTokenMissing: 'Unable to retrieve a payment token from Dejavoo. Check the card details and try again.',
    keyedEntryDeclined: 'Card declined.',
    keyedEntryFailed: 'Could not complete keyed payment.',
    keyedEntryFailedDetail: 'Keyed entry failed: {detail}',
    keyedEntryTokenFailed: 'Tokenization failed. Check the card details and network, then try again.',
    keyedEntrySaleNote: 'Keyed entry (Dejavoo FTD)',
    stripeKeyedEntryBanner: 'Enter the card in the secure Stripe form. Card data is sent to Stripe; Blu never stores raw card numbers.',
    stripeKeyedEntrySaleNote: 'Keyed entry (Stripe)',
    keyedEntrySpinnerTitle: 'Processing payment',
    keyedEntrySpinnerSub: 'Do not navigate away.',
    convenienceFeeFullPreview: 'Convenience fee ({percent}%): ${fee} • Customer pays: ${total}',
    convenienceFeePartialPreview: 'Convenience fee ({percent}%): ${fee} on ${eligible} eligible • Customer pays: ${total}',
    integratedTerminalBanner: 'The customer will pay on the card reader built into this device. When payment completes, it is recorded in Blu automatically.',
    integratedTerminalRequiresAndroidApp: 'Integrated card reader checkout requires the Blu Android app on this device.',
    integratedTerminalRequiresDejavooDevice: 'Integrated card reader checkout is only available on whitelisted Dejavoo payment terminals.',
    integratedTerminalRequiresDejavooWhitelist: 'This Dejavoo device is not on the hardware whitelist yet. Capture its identity from Dejavoo PoC and update the app config.',
    integratedTerminalSpinnerTitle: 'Processing payment',
    integratedTerminalSpinnerSub: 'Follow the prompts on the card reader.',
    tapToPayIosSpinnerTitle: 'Tap to Pay on iPhone',
    tapToPayIosSpinnerSub: 'Follow the Tap to Pay screen. Hold the customer’s card or phone near the top of your iPhone until you see Approved or Declined.',
    tapToPayIosTimeout: 'Tap to Pay did not finish in time. Check your internet connection, complete or cancel on the Tap to Pay screen, then try again.',
    integratedTerminalRecordFailed: 'Payment succeeded on the card reader but recording failed. Keep this sale open for staff review.',
    integratedTerminalDeclined: 'Payment was not approved.',
    tapToPayFailed: 'Tap to Pay could not be completed. Check Stripe setup and try again.',
    integratedTerminalCancelled: 'Payment cancelled',
    integratedTerminalLaunchedNotice: 'Complete payment on the card reader.',
    integratedTerminalLaunchFailed: 'Could not open the card reader.',
    integratedTerminalAwaitManualConfirm: 'If payment completed on the card reader, confirm or record it from payment history.',
    integratedTerminalRegisterFailed: 'Could not configure the card reader. Verify the terminal TPN in Terminal Management.',
    integratedTerminalDeclinedWithSale: 'Payment declined: {message}. Sale retained (#{saleId}).',
    integratedTerminalCancelledWithSale: 'Payment cancelled: {message}. Sale retained (#{saleId}).',
    integratedTerminalTip: {
      title: 'Add a tip',
      saleTotal: 'Sale total: {amount}',
      preset15: '15%',
      preset18: '18%',
      preset20: '20%',
      noTip: 'No tip',
      custom: 'Custom',
      customAmount: 'Custom tip amount',
      chargeTotal: 'Total to charge'
    },
    terminalPaymentProcessingTitle: 'Processing terminal payment',
    terminalPaymentProcessingSub: 'Please complete the payment on the physical terminal',
    terminalPaymentAwaitingTerminal: 'Waiting for the customer to finish on the terminal',
    terminalPaymentDoNotRetry: 'Do not start another card payment — the terminal may still be processing this one.',
    terminalPaymentInFlight: 'A card payment is already in progress for this sale. Waiting for the terminal…',
    terminalPaymentAlreadyPaid: 'This sale is already paid in full.',
    terminalPaymentFailedGeneric: 'The card payment did not complete. You can try again or choose another payment method.',
    terminalPaymentTimeout: 'Payment timed out waiting for the terminal. Confirm the transaction, then try again or use another method.',
    terminalPaymentFailedTitle: 'Card payment did not complete',
    terminalPaymentErrorAcknowledge: 'Dismiss',
    terminalPaymentReference: 'Reference',
    posDialogTitle: 'Process payment',
    posDialogSubtitle: 'Confirm tender and complete the sale',
    posDialogAmountDue: 'Amount due',
    cashDue: 'Cash due',
    exactTotal: 'Exact total',
    pennyRounding: 'Penny rounding',
    posDialogProcess: 'Process payment',
    noCardPaymentOptions: 'No card payment options available.',
    noCardPaymentOptionsTapToPay: 'For Tap to Pay, use the Blu Android app on a supported phone. If Tap to Pay is missing, open Settings → Payments → Dejavoo for setup status or contact Blu support.',
    noCardPaymentOptionsTapToPayIos: 'Tap to Pay on iPhone is not ready on this device. Open Settings → Payments → Dejavoo → Tap to Pay on iPhone setup, or contact Blu support.',
    noCardPaymentOptionsPhysicalTerminal: 'For a physical terminal, assign an active terminal to this register.',
    noCardPaymentOptionsBarTabCof: 'For bar tab card on file, verify a card on the tab before close-out.',
    splitAmountDue: 'Amount due',
    splitAllocated: 'Allocated',
    splitRemaining: 'Remaining',
    splitEvenlyComingSoon: 'Split evenly (coming soon)',
    splitPaymentNumber: 'Payment {n}',
    splitRemoveRow: 'Remove payment',
    splitMethodCash: 'Cash',
    splitMethodCard: 'Card',
    splitAmountLabel: 'Amount',
    splitAddPayment: 'Add payment',
    splitCardTerminalLabel: 'Select card terminal',
    splitCardHelper: 'Customer completes card payment on the physical terminal.',
    splitFeeCalculating: 'Calculating convenience fee…',
    splitFeeQuoteError: 'Could not calculate convenience fee',
    splitWizardStepMethodTitle: 'How is this payment?',
    splitWizardStepAmountTitle: 'Payment amount',
    splitWizardStepCashAmountTitle: 'Cash amount',
    splitWizardStepCardTitle: 'Card terminal',
    splitWizardProgressMethod: 'Payment {n} — choose method',
    splitWizardProgressAmount: 'Payment {n} — enter amount',
    splitWizardProgressDetails: 'Payment {n} — complete details',
    splitWizardUseRemaining: 'Use full remaining balance',
    splitWizardContinue: 'Continue',
    splitWizardBack: 'Back',
    splitWizardAddAnother: 'Add next payment',
    splitWizardFinish: 'Review split',
    splitWizardAddedPayments: 'Added so far',
    splitWizardReviewTitle: 'Ready to process',
    splitWizardReviewReady: 'All payments are entered. Process when ready.',
    splitWizardEditLast: 'Edit last payment',
    splitWizardBackToReview: 'Back to review',
    splitPlanTitle: 'Split between payers',
    splitPayerCount: 'Number of payers',
    splitEvenly: 'Split evenly',
    splitPayerLabelOptional: 'Label (optional)',
    splitMethodLabel: 'Method',
    splitEditPlan: 'Edit split plan',
    splitCollectProgress: 'Payment {current} of {total}',
    splitCollectAmount: 'Collect {amount}',
    splitCollectFailed: 'This payment did not complete. You can retry or cancel the checkout.',
    splitCollectRetry: 'Retry payment',
    splitCollectCancel: 'Cancel split checkout',
    splitCollectIncomplete: 'Split checkout did not finish. Collect every payment before completing the sale.',
    splitMultiCardDisabled: 'Multi-card split is not enabled for this business.'
  },
  terminals: {
    title: 'Terminals',
    subtitle: 'Monitor payment terminals, health, and register assignments',
    newTerminal: 'New Terminal',
    createTerminalTooltip: 'Create a new payment terminal',
    totalTerminals: 'Total Terminals',
    healthy: 'Healthy',
    issues: 'Issues',
    assigned: 'Assigned',
    search: 'Search',
    searchPlaceholder: 'Label, external id, register…',
    filter: 'Filter',
    apply: 'Apply',
    clear: 'Clear',
    refreshTooltip: 'Refresh terminals',
    manage: {
      filterAll: 'All',
      filterHealthy: 'Healthy',
      filterIssues: 'Issues',
      filterUnassigned: 'Unassigned',
      chipReady: 'Ready',
      chipIssue: 'Attention',
      unknownGateway: 'Unknown gateway',
      registerChip: 'Register: {name}',
      unassigned: 'Unassigned',
      capabilitiesLead: 'Capabilities',
      menuViewDetails: 'View details',
      menuEdit: 'Edit',
      menuDelete: 'Delete',
      emptyTitle: 'No terminals found',
      emptyFiltered: 'No terminals match the current filters.',
      emptyNoneYet: 'No terminals have been added for this location yet.',
      emptyCreateFirst: 'Create terminal',
      emptyViewPaymentStatus: 'View payment setup status',
      adminProvisionedBanner: 'Processor credentials and capabilities are configured by Blu. You can update the display label here; assign registers from Register Management.',
      formTitleNew: 'New terminal',
      formTitleEdit: 'Edit terminal',
      label: 'Terminal label',
      labelRequired: 'Label is required',
      externalId: 'External ID',
      externalIdRequired: 'External ID is required',
      paymentGateway: 'Payment gateway',
      gatewayRequired: 'Gateway is required',
      ecomAuthToken: 'E-commerce auth token',
      ecomAuthTokenHint: 'Required when Ecom is enabled. Stored encrypted; kept when Ecom is disabled.',
      ecomAuthTokenRequiredWhenEnabled: 'E-commerce auth token is required when Ecom capability is enabled.',
      ecomAuthTokenRequired: 'E-commerce auth token is required for Dejavoo terminals',
      merchantCodeOptional: 'Merchant code / MID (Tap to Pay on Android)',
      capabilitiesSection: 'Terminal capabilities',
      capabilitiesHint: 'One TPN can support multiple flows. Enable only what this device uses.',
      hardwareCapsSection: 'Hardware options',
      capSpin: 'SPIn REST (physical terminal)',
      capSpinHint: 'Send card-present payments to a physical terminal via SPIn.',
      capEcom: 'Ecom / Transact (keyed & online)',
      capEcomHint: 'Enables keyed entry and online Transact for this TPN. Disabling keeps the auth token stored.',
      capDvpayliteIntegrated: 'Integrated (DvPayLite)',
      capDvpayliteIntegratedHint: 'Hand off sales to the DvPayLite app on the same Android device.',
      capTapOnPhone: 'Tap to Pay (mobile)',
      capTapOnPhoneHint: 'In-app NFC Tap to Pay on Android.',
      capabilityLabel: {
        contactless: 'Contactless',
        chip: 'Chip',
        swipe: 'Swipe',
        print: 'Print',
        signature: 'Signature'
      },
      dejavooType: 'Dejavoo terminal type',
      dejavooTypeHint: 'Physical terminal uses SPIn; E-commerce supports keyed and online flows; Tap to Pay for in-app NFC on Android.',
      typeSpin: 'Card present (SPIn)',
      typeEcom: 'E-commerce / online only',
      typeTop: 'Tap to Pay (mobile)',
      statusField: 'Status',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      statusMaintenance: 'Maintenance',
      statusDisconnected: 'Disconnected',
      noGatewayAccounts:
        'No payment gateway accounts are configured. Add a gateway in Payment settings before creating terminals.',
      cancel: 'Cancel',
      saveCreate: 'Create',
      saveUpdate: 'Update',
      detailsTitle: 'Terminal details',
      detailFor: '{name}',
      basicInfo: 'Basic information',
      fieldLabel: 'Label',
      fieldExternalId: 'External ID',
      fieldGateway: 'Gateway',
      fieldStatus: 'Status',
      fieldHealth: 'Health',
      statusUnknown: 'Unknown',
      healthOk: 'Healthy',
      healthWarn: 'Needs attention',
      assignSection: 'Register assignment',
      fieldRegister: 'Register',
      fieldRegisterId: 'Register ID',
      fieldLocation: 'Location ID',
      noRegisterTitle: 'No register assigned',
      noRegisterLead: 'Assign this terminal from Register management.',
      capsSection: 'Capabilities',
      noCaps: 'No capabilities on file',
      metricsSection: 'Activity (sample)',
      metricsTotalTxn: 'Sample transactions',
      metricsSuccessRate: 'Sample success rate',
      metricsLastUsed: 'Last used',
      metricsNever: 'Never',
      close: 'Close',
      editFromDetails: 'Edit terminal',
      manageAssignment: 'Manage assignment',
      assignmentSoon: 'Register assignment from this dialog is coming soon.',
      confirmDeleteTitle: 'Delete terminal?',
      confirmDeleteMessage:
        'Delete “{name}”? Unregister it from registers first if it is still in use. This cannot be undone.',
      loadFailedDetail: 'Could not load terminals: {message}',
      loadFailedGeneric: 'Failed to load terminals',
      refreshFailed: 'Failed to refresh terminals',
      created: 'Terminal created',
      updated: 'Terminal updated',
      saveFailedDetail: 'Could not save terminal: {message}',
      saveFailedGeneric: 'Failed to save terminal',
      deleted: 'Terminal deleted',
      deleteFailedDetail: 'Could not delete terminal: {message}',
      deleteFailedGeneric: 'Failed to delete terminal'
    },
    tokenHints: {
      setOrReplace: 'Enter a token to set or replace the e-commerce auth credential for this terminal.',
      notSetYet: 'No Dejavoo e-commerce auth token is stored for this terminal yet.',
      currentBoth: 'Stored token begins with {first} and ends in {last}. Enter a new value to replace it.',
      currentLast: 'Stored token ends in {last}. Enter a new value to replace it.',
      configuredObscured: 'A token is already stored. Enter a new value to replace it.'
    }
  },
  storeOrders: {
    title: 'Store pickup queue',
    featureDisabled: 'Blu Store is not enabled for this business.',
    noOrders: 'No store orders waiting for pickup.',
    noHistory: 'No completed or cancelled store orders yet.',
    tabActive: 'Active',
    tabHistory: 'History',
    historyHint: 'Completed and cancelled online store orders for this location.',
    colOrder: 'Order',
    colCustomer: 'Customer',
    colTotal: 'Total',
    colFulfillment: 'Fulfillment',
    colStatus: 'Status',
    colUpdated: 'Updated',
    historySearchPlaceholder: 'Search by order #, name, or email',
    guestCustomer: 'Guest',
    updateFailed: 'Could not update order status.',
    pickupLabel: 'Store pickup',
    viewSale: 'View sale',
    saleDetailTitle: 'Store order #{id}',
    saleDetailSubtitle: 'Lines, totals, and payment details',
    saleDetailLoadFailed: 'Could not load sale details.',
    channelContext: 'Blu Store online order',
    customerEmailLine: 'Shopper email: {email}',
    noEmailOnFile: 'No shopper email on file',
    fulfillmentShipped: 'Shipped',
    markShipped: 'Mark shipped',
    fulfillmentModePickup: 'Pickup',
    fulfillmentModeShip: 'Ship',
    lineItemCount: '{count} items',
    shipDialogTitle: 'Ship order #{id}',
    shipDialogHint: 'Optional carrier and tracking number are included in the shipped email and on the shopper order page.',
    shipCarrierLabel: 'Carrier',
    shipCarrierUsps: 'USPS',
    shipCarrierUps: 'UPS',
    shipCarrierFedex: 'FedEx',
    shipCarrierDhl: 'DHL',
    shipCarrierOther: 'Other',
    shipCarrierOtherLabel: 'Carrier name',
    shipTrackingLabel: 'Tracking number',
    shipTrackingHint: 'Optional',
    shipConfirm: 'Mark as shipped',
    markReturned: 'Mark returned',
    markReturnedConfirmTitle: 'Mark order returned?',
    markReturnedConfirmMessage: 'Order #{id} will be recorded as returned and inventory will be restocked. Card refunds still use the sale void flow.',
    markReturnedConfirmOk: 'Mark returned',
    markReturnedSuccess: 'Order marked returned and inventory updated.',
    cancelDialogTitle: 'Cancel this store order?',
    cancelDialogMessage:
      'Order #{id} will be marked cancelled and pickup or ship inventory will be restocked. Card refunds still use the sale void flow.',
    cancelDialogOk: 'Cancel order',
    cancelPendingLine: 'Order #{id} will be cancelled'
  },
  kds: {
    titleKitchenQueue: 'Kitchen queue',
    titleKitchenDisplay: 'Kitchen display',
    toggleChimeAria: 'Toggle new-order sound',
    signOutDevice: 'Sign out device',
    noOrders: 'No orders in queue.',
    featureDisabled: 'Order ahead queue is disabled for this business. Enable it in Settings > Business info.',
    start: 'Start',
    ready: 'Ready',
    complete: 'Complete',
    cancelOrder: 'Cancel order',
    printTicket: 'Print ticket',
    itemFallback: 'Item',
    feedbackPreparing: 'Preparing',
    feedbackReady: 'Ready',
    feedbackCompleted: 'Completed',
    orderNumberLine: 'Order #{id}',
    feedbackAllFinished: 'All finished!',
    overlayCancelled: 'Cancelled',
    cancelPendingLine: 'Order #{id} will be cancelled',
    undoInSeconds: 'Undo in {n}s',
    undoSeparator: ' · ',
    undo: 'Undo',
    dialogCancelTitle: 'Cancel this order?',
    dialogCancelMessage: 'Order #{id} will be marked as cancelled for the kitchen queue.',
    dialogKeep: 'Keep',
    dialogConfirmCancel: 'Cancel order',
    notPaired: 'This device is not paired. Open /kds/setup first.',
    failedLoadQueue: 'Failed to load queue',
    updateFailed: 'Update failed',
    cancelFailed: 'Cancel failed',
    fulfillment: {
      queued: 'Queued',
      in_progress: 'In progress',
      ready: 'Ready',
      shipped: 'Shipped',
      cancelled: 'Cancelled',
      completed: 'Completed'
    },
    relativeJustNow: 'Just now',
    relativeMinutesAgo: '{n} min ago',
    relativeHoursAgo: '{n} hr ago',
    relativeOneDayAgo: '1 day ago',
    relativeDaysAgo: '{n} days ago',
    printDocTitle: 'Order #{id}',
    printHeading: 'Order #{id}',
    customerGuest: 'Guest',
    openStaffKitchenQueue: 'Open staff kitchen queue',
    backToEquipment: 'Back to Equipment'
  },
  scheduling: {
    title: 'Scheduling',
    subtitle: 'View and manage appointments for this location.',
    settingsSubtitle: 'Configure services, staff, and availability.',
    columnTime: 'Time',
    columnCustomer: 'Customer',
    columnStatus: 'Status',
    refreshList: 'Reload appointments',
    dialogBookSubtitle: 'Choose a service, then pick date and time from the calendar.',
    dialogAppointmentSubtitle: 'Review details and take action.',
    editService: 'Edit service',
    dialogServiceSubtitle: 'Each service must be linked to a product for correct pricing at checkout.',
    dialogStaffSubtitle: 'Choose which services this team member can perform.',
    dialogRuleSubtitle: 'Set regular weekly hours for the selected staff member.',
    dialogExceptionSubtitle: 'Block a full day or set custom hours for one date.',
    selectNoServices: 'No services are available. Add services in Scheduling settings.',
    selectNoMatchingServices: 'No services match your search.',
    selectNoStaff: 'No staff members are set up. Add staff in Scheduling settings.',
    selectNoStaffOffersService: 'No staff is assigned to this service yet. Update staff in Scheduling settings.',
    selectNoMatchingStaff: 'No staff match your search.',
    selectNoTimeSlots: 'No open times for this selection. Try another staff member or check availability in settings.',
    selectNoMatchingTimeSlots: 'No times match your search.',
    selectTimeSlotsNeedDate: 'Choose an appointment date first.',
    selectTimeSlotsNeedServiceStaff: 'Select a service and staff member first.',
    slotPickerTitle: 'Date & time',
    slotPickerSubtitle: 'Days with a dot have availability. Tap a day, then a time.',
    slotPickerNeedService: 'Select a service first.',
    slotPickerLegend: 'Staff colors',
    slotPickerSummaryFailed: 'Could not load the calendar. Try again.',
    slotPickerPickDate: 'Select a date on the calendar.',
    slotPickerLoadFailed: 'Could not load times. Try again.',
    slotPickerNoSlotsDay: 'No open times on this day for this service.',
    slotPickerOneTime: '1 time',
    slotPickerTimesCount: '{count} times',
    slotPickerBack: 'Back',
    slotPickerChoose: 'Choose date & time',
    slotPickerChange: 'Change date & time',
    slotPickerSelectServiceFirst: 'Select a service to enable booking.',
    bookingSelectionLabel: 'Appointment',
    dayPartMorning: 'Morning',
    dayPartAfternoon: 'Afternoon',
    dayPartEvening: 'Evening',
    noServicesYet: 'No services yet. Add one to get started.',
    noStaffYet: 'No staff yet. Add a team member.',
    settings: 'Settings',
    back: 'Back',
    today: 'Today',
    calendar: 'Calendar',
    calLayoutGrid: 'Grid',
    calLayoutList: 'List',
    calDay: 'Day',
    calWeek: 'Week',
    calMonth: 'Month',
    calPrev: 'Previous period',
    calNext: 'Next period',
    calToday: 'Today',
    calPickDate: 'Go to date',
    filterByStaff: 'Filter by staff',
    newAppointment: 'New appointment',
    noAppointments: 'No appointments',
    date: 'Date',
    service: 'Service',
    staff: 'Staff',
    staffMember: 'Staff member',
    staffName: 'Name',
    timeSlot: 'Time',
    book: 'Book',
    appointment: 'Appointment',
    checkIn: 'Check in',
    startSale: 'Start sale',
    cancelAppointment: 'Cancel appointment',
    cancelAppointmentConfirmTitle: 'Cancel this appointment?',
    cancelAppointmentConfirmMessage:
      'It will be removed from the schedule. Customers with a portal link may see it as cancelled. You can restore it later if this was a mistake.',
    cancelAppointmentConfirmAction: 'Yes, cancel',
    restoreAppointment: 'Restore appointment',
    restoreAppointmentConfirmTitle: 'Restore this appointment?',
    restoreAppointmentConfirmMessage: 'It will be scheduled again and appear on your calendar.',
    appointmentRestored: 'Appointment restored',
    statusChangeFailed: 'Could not update this appointment. Try again.',
    saved: 'Saved',
    checkedIn: 'Checked in',
    cancelled: 'Cancelled',
    servicesTitle: 'Services',
    staffTitle: 'Staff',
    addService: 'Add service',
    addStaff: 'Add staff',
    editStaff: 'Edit staff member',
    serviceName: 'Service name',
    servicePrice: 'Price',
    durationMinutes: 'Duration (minutes)',
    product: 'Product',
    productOptionalHint: 'Optional — link a POS product for register checkout, or leave blank and set a price above.',
    services: 'Services',
    servicesOffered: 'Services offered',
    availabilityTitle: 'Availability',
    availabilityHint: 'Pick a staff member to edit their weekly hours and exceptions.',
    weeklyRules: 'Weekly hours',
    exceptions: 'Exceptions',
    setSchedule: 'Set schedule',
    setScheduleSubtitle: 'Choose which days apply, then add one or more time windows for each day.',
    preset247: 'Available 24/7',
    presetWeekdays: 'Weekdays (Mon–Fri)',
    presetWeekend: 'Weekend (Sat–Sun)',
    addTimeSlot: 'Add time slot',
    allDayThisDay: 'All day (this day)',
    scheduleSelectDayHint: 'Select a day on the left to edit its hours.',
    scheduleNeedSlotPerDay: 'Add at least one time window for each selected day.',
    scheduleInvalidSlot: 'Each window needs an end time after the start time.',
    scheduleSyncFailed: 'Could not save. Overlapping hours on the same day are not allowed.',
    scheduleWindowCount: '{n} time window(s)',
    addException: 'Add exception',
    dayOfWeek: 'Day of week',
    day: 'Day',
    opens: 'Opens',
    closes: 'Closes',
    closedAllDay: 'Closed all day',
    closed: 'Closed',
    hours: 'Hours',
    createNewProduct: 'Create new product…',
    selectNoProductData: 'No products found. Try a search or create a new product.',
    selectNoMatchingProducts: 'No products match your search.',
    inlineProductHint:
      'New product is saved as non-stock in Uncategorized. You can edit details later on the Products page.',
    inlineProductName: 'Product name',
    inlineProductPrice: 'Price',
    inlineProductRequired: 'Enter a product name and a valid price (0 or greater).',
    productCreateForbidden: 'You do not have permission to create products. Link an existing product or ask an administrator.',
    fillRequired: 'Required fields are missing.',
    completeSaleLinkFailed: 'Sale completed, but the appointment could not be linked. Update it from Scheduling.',
    days: {
      sun: 'Sunday',
      mon: 'Monday',
      tue: 'Tuesday',
      wed: 'Wednesday',
      thu: 'Thursday',
      fri: 'Friday',
      sat: 'Saturday'
    }
  },
  booking: {
    title: 'Booking',
    subtitle: 'View and manage bookings for this location.',
    settingsSubtitle: 'Configure services, staff, availability, payments, and website booking.',
    columnTime: 'Time',
    columnCustomer: 'Customer',
    columnStatus: 'Status',
    columnPayment: 'Payment',
    refreshList: 'Reload bookings',
    dialogBookSubtitle: 'Choose a service, then pick date and time from the calendar.',
    dialogAppointmentSubtitle: 'Review details and take action.',
    editService: 'Edit service',
    dialogServiceSubtitle: 'Set name, duration, and price for this bookable service.',
    dialogStaffSubtitle: 'Choose which services this team member can perform.',
    dialogRuleSubtitle: 'Set regular weekly hours for the selected staff member.',
    dialogExceptionSubtitle: 'Block a full day or set custom hours for one date.',
    selectNoServices: 'No services are available. Add services in Booking settings.',
    selectNoMatchingServices: 'No services match your search.',
    selectNoStaff: 'No staff members are set up. Add staff in Booking settings.',
    selectNoStaffOffersService: 'No staff is assigned to this service yet. Update staff in Booking settings.',
    selectNoMatchingStaff: 'No staff match your search.',
    selectNoTimeSlots: 'No open times for this selection. Try another staff member or check availability in settings.',
    selectNoMatchingTimeSlots: 'No times match your search.',
    selectTimeSlotsNeedDate: 'Choose an appointment date first.',
    selectTimeSlotsNeedServiceStaff: 'Select a service and staff member first.',
    slotPickerTitle: 'Date & time',
    slotPickerSubtitle: 'Days with a dot have availability. Tap a day, then a time.',
    slotPickerNeedService: 'Select a service first.',
    slotPickerLegend: 'Staff colors',
    slotPickerSummaryFailed: 'Could not load the calendar. Try again.',
    slotPickerPickDate: 'Select a date on the calendar.',
    slotPickerLoadFailed: 'Could not load times. Try again.',
    slotPickerNoSlotsDay: 'No open times on this day for this service.',
    slotPickerOneTime: '1 time',
    slotPickerTimesCount: '{count} times',
    slotPickerBack: 'Back',
    slotPickerChoose: 'Choose date & time',
    slotPickerChange: 'Change date & time',
    slotPickerSelectServiceFirst: 'Select a service to enable booking.',
    bookingSelectionLabel: 'Booking',
    dayPartMorning: 'Morning',
    dayPartAfternoon: 'Afternoon',
    dayPartEvening: 'Evening',
    noServicesYet: 'No services yet. Add one to get started.',
    noStaffYet: 'No staff yet. Add a team member.',
    settings: 'Settings',
    back: 'Back',
    today: 'Today',
    calendar: 'Calendar',
    calLayoutGrid: 'Grid',
    calLayoutList: 'List',
    calDay: 'Day',
    calWeek: 'Week',
    calMonth: 'Month',
    calPrev: 'Previous period',
    calNext: 'Next period',
    calToday: 'Today',
    calPickDate: 'Go to date',
    filterByStaff: 'Filter by staff',
    newAppointment: 'New booking',
    noAppointments: 'No bookings',
    date: 'Date',
    service: 'Service',
    staff: 'Staff',
    staffMember: 'Staff member',
    staffName: 'Name',
    timeSlot: 'Time',
    book: 'Book',
    appointment: 'Booking',
    checkIn: 'Check in',
    startSale: 'Start sale',
    cancelAppointment: 'Cancel booking',
    statusChangeFailed: 'Could not update this booking. Try again.',
    saved: 'Saved',
    checkedIn: 'Checked in',
    cancelled: 'Cancelled',
    servicesTitle: 'Services',
    staffTitle: 'Staff',
    addService: 'Add service',
    addStaff: 'Add staff',
    editStaff: 'Edit staff member',
    serviceName: 'Service name',
    servicePrice: 'Price',
    durationMinutes: 'Duration (minutes)',
    product: 'Product',
    productOptionalHint: 'Optional — link a POS product for register checkout, or leave blank and set a price above.',
    services: 'Services',
    servicesOffered: 'Services offered',
    availabilityTitle: 'Availability',
    availabilityHint: 'Pick a staff member to edit their weekly hours and exceptions.',
    weeklyRules: 'Weekly hours',
    exceptions: 'Exceptions',
    setSchedule: 'Set schedule',
    setScheduleSubtitle: 'Choose which days apply, then add one or more time windows for each day.',
    preset247: 'Available 24/7',
    presetWeekdays: 'Weekdays (Mon–Fri)',
    presetWeekend: 'Weekend (Sat–Sun)',
    addTimeSlot: 'Add time slot',
    allDayThisDay: 'All day (this day)',
    scheduleSelectDayHint: 'Select a day on the left to edit its hours.',
    scheduleNeedSlotPerDay: 'Add at least one time window for each selected day.',
    scheduleInvalidSlot: 'Each window needs an end time after the start time.',
    scheduleSyncFailed: 'Could not save. Overlapping hours on the same day are not allowed.',
    scheduleWindowCount: '{n} time window(s)',
    addException: 'Add exception',
    dayOfWeek: 'Day of week',
    day: 'Day',
    opens: 'Opens',
    closes: 'Closes',
    closedAllDay: 'Closed all day',
    closed: 'Closed',
    hours: 'Hours',
    createNewProduct: 'Create new product…',
    selectNoProductData: 'No products found. Try a search or create a new product.',
    selectNoMatchingProducts: 'No products match your search.',
    inlineProductHint:
      'New product is saved as non-stock in Uncategorized. You can edit details later on the Products page.',
    inlineProductName: 'Product name',
    inlineProductPrice: 'Price',
    inlineProductRequired: 'Enter a product name and a valid price (0 or greater).',
    productCreateForbidden: 'You do not have permission to create products. Link an existing product or ask an administrator.',
    fillRequired: 'Required fields are missing.',
    completeSaleLinkFailed: 'Sale completed, but the booking could not be linked. Update it from Booking.',
    paymentStatusUnpaid: 'Unpaid',
    collectPayment: 'Collect payment',
    collectPaymentTitle: 'Collect payment',
    collectPaymentSubtitle: 'Charge a card, use a saved card, send a pay link, or record a manual payment.',
    collectPaymentSuccess: 'Payment recorded',
    collectPaymentFailed: 'Payment could not be completed',
    amountDue: 'Amount due',
    collectTabCard: 'Card',
    collectTabSavedCard: 'Saved card',
    collectTabSendLink: 'Send link',
    collectTabManual: 'Manual',
    collectCardUnavailable: 'Keyed card entry is not configured for this location.',
    collectAmountOptional: 'Amount (optional)',
    collectNoSavedCards: 'This customer has no saved cards on file.',
    collectSubmitCard: 'Charge card',
    collectSubmitSavedCard: 'Charge saved card',
    collectEmailTo: 'Recipient email',
    collectEmailRequired: 'Enter an email address',
    collectManualAmount: 'Amount',
    collectManualAmountRequired: 'Enter a valid amount',
    collectManualMethod: 'Payment method',
    collectManualReference: 'Reference (optional)',
    collectManualNotes: 'Notes (optional)',
    collectSubmitManual: 'Record payment',
    manualMethodCash: 'Cash',
    manualMethodCheck: 'Check',
    manualMethodCardExternal: 'External card',
    manualMethodBankTransfer: 'Bank transfer',
    manualMethodOther: 'Other',
    paymentLinkLabel: 'Payment link',
    generatePaymentLink: 'Generate link',
    generatePaymentLinkFailed: 'Could not generate payment link',
    emailPaymentLink: 'Email link',
    emailPaymentLinkSent: 'Payment link emailed',
    emailPaymentLinkFailed: 'Could not email payment link',
    paymentLinkEmailSection: 'Email payment link',
    paymentLinkSmsSection: 'Text payment link',
    collectSmsTo: 'Recipient phone',
    collectSmsRequired: 'Enter a phone number',
    collectSmsUsOnly: 'SMS can only be sent to US phone numbers',
    sendPaymentLinkEmail: 'Send email',
    sendPaymentLinkSms: 'Send text',
    smsPaymentLinkSent: 'Payment link sent by text',
    smsPaymentLinkFailed: 'Could not send payment link by text',
    paymentLinkCopied: 'Payment link copied',
    paymentLinkCopyFailed: 'Could not copy link',
    generalSettingsTitle: 'Booking settings',
    embedSettingsTitle: 'Website booking widget',
    embedSettingsHint:
      'Copy the code block below into your website. The booking area resizes automatically as customers move through each step.',
    embedCodeTitle: 'Website code',
    embedIframeTitle: 'Online booking',
    copyEmbedCode: 'Copy website code',
    embedCodeCopied: 'Website code copied',
    embedCodeCopyFailed: 'Could not copy website code',
    previewEmbed: 'Preview',
    enablePublicBooking: 'Allow bookings on your website',
    posIntegrationEnabled: 'Enable POS integration (Start sale handoff)',
    embedTitle: 'Widget title',
    embedWelcomeMessage: 'Welcome message',
    successMessage: 'Success message',
    depositPolicy: 'Deposit policy',
    depositPolicyNone: 'No deposit',
    depositPolicyFixed: 'Fixed amount',
    depositPolicyPercent: 'Percentage',
    depositPolicyFullPrepay: 'Full prepayment',
    depositAmount: 'Deposit amount',
    depositPercent: 'Deposit percent',
    depositEmbedHint: 'Online checkout shows amount due today and any balance later when a deposit policy applies.',
    requirePaymentToConfirm: 'Require payment to confirm booking',
    pendingPaymentTtlMinutes: 'Checkout hold time (minutes)',
    pendingPaymentTtlHint: 'Unpaid online checkouts hold the trip slot for this long, then release automatically.',
    bookingStyleLabel: 'Booking style',
    bookingStyleColumn: 'Style',
    bookingStyle: {
      appointment: 'Appointment',
      experience: 'Experience / trip',
      transport: 'Transport'
    },
    serviceDescription: 'Description',
    fixedStartTime: 'Departure time',
    fixedStartTimeHint: 'Fixed start time for trip departures (location timezone). Required for experience services.',
    fixedStartTimeRequired: 'Experience services require a departure time.',
    maxPartySize: 'Max group size',
    maxPartySizeHint: 'Maximum guests per trip departure shown on your website.',
    showInPublicEmbed: 'Show on your website',
    durationLabel: 'Duration',
    durationPresetsHint: 'Quick picks for common trip lengths',
    durationCustomLabel: 'Or set a custom length',
    durationCustomDays: 'Days',
    durationCustomHours: 'Hours',
    durationCustomMinutes: 'Minutes',
    durationSelectedHint: 'Bookings block {duration} on the calendar.',
    durationFormatDays: '{count} day | {count} days',
    durationFormatHours: '{count} hour | {count} hours',
    durationFormatMinutes: '{count} minute | {count} minutes',
    durationFormatMixed: '{days}d {hours}h {minutes}m',
    durationPreset: {
      '30m': '30 min',
      '1h': '1 hour',
      '2h': '2 hours',
      '4h': '4 hours',
      '6h': '6 hours',
      '8h': '8 hours',
      '12h': '12 hours',
      '1d': 'Full day (24h)',
      '2d': '2 days',
      '3d': '3 days'
    },
    leadTimeDays: 'Minimum lead time (days)',
    leadTimeHours: 'Hours',
    leadTimeHint: 'Customers cannot book sooner than {total} hours from now.',
    cancellationWindowHours: 'Cancellation window (hours)',
    cancellationWindowHint: 'Trips departing within this many hours show as non-refundable online and cannot be cancelled by the customer.',
    customerCanCancel: 'Allow customers to cancel online',
    pricingModeLabel: 'Pricing basis',
    pricingMode: {
      fixed: 'Fixed price',
      tiered: 'Tiered by group size',
      quote: 'Quote (manual price)'
    },
    pricingModeQuoteHint: 'Customers request a quote; set a quoted price on each booking in the calendar.',
    priceTiersTitle: 'Group size price tiers',
    priceTiersHint: 'Flat trip total for each guest count range. Tiers must cover every size from 1 through max group size with no gaps.',
    tierMinParty: 'Min guests',
    tierMaxParty: 'Max guests',
    tierPrice: 'Trip total',
    addPriceTier: 'Add tier',
    priceTiersRequired: 'Add at least one price tier.',
    priceTiersInvalidRange: 'Each tier needs valid min and max guest counts.',
    priceTiersInvalidPrice: 'Each tier needs a valid price (0 or greater).',
    priceTiersGap: 'Tiers must cover every group size from 1 to {max} without gaps.',
    priceTiersExceedMaxParty: 'A tier exceeds the max group size.',
    priceTiersMaxReached: 'All group sizes are already covered by existing tiers.',
    priceTiersFleetUnitSizeRequired: 'Set guests per unit before configuring fleet price tiers.',
    fleetSettingsTitle: 'Fleet capacity',
    fleetSettingsHint: 'Global pool of units (boats, vehicles, etc.) shared across fleet-mode trip services. Period cap of 0 disables online booking for fleet services in that date range.',
    fleetSize: 'Fleet size (max units)',
    capacityUnitLabelSingular: 'Unit label (singular)',
    capacityUnitLabelPlural: 'Unit label (plural)',
    defaultCapacityUnitSize: 'Default guests per unit',
    fleetPeriodRulesTitle: 'Seasonal fleet caps',
    fleetPeriodStartsOn: 'Starts on',
    fleetPeriodEndsOn: 'Ends on',
    fleetPeriodMaxUnits: 'Max units',
    fleetPeriodMaxUnitsHint: 'Use 0 to block online booking for fleet services during this period.',
    fleetPeriodNotes: 'Notes',
    addFleetPeriodRule: 'Add period rule',
    noFleetPeriodRules: 'No seasonal caps configured.',
    fleetServiceRulesTitle: 'Service capacity rules',
    fleetServiceRuleService: 'Service',
    fleetServiceRuleBlackout: 'Blackout (no online booking)',
    fleetServiceRuleMaxUnitsPerBooking: 'Max units per booking',
    fleetServiceRuleTimeFrom: 'Allowed departure from',
    fleetServiceRuleTimeTo: 'Allowed departure until',
    addFleetServiceRule: 'Add service rule',
    noFleetServiceRules: 'No service rules configured.',
    capacityModeLabel: 'Capacity mode',
    capacityMode: {
      simple: 'Simple (one exclusive booking per departure)',
      fleet_units: 'Fleet units (shared pool, multiple bookings)'
    },
    capacityModeSimpleHint: 'One booking takes the entire departure. Tier prices apply to the whole group.',
    capacityModeFleetHint: 'Multiple bookings share a fleet pool until units are exhausted. Tier prices apply per unit (1 through guests per unit).',
    capacityUnitSize: 'Guests per unit',
    maxUnitsPerBooking: 'Max units per booking',
    priceTiersFleetHint: 'Price per unit for each guest count from 1 through guests per unit. Larger groups use multiple units (e.g. 5 guests with 4 per unit = one full unit plus one single-guest unit).',
    priceTiersExceedUnitSize: 'A tier exceeds guests per unit.',
    tripStaffMembers: 'Captains on trip',
    tripStaffMembersHint: 'Primary captain is used for scheduling overlap checks. Add co-captains for reporting.',
    saveStaffMembers: 'Save captains',
    capacityUnitsReserved: 'Fleet units reserved',
    capacityUnitsCount: '{count} {unit}',
    settingsTabGeneral: 'General',
    settingsTabEmbed: 'Website',
    settingsTabFleet: 'Fleet capacity',
    settingsTabServices: 'Services',
    backToBookingSettings: 'Back to Booking Settings',
    settingsHubSubtitle: 'General settings, services, and fleet capacity',
    settingsGeneralSubtitle: 'Website booking, payments, and customer policies',
    settingsServicesSubtitle: 'Manage bookable services, pricing, and capacity modes',
    settingsFleetSubtitle: 'Fleet pool size, seasonal caps, and service booking rules',
    settingsTileGeneral: 'General',
    settingsTileGeneralEnabled: 'Public booking is enabled',
    settingsTileGeneralDisabled: 'Public booking is off',
    settingsTileServices: 'Services',
    settingsTileServicesDesc: 'Trips, appointments, pricing tiers, and fleet capacity per service',
    settingsTileServicesCount: '{count} service configured | {count} services configured',
    settingsTileFleet: 'Fleet capacity',
    settingsTileFleetDesc: 'Pool of {count} units, seasonal caps, blackouts, and limits',
    fleetPeriodRulesHint: 'Adjust how many fleet units are available online during specific date ranges.',
    fleetServiceRulesHint: 'Block bookings, limit units per reservation, or restrict departure times for individual services.',
    fleetRulesViewList: 'List',
    fleetRulesViewCalendar: 'Calendar',
    fleetRuleColumnDateRange: 'Date range',
    fleetRuleColumnSummary: 'Effect',
    fleetRuleAlways: 'Always',
    fleetRuleSummaryBlocked: 'Block online booking',
    fleetRuleSummaryCap: 'Cap: {count} units',
    fleetRuleSummaryFullFleet: 'Full fleet ({count})',
    fleetRuleChipBlock: 'Block online booking',
    fleetRuleChipFullFleet: 'Full fleet ({count})',
    editFleetPeriodRule: 'Edit seasonal cap',
    editFleetServiceRule: 'Edit service rule',
    fleetPeriodRuleDialogSubtitle: 'Set a date range and how many fleet units can be booked online.',
    fleetServiceRuleDialogSubtitle: 'Restrict online booking for a specific service.',
    fleetServiceRuleTypeLabel: 'Rule type',
    fleetServiceRuleTypeBlackout: 'Block online booking',
    fleetServiceRuleTypeMaxUnitsLabel: 'Limit units per booking',
    fleetServiceRuleTypeTimeWindowLabel: 'Restrict departure times',
    fleetServiceRuleTypeMaxUnits: 'Max {count} units per booking',
    fleetServiceRuleTypeTimeWindow: 'Departures {from} – {to}',
    fleetServiceRuleDateOptionalHint: 'Leave dates empty to apply this rule at all times.',
    fleetServiceRuleBlackoutHint: 'Customers cannot book this service online while this rule is active.',
    fleetServiceRuleMaxUnitsHint: 'Limits how many fleet units one reservation can consume.',
    fleetServiceRuleTimeRequired: 'Set at least one departure time boundary.',
    fleetDateRangeHint: 'Select a start and end date on the calendar, or use advanced fields below.',
    fleetDateRangeAdvanced: 'Advanced date entry',
    fleetCalendarLegend: 'Legend',
    fleetCalendarLegendBlocked: 'Blocked / blackout',
    fleetCalendarLegendReducedCap: 'Reduced fleet cap',
    fleetCalendarLegendBlackout: 'Service blackout',
    fleetCalendarLegendMaxUnits: 'Unit limit',
    fleetCalendarLegendTimeWindow: 'Time window',
    fleetCalendarRulesOnDate: 'Rules on {date}',
    fleetCalendarNoRulesOnDate: 'No rules apply on this date.',
    fleetCalendarAddForDate: 'Add rule for this date',
    fleetCalendarFilterService: 'Filter by service',
    fleetCalendarAllServices: 'All services',
    addFirstFleetPeriodRule: 'Add your first seasonal cap',
    addFirstFleetServiceRule: 'Add your first service rule',
    serviceTabBasics: 'Basics',
    serviceTabCapacity: 'Capacity & pricing',
    serviceTabProduct: 'Product',
    serviceCapacityExperienceOnly: 'Capacity and fleet settings apply to experience (trip) services.',
    settingsSaveFailed: 'Could not save booking settings',
    runSetupWizard: 'Run setup wizard',
    setupWizardTitle: 'Booking setup',
    setupWizardSubtitle: 'Add your first service, staff, hours, and website booking code.',
    setupStepService: 'Service',
    setupStepStaff: 'Staff',
    setupStepHours: 'Hours',
    setupStepEmbed: 'Website',
    setupStepServiceHint: 'Create the first bookable service customers can choose.',
    setupStepStaffHint: 'Add a provider who performs this service.',
    setupStepHoursHint: 'Set when customers can book online.',
    setupStepEmbedHint: 'Turn on website booking and copy the full code block into your site.',
    setupSoloProvider: 'I am the only provider',
    setupBack: 'Back',
    setupContinue: 'Continue',
    setupFinish: 'Finish',
    setupComplete: 'Booking setup complete',
    setupSaveFailed: 'Setup could not be saved',
    setupStaffMissing: 'Add a staff member before setting hours.',
    days: {
      sun: 'Sunday',
      mon: 'Monday',
      tue: 'Tuesday',
      wed: 'Wednesday',
      thu: 'Thursday',
      fri: 'Friday',
      sat: 'Saturday'
    }
  },
  projects: {
    title: 'Projects',
    subtitle: 'Track job profitability with invoices and expenses',
    listTitle: 'All projects',
    emptyList: 'No projects match your filters. Create a project or adjust search.',
    refreshList: 'Refresh list',
    backToProjects: 'Back to projects',
    detailSubtitle: 'Linked invoices, expenses, and job profitability.',
    formSubtitle: 'Customer, schedule, budget, and notes for this job.',
    projectDetails: 'Project details',
    financialSummary: 'Financial summary',
    invoicesTabHint: 'Link existing invoices or create a new one for this project.',
    invoicesEmpty: 'No invoices linked yet. Link invoices or create one from here.',
    deleteExpenseTitle: 'Delete expense?',
    newProject: 'New Project',
    editProject: 'Edit Project',
    search: 'Search projects',
    number: 'Number',
    name: 'Name',
    customer: 'Customer',
    customerOrCompany: 'Customer or company',
    status: 'Status',
    budget: 'Budget',
    startDate: 'Start date',
    endDate: 'End date',
    description: 'Description',
    internalNotes: 'Internal notes',
    nameRequired: 'Project name is required',
    statusDraft: 'Draft',
    statusActive: 'Active',
    statusOnHold: 'On hold',
    statusCompleted: 'Completed',
    statusCancelled: 'Cancelled',
    tabOverview: 'Overview',
    tabInvoices: 'Invoices',
    tabExpenses: 'Expenses',
    revenueBilled: 'Revenue billed',
    revenueCollected: 'Collected',
    outstanding: 'Outstanding',
    expensesTotal: 'Expenses',
    margin: 'Margin',
    linkInvoices: 'Link invoices',
    linkInvoicesSubtitle: 'Select invoices that belong to this project.',
    linkSelected: 'Link selected',
    searchInvoices: 'Search unlinked invoices',
    createInvoice: 'Create invoice',
    snapReceipt: 'Snap receipt',
    choosePhoto: 'Choose photo',
    chooseReceipt: 'Choose photo or PDF',
    receiptPdfAttached: 'PDF receipt attached',
    receiptFileTypeInvalid: 'Please choose a photo (JPEG, PNG, WebP) or PDF.',
    enterManually: 'Enter manually',
    addExpense: 'Add expense',
    addExpenseSubtitle: 'Snap or upload a receipt, or enter details manually.',
    newExpense: 'New expense',
    newExpenseSubtitle: 'Review the details and save when ready.',
    editExpenseSubtitle: 'Update amount, date, or replace the receipt.',
    expensesTabHint: 'Track job costs with receipts or manual entries.',
    expensesEmpty: 'No expenses yet. Add a receipt or enter one manually.',
    saveExpense: 'Save expense',
    editExpense: 'Edit expense',
    replaceReceipt: 'Replace receipt',
    deleteExpenseConfirm: 'Delete this expense? This cannot be undone.',
    vendor: 'Vendor',
    amount: 'Amount',
    expenseDate: 'Expense date',
    category: 'Category',
    notes: 'Notes',
    amountRequired: 'Amount is required',
    ocrPending: 'Reading receipt…',
    ocrFailed: 'Could not read receipt automatically. Enter details manually.'
  },
  nav: {
    dashboard: 'Dashboard',
    salesRegister: 'Sales Register',
    sales: 'Sales',
    customers: 'Customers',
    leads: 'Leads',
    invoices: 'Invoices',
    projects: 'Projects',
    tabs: 'Tabs',
    rentals: 'Rentals',
    events: 'Events',
    scheduling: 'Scheduling',
    booking: 'Booking',
    products: 'Products',
    registers: 'Registers',
    reports: 'Reports',
    settings: 'Settings',
    dejavoo: 'Dejavoo PoC'
  },
  stripeConnect: {
    hubTitle: 'Stripe payments',
    hubDesc: 'Onboard, order hardware, and accept card payments',
    title: 'Stripe payment setup',
    subtitle: 'Complete onboarding to accept online and in-person payments.',
    ready: 'Ready to accept payments',
    notReady: 'Setup required',
    accountId: 'Connected account',
    createAccount: 'Start Stripe setup',
    continueOnboarding: 'Continue setup',
    accountCreated: 'Stripe account created',
    createFailed: 'Could not create Stripe account',
    sessionFailed: 'Could not start onboarding session',
    statusFailed: 'Could not load Stripe status',
    testMode: 'Test mode',
    tabOnboarding: 'Account setup',
    tabHardware: 'Order hardware',
    tabReaders: 'Readers & Tap to Pay',
    hardwareDesc: 'Order Stripe Terminal readers and accessories shipped to your business.',
    hardwareHeroTitle: 'Get card readers for your store',
    hardwareHeroSubtitle: 'Order official Stripe Terminal hardware shipped to your location, then register readers in Blu when they arrive.',
    hardwareStepLabel: 'Step {n}',
    hardwareStepOrder: 'Choose hardware',
    hardwareStepOrderDesc: 'Pick a reader that fits your counter—Stripe ships directly to you with secure checkout below.',
    hardwareStepShip: 'Track delivery',
    hardwareStepShipDesc: 'Stripe emails tracking updates. Expand order history anytime to see status.',
    hardwareStepRegister: 'Register in Blu',
    hardwareStepRegisterDesc: 'Enter the pairing code from the reader label so checkout can use it at this location.',
    hardwareShopTitle: 'Stripe hardware shop',
    hardwareShopLoading: 'Loading shop…',
    hardwareOrdersTitle: 'Order history & tracking',
    hardwareOrdersDesc: 'View past hardware orders and delivery status from Stripe.',
    hardwareOrderPlacedTitle: 'Order placed—nice work!',
    hardwareOrderPlacedBody: 'When your reader arrives, open Readers & Tap to Pay and enter the pairing code from the device label.',
    hardwareOrderPlacedCta: 'Register a reader',
    hardwareOrderPlacedDismiss: 'Continue shopping',
    hardwareAfterOrderHint: 'After Stripe ships your reader, register it with the pairing code from the device label.',
    openReadersTab: 'Readers & Tap to Pay',
    registrationCodeHint: 'Printed on the reader label or from your Stripe order confirmation.',
    currentLocation: 'Location: {name}',
    readersEmptyTitle: 'No readers at this location yet',
    readersEmptyHint: 'Register a reader with its pairing code, or sync from Stripe after registering in the Stripe Dashboard.',
    androidTapToPayTitle: 'Tap to Pay on this phone (Android)',
    androidTapToPayHint: 'Use the Blu Android app on an NFC phone at checkout. Allow location when prompted. No separate reader is required when Tap to Pay readiness is green above.',
    tapToPayLocationDenied: 'Location permission is required for Stripe Tap to Pay. Enable location for Blu in system settings and try again.',
    tapToPayUnavailable: 'Tap to Pay is not available on this device.',
    missingPublishableKey: 'Stripe is not configured on the server (missing publishable key).',
    registerReaderTitle: 'Register a reader you already have',
    registerReaderHint: 'Enter the pairing code from the reader label, then assign the reader to a register in Equipment settings.',
    registrationCode: 'Registration code',
    readerLabel: 'Reader label (optional)',
    registerReader: 'Register reader',
    readerRegistered: 'Stripe reader registered for this location',
    readerRegisterFailed: 'Could not register reader',
    selectLocation: 'Select a location in the POS before registering a reader.',
    readinessTitle: 'Payment readiness',
    readinessLead: 'Green chips mean that track is ready for checkout. Fix errors before taking card-present or Tap to Pay payments.',
    readinessAllClear: 'All Stripe payment tracks are ready.',
    readinessIncomplete: 'Complete the items below before going live.',
    scenarioCardPresent: 'Card present (readers)',
    scenarioTapOnPhone: 'Tap to Pay (phone)',
    scenarioCnp: 'Keyed / online (CNP)',
    readersAtLocation: 'Readers at this location',
    syncReaders: 'Sync from Stripe',
    readersSynced: 'Stripe readers synced for this location',
    syncReadersFailed: 'Could not sync Stripe readers',
    colReaderLabel: 'Label',
    colReaderId: 'Stripe reader ID',
    colReaderStatus: 'Status'
  },
  iphoneTopSetup: {
    title: 'Tap to Pay on iPhone',
    subtitle: 'Set up this iPhone to accept contactless payments with Apple Tap to Pay and Dejavoo.',
    continue: 'Continue',
    iosOnly: 'Open Blu on a physical iPhone to run this setup.',
    notConfigured: 'Tap to Pay on iPhone is not configured for this business yet. Contact Blu support if you expected it to be ready.',
    noIphoneTpn: 'No Apple Tap to Pay terminal is provisioned for this business. Blu staff enable this in Admin when onboarding your iPhone TPN.',
    terminalLabel: 'Terminal: {label}',
    locationDenied: 'Location permission is required for Tap to Pay on iPhone.',
    deviceIpadUnsupported: 'Tap to Pay on iPhone is only available on iPhone. Open Blu on a compatible iPhone to accept contactless payments.',
    deviceModelUnsupported: 'This iPhone does not support Tap to Pay on iPhone. Use iPhone Xs or later.',
    osVersionNotSupported: 'Update this iPhone to iOS 17.6 or later to use Tap to Pay on iPhone.',
    registerSuccess: 'This iPhone is registered for Tap to Pay.',
    bluLinkSuccess: 'This iPhone is linked to your Blu account.',
    testSaleApproved: 'Test payment approved.',
    testSaleDeclined: 'Test payment was not approved.',
    testSaleFailed: 'Test payment could not be completed.',
    promoTitle: 'Tap to Pay on iPhone',
    promoBody: 'Accept contactless payments on this iPhone—no extra hardware. Complete one-time setup to enable checkout on the register.',
    promoCta: 'Set up Tap to Pay on iPhone',
    configuringTitle: 'Configuring Tap to Pay on iPhone',
    configuringSubtitle: 'This iPhone is not ready for payments yet. Keep the app open until setup finishes.',
    checkoutBlocked: 'Complete Tap to Pay on iPhone setup before taking a payment.',
    checkoutDialogTitle: 'Set up Tap to Pay on iPhone',
    checkoutDialogMessage: 'This iPhone still needs a one-time setup (Apple terms and Dejavoo registration). It only takes a few minutes.',
    checkoutDialogCta: 'Start setup',
    adminRequiredTitle: 'Manager or owner required',
    adminRequiredBody: 'Only a store owner or manager can accept Apple Tap to Pay terms and register this iPhone. Ask them to open Settings → Tap to Pay on iPhone, or sign in with an authorized account.',
    steps: {
      welcome: {
        title: 'Welcome',
        body: 'You will register this iPhone as a secure Tap to Pay terminal. Blu already provisioned your merchant TPN—no codes to enter here.',
        bulletUsRegion: 'Device region set to United States',
        bulletDevice: 'iPhone Xs or later with iOS 17.6+',
        bulletSandboxAppleId: 'Sandbox Apple ID signed in on this iPhone (UAT / test builds)',
        bulletProvisioned: 'Blu Admin completed Apple Tap to Pay merchant setup'
      },
      permissions: {
        title: 'Location',
        body: 'Blu uses your location during payment processing to meet card network requirements.',
        cta: 'Allow location'
      },
      register: {
        title: 'Register this iPhone',
        body: 'Tap below to download terminal parameters and prepare Apple Tap to Pay on this device.',
        appleTermsHint: 'Apple may show Tap to Pay terms during this step—review and accept to continue.',
        cta: 'Register with Dejavoo',
        acceptTermsCta: 'Accept terms and register'
      },
      bluLink: {
        title: 'Link to Blu',
        body: 'Connect this iPhone to your Blu mobile terminal record so sales and reporting stay in sync.',
        cta: 'Link this iPhone'
      },
      done: {
        title: 'You are ready',
        body: 'Take Tap to Pay card payments on the sales register or try your first contactless payment now.',
        tryItCta: 'Try Tap to Pay on iPhone',
        testSale: 'Test $0.01 sale',
        registers: 'Open sales register',
        backToPayments: 'Back to Dejavoo settings'
      }
    }
  },
  iphoneTopMarketing: {
    title: 'Tap to Pay on iPhone',
    bulletContactless: 'Accept contactless credit and debit cards right on your iPhone.',
    bulletNoHardware: 'No extra card reader—customers tap their card or phone on yours.',
    bulletFastCheckout: 'Speed up checkout on the Blu sales register.',
    ctaSetup: 'Set up Tap to Pay on iPhone',
    ctaLater: 'Not now'
  },
  dejavooPoc: {
    resultDialogTitle: 'Dejavoo Callback Result',
    requestId: 'Request ID',
    status: 'Status',
    rawUrl: 'Raw URL',
    payload: 'Payload',
    copied: 'Copied',
    iphoneTopTitle: 'Tap to Pay on iPhone (In-App SDK)',
    iphoneTopHint: 'UAT: device region US, sandbox Apple ID, Info.plist Environment UAT. NFC requires a physical iPhone.',
    iphoneLoadConfig: 'Load backend ToP config',
    iphoneIsAvailable: 'Check plugin availability',
    iphoneWarmSession: 'Register / warm session',
    iphoneTestSale: 'Test sale (SDK only)',
    iphoneClearSession: 'Clear SDK session',
    iphoneLastResult: 'Last iPhone ToP result',
    iphoneConfigIncomplete: 'Tap to Pay config is disabled or missing TPN / merchant code.',
    iphoneSaleAmountPrompt: 'Sale amount (USD)',
    iphoneInvalidAmount: 'Enter a valid amount greater than zero.'
  },
  rentals: {
    title: 'Rentals',
    subtitle: 'Manage storage units, agreements, and billing',
    mapView: 'Map',
    listView: 'List',
    location: 'Location',
    building: 'Building',
    unit: 'Unit',
    status: 'Status',
    customer: 'Customer',
    rate: 'Rate',
    billingTerm: 'Billing term',
    balance: 'Balance',
    nextDue: 'Next due',
    actions: 'Actions',
    apply: 'Apply',
    clear: 'Clear',
    allLocations: 'All locations',
    allBuildings: 'All buildings',
    allStatuses: 'All statuses',
    pastDueOnly: 'Past due only',
    unitsList: 'Units',
    exportCsv: 'Export CSV',
    exportFailed: 'Failed to export',
    settings: 'Settings',
    newAgreement: 'New agreement',
    editLayout: 'Edit layout',
    noBuildings: 'No buildings configured for this location.',
    emptySlot: 'Empty',
    statusVacant: 'Vacant',
    statusOccupied: 'Occupied',
    statusPastDue: 'Past due',
    statusMaintenance: 'Maintenance',
    statusReserved: 'Reserved',
    viewAgreement: 'View agreement',
    back: 'Back',
    unitDetailTitle: 'Unit {unit}',
    agreementDetailTitle: 'Rental agreement',
    agreementOverview: 'Agreement details',
    agreementStatusPending: 'Pending',
    agreementStatusActive: 'Active',
    agreementStatusEnded: 'Ended',
    endAgreementConfirm: 'End this rental agreement? The unit will become vacant and recurring billing will stop.',
    recurringBilling: 'Recurring billing',
    recurringBillingNote: 'Ending this agreement also ends the recurring schedule.',
    noInvoicesYet: 'No invoices yet',
    currentAgreement: 'Current agreement',
    size: 'Size',
    notes: 'Notes',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    annual: 'Annual',
    startDate: 'Start date',
    endDate: 'End date',
    activate: 'Activate',
    endAgreement: 'End agreement',
    generateInvoice: 'Generate invoice',
    invoiceHistory: 'Invoice history',
    invoiceNumber: 'Invoice #',
    issueDate: 'Issue date',
    total: 'Total',
    agreementActivated: 'Agreement activated',
    agreementEnded: 'Agreement ended',
    invoiceGenerated: 'Invoice generated',
    actionFailed: 'Action failed',
    settingsTitle: 'Rental settings',
    settingsSubtitle: 'Policies, buildings, and units',
    policies: 'Policies',
    newPolicy: 'New policy',
    editPolicy: 'Edit policy',
    defaultPolicy: 'Default policy',
    policyName: 'Policy name',
    gracePeriodDays: 'Grace period (days)',
    autoEmailInvoices: 'Auto-email invoices',
    depositRequired: 'Deposit required',
    defaultDeposit: 'Default deposit',
    defaultMonthlyRate: 'Default monthly rate',
    defaultRateLabel: '{rate}/mo',
    ratePlan: 'Rate plan',
    policyRateNotConfigured: 'This rate plan has no default monthly rate configured.',
    buildings: 'Buildings',
    newBuilding: 'New building',
    editBuilding: 'Edit building',
    buildingName: 'Building name',
    sortOrder: 'Sort order',
    unitCount: '{count} units',
    addUnit: 'Add unit',
    unitNumber: 'Unit number',
    cancel: 'Cancel',
    save: 'Save',
    create: 'Create',
    policySaved: 'Policy saved',
    buildingSaved: 'Building saved',
    unitSaved: 'Unit saved',
    saveFailed: 'Save failed',
    editLayoutTitle: 'Layout — {name}',
    gridSize: 'Grid size',
    rows: 'Rows',
    cols: 'Columns',
    unplacedUnits: 'Unplaced units',
    allUnitsPlaced: 'All units placed',
    layoutPreview: 'Layout preview',
    saveLayout: 'Save layout',
    layoutSaved: 'Layout saved',
    layoutSaveFailed: 'Failed to save layout',
    dropHere: 'Drop here',
    layoutDragHint: 'Drag units onto the grid or between cells',
    clickSlotToPlace: 'Click an empty slot to place the selected unit',
    missingRequiredFields: 'Unit and customer are required',
    agreementCreated: 'Agreement created',
    agreementCreateFailed: 'Failed to create agreement',
    editUnit: 'Edit unit',
    deleteUnit: 'Delete unit',
    deleteUnitConfirm: 'Delete unit {unit}?',
    unitDeleted: 'Unit deleted',
    unitLabel: 'Display label',
    operationalStatus: 'Operational status',
    opStatusAvailable: 'Available',
    generateUnits: 'Generate units',
    unitPrefix: 'Prefix',
    startNumber: 'Start number',
    unitCountField: 'Count',
    zeroPad: 'Zero pad width',
    generate: 'Generate',
    bulkGenerateResult: 'Created {created} units ({skipped} skipped)',
    noUnitsInBuilding: 'No units in this building yet.',
    unplacedUnitsMap: 'Unplaced units',
    registerRentUnit: 'Rent unit',
    unitNotAvailableForRent: 'This unit is not available to rent',
    startRecurringInvoices: 'Start recurring invoices for future periods',
    addToRegister: 'Add to register',
    issueInvoiceAndPay: 'Create agreement & pay invoices',
    agreementActivatedPayInvoices: 'Rental agreement created. Collect payment for the open invoice(s).',
    registerCheckoutTotal: 'Checkout total: {total}',
    registerCheckoutFailed: 'Failed to prepare rental checkout',
    rentAtRegister: 'Rent at register',
    viewInvoices: 'View invoices',
    sendPortalLink: 'Send portal link',
    portalLinkTitle: 'Send portal link',
    portalLinkSubtitle: 'Email or text the customer a secure link to view and pay rental invoices',
    portalLinkEmailSection: 'Email link',
    portalLinkSmsSection: 'Text link',
    portalLinkTo: 'Recipient email',
    portalLinkPhone: 'Recipient phone',
    portalLinkPhoneUsOnly: 'SMS can only be sent to US phone numbers',
    portalLinkSubjectOptional: 'Subject (optional)',
    portalLinkMessageOptional: 'Message (optional)',
    portalLinkSendEmail: 'Send email',
    portalLinkSendText: 'Send text',
    portalLinkSend: 'Send link',
    portalLinkDefaultSubject: 'Your rental portal — Unit {unit}',
    portalLinkEmailSent: 'Portal link emailed',
    portalLinkSmsSent: 'Portal link texted',
    portalLinkSmsFailed: 'Failed to send portal link text',
    portalLinkSent: 'Portal link sent',
    portalLinkFailed: 'Failed to send portal link',
    allowedFrequencies: 'Allowed billing frequencies',
    defaultTerms: 'Default invoice terms'
  },
  storeBuilder: {
    title: 'Store homepage builder',
    titleProductTemplate: 'Product page template',
    subtitle: 'Visual editor with live preview',
    openVisualEditor: 'Visual editor',
    openProductTemplate: 'Product template',
    pageSwitcher: {
      home: 'Homepage',
      product: 'Product template',
    },
    contentPages: {
      manage: 'Content pages',
      title: 'Content pages',
      subtitle: 'Static pages (About, Contact, etc.) use the same sections as your homepage.',
      create: 'New page',
      createTitle: 'Create content page',
      pageTitle: 'Page title',
      pageSlug: 'URL slug',
      pageSlugHint: 'Used in the page link you share with customers (lowercase letters, numbers, hyphens)',
      edit: 'Edit',
      duplicate: 'Duplicate',
      empty: 'No content pages yet.',
      createFailed: 'Could not create page.',
      duplicated: 'Page duplicated.',
      duplicateFailed: 'Could not duplicate page.',
      deleteTitle: 'Delete page',
      deleteConfirm: 'Delete “{title}”? This cannot be undone until you publish again.',
      deleted: 'Page deleted.',
      deleteFailed: 'Could not delete page.',
      editTitle: 'Edit: {title}',
    },
    undo: 'Undo',
    redo: 'Redo',
    publish: 'Publish',
    publishSuccess: 'Store published — shoppers will see this version.',
    publishFailed: 'Publish failed. Save your draft and try again.',
    storeDisabledBanner: 'Enable Blu Store in settings to edit and save the homepage.',
    previewFrameTitle: 'Store preview',
    previewLoading: 'Loading preview…',
    previewLoadFailed: 'Could not load the store draft from the server.',
    viewportDesktop: 'Desktop',
    viewportMobile: 'Mobile',
    savedNotify: 'Draft saved',
    savedLocalNotify: 'Draft saved on this device only — reconnect to sync with the server.',
    savedLocalFallback: 'Could not reach the server — draft saved in this browser only.',
    savedGlobalsFailed: 'Draft saved, but site style and theme did not sync. Reload the builder and save again.',
    saveStatus: {
      idle: 'All changes saved',
      unsaved: 'Unsaved changes',
      saving: 'Saving…',
      saved: 'Saved',
      savedLocal: 'Saved locally',
      error: 'Save failed',
    },
    inspector: {
      section: 'Section',
      siteStyle: 'Site style',
      chrome: 'Header & footer',
      selectSection: 'Select a section in the list or preview.',
    },
    sectionGallery: {
      title: 'Add section',
      hint: 'Choose a block to add to the page.',
    },
    chrome: {
      title: 'Store chrome',
      hint: 'Navigation and footer links shown on every storefront page.',
      announcementEnabled: 'Show announcement bar',
      announcementText: 'Announcement text',
      announcementLinkLabel: 'Optional link label',
      announcementStyle: 'Bar colors',
      announcementStyleTheme: 'Use theme primary',
      announcementStyleCustom: 'Custom colors',
      announcementBg: 'Bar background',
      announcementTextColor: 'Bar text color',
      announcementMarquee: 'Scrolling text (marquee)',
      announcementDismissible: 'Allow shoppers to dismiss',
      navLinks: 'Header navigation',
      socialLinks: 'Social links',
      addSocialLink: 'Add social link',
      socialIconPreset: 'Icon preset',
      socialIconUrl: 'Custom icon URL (HTTPS)',
      socialIconUrlHint: 'PNG or SVG URL; overrides preset when set.',
      socialIconNone: 'None',
      socialIconInstagram: 'Instagram',
      socialIconFacebook: 'Facebook',
      socialIconTiktok: 'TikTok',
      socialIconPinterest: 'Pinterest',
      socialIconYoutube: 'YouTube',
      socialIconX: 'X (Twitter)',
      policyLinks: 'Policy links (footer)',
      footerWave: 'Curved wave above footer',
      footerColumns: 'Footer columns',
      footerColumn: 'Column {n}',
      columnTitle: 'Column title',
      linkLabel: 'Label',
      linkHref: 'URL or path',
      addLink: 'Add link',
      addColumn: 'Add column',
      removeColumn: 'Remove column',
    },
    restore: {
      open: 'Restore',
      title: 'Restore a published version',
      hint: 'Loads that release into your drafts. Shoppers keep the current live site until you publish again.',
      releaseLabel: 'Release #{id}',
      empty: 'No published releases yet.',
      success: 'Draft restored from release.',
      failed: 'Restore failed.',
    },
    sectionList: {
      title: 'Sections',
      moveUp: 'Move section up',
      moveDown: 'Move section down',
      duplicate: 'Duplicate section',
      remove: 'Remove section',
    },
    section: {
      heroLayout: 'Hero layout',
      heroLayoutSplit: 'Split (image + text)',
      heroLayoutStack: 'Stacked',
      heroImageHint: 'Upload a photo or paste an HTTPS URL for split/stack layouts.',
      imageUpload: 'Upload image',
      imageUploadHint: 'JPEG, PNG, or WebP from your device.',
      imageUploadFailed: 'Could not upload that image. Try again or use a smaller file.',
      imageRemove: 'Remove image',
      heroCta: 'Call-to-action button',
      heroCtaLabel: 'Button label',
      heroCtaLink: 'Button link',
      heroCtaLinkHint: 'Store path (e.g. /) or full https:// URL.',
      focalPoint: 'Image focal point',
      focalCenter: 'Center',
      focalTop: 'Top',
      focalBottom: 'Bottom',
      focalLeft: 'Left',
      focalRight: 'Right',
      productDetailsLocked: 'Required on every product page. You can adjust display options only.',
      productDetailsShowTitle: 'Show product title',
    },
    siteStyle: {
      title: 'Site style',
      hint: 'Global design tokens applied with your theme preset.',
      primaryColor: 'Primary color',
      accentColor: 'Accent color',
      backgroundColor: 'Background color',
      headerColor: 'Header background',
      textColor: 'Text color',
      accentColorHint: 'Secondary highlights on the live store (not the builder selection frame).',
      fontPair: 'Font pair',
      fontInter: 'Inter — clean modern (general retail)',
      fontOutfit: 'Outfit — geometric contemporary',
      fontNunitoSans: 'Nunito Sans — soft & friendly',
      fontRubik: 'Rubik — rounded approachable',
      fontMonoAccent: 'Space Grotesk + IBM Plex — tech & makers',
      fontBarlow: 'Barlow Condensed + Barlow — bold industrial',
      fontOswaldOpenSans: 'Oswald + Open Sans — athletic & outdoor',
      fontPlayfairSource: 'Playfair + Source Sans — boutique editorial',
      fontCormorantMontserrat: 'Cormorant + Montserrat — luxury fashion',
      fontDmSerifDmSans: 'DM Serif + DM Sans — elegant minimal',
      fontJosefinLato: 'Josefin + Lato — beauty & wellness',
      fontSerifModern: 'Libre Baskerville + Inter — classic readable',
      fontLoraInter: 'Lora + Inter — artisan & craft',
      fontMerriweatherLato: 'Merriweather + Lato — café & hospitality',
      fontCrimsonInter: 'Crimson Pro + Inter — literary & gifts',
      fontEbGaramondInter: 'EB Garamond + Inter — traditional formal',
      fontPtSerifInter: 'PT Serif + Inter — news & publishing',
      fontFrauncesWorkSans: 'Fraunces + Work Sans — specialty food',
      buttonShape: 'Button shape',
      buttonSquare: 'Square',
      buttonRounded: 'Rounded',
      buttonPill: 'Pill',
      buttonVariant: 'Button style',
      buttonVariantSolid: 'Solid fill',
      buttonVariantOutline: 'Outline',
      buttonVariantFlat: 'Flat tint',
      buttonVariantElevated: 'Elevated',
      buttonVariantGloss: 'Gloss',
      buttonLabelColor: 'Button text',
      buttonLabelAuto: 'Auto (black or white)',
      buttonLabelLight: 'Light',
      buttonLabelDark: 'Dark',
      cornerTreatment: 'Corners',
      cornerSharp: 'Sharp',
      cornerSoft: 'Soft',
      spacingDensity: 'Spacing',
      spacingCompact: 'Compact',
      spacingComfortable: 'Comfortable',
      spacingSpacious: 'Spacious',
      contentWidth: 'Content width',
      widthNarrow: 'Narrow',
      widthStandard: 'Standard',
      widthWide: 'Wide',
      colorDefault: 'Theme default',
      colorInk: 'Ink',
      colorNavy: 'Navy',
      colorBlue: 'Blue',
      colorTeal: 'Teal',
      colorGreen: 'Green',
      colorAmber: 'Amber',
      colorRose: 'Rose',
      colorWhite: 'White',
      colorCloud: 'Cloud',
      colorSand: 'Sand',
      customColor: 'Custom color',
      hexValue: 'Hex',
      enableScrollReveal: 'Animate sections on scroll',
      enableScrollRevealHint: 'Subtle fade-in on homepage and product template sections. Disabled in builder preview.',
      enableAddToCartFly: 'Fly to cart animation',
      enableAddToCartFlyHint: 'Product image arcs into the cart icon when shoppers add items (PDP and quick add). Respects reduced motion.',
    },
  },
  richText: {
    link: 'Link',
    linkTip: 'Insert hyperlink'
  }
}
